"Linux x86_64" != navigator.platform &&
  (function (e) {
    "function" == typeof define && define.amd ? define("index", e) : e();
  })(function () {
    "use strict";
    function wi(e) {
      return (wi =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function a(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function r(e, t, i) {
      return t && n(e.prototype, t), i && n(e, i), e;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && l(e, t);
    }
    function s(e) {
      return (s = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function l(e, t) {
      return (l =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function c() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function d(e, t, i) {
      return (d = c()
        ? Reflect.construct
        : function (e, t, i) {
            var n = [null];
            n.push.apply(n, t);
            n = new (Function.bind.apply(e, n))();
            return i && l(n, i.prototype), n;
          }).apply(null, arguments);
    }
    function u(e) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return (u = function (e) {
        if (
          null === e ||
          ((t = e), -1 === Function.toString.call(t).indexOf("[native code]"))
        )
          return e;
        var t;
        if ("function" != typeof e)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (void 0 !== n) {
          if (n.has(e)) return n.get(e);
          n.set(e, i);
        }
        function i() {
          return d(e, arguments, s(this).constructor);
        }
        return (
          (i.prototype = Object.create(e.prototype, {
            constructor: {
              value: i,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          l(i, e)
        );
      })(e);
    }
    function h(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function p(i) {
      var n = c();
      return function () {
        var e,
          t = s(i);
        return (
          (e = n
            ? ((e = s(this).constructor), Reflect.construct(t, arguments, e))
            : t.apply(this, arguments)),
          (t = this),
          !(e = e) || ("object" != typeof e && "function" != typeof e)
            ? h(t)
            : e
        );
      };
    }
    function m(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) return g(e);
        })(e) ||
        (function (e) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
            return Array.from(e);
        })(e) ||
        f(e) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function f(e, t) {
      if (e) {
        if ("string" == typeof e) return g(e, t);
        var i = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === i && e.constructor && (i = e.constructor.name),
          "Map" === i || "Set" === i
            ? Array.from(e)
            : "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            ? g(e, t)
            : void 0
        );
      }
    }
    function g(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];
      return n;
    }
    var v = {},
      y = (function () {
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "slideUp",
              value: function (i, n) {
                var e =
                  2 < arguments.length && void 0 !== arguments[2]
                    ? arguments[2]
                    : "height";
                (i.style[e] = "".concat(i.scrollHeight, "px")),
                  i.offsetHeight,
                  (i.style[e] = 0),
                  v[i.id] &&
                    (i.removeEventListener("transitionend", v[i.id]),
                    delete v[i.id]);
                e = function e(t) {
                  "height" === t.propertyName &&
                    (i.removeEventListener("transitionend", e),
                    (n || function () {})());
                };
                i.addEventListener("transitionend", e);
              },
            },
            {
              key: "slideDown",
              value: function (t, i) {
                var n =
                  2 < arguments.length && void 0 !== arguments[2]
                    ? arguments[2]
                    : "height";
                t.style[n] = "".concat(t.scrollHeight, "px");
                function o(e) {
                  e.propertyName === n &&
                    ((e = "max-height" === n ? "none" : "auto"),
                    (t.style[n] = e),
                    t.removeEventListener("transitionend", o),
                    delete v[t.id],
                    (i || function () {})());
                }
                t.addEventListener("transitionend", o), (v[t.id] = o);
              },
            },
          ]),
          e
        );
      })(),
      b = (function () {
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "getSiblings",
              value: function (e, t) {
                for (
                  var i =
                      2 < arguments.length &&
                      void 0 !== arguments[2] &&
                      arguments[2],
                    n = [],
                    o = e;
                  (o = o.previousElementSibling);

                )
                  (t && !o.matches(t)) || n.push(o);
                for (i && n.push(e), o = e; (o = o.nextElementSibling); )
                  (t && !o.matches(t)) || n.push(o);
                return n;
              },
            },
          ]),
          e
        );
      })(),
      w =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : {};
    function e(e) {
      return e &&
        e.__esModule &&
        Object.prototype.hasOwnProperty.call(e, "default")
        ? e.default
        : e;
    }
    function t(e, t, i) {
      return (
        e(
          (i = {
            path: t,
            exports: {},
            require: function (e, t) {
              return (function () {
                throw new Error(
                  "Dynamic requires are not currently supported by @rollup/plugin-commonjs"
                );
              })(null == t && i.path);
            },
          }),
          i.exports
        ),
        i.exports
      );
    }
    var _ = e(
        t(function (e, t) {
          function i(e) {
            (this.listenerMap = [{}, {}]),
              e && this.root(e),
              (this.handle = i.prototype.handle.bind(this)),
              (this._removedListeners = []);
          }
          function r(e, t) {
            return e.toLowerCase() === t.tagName.toLowerCase();
          }
          function l(e, t) {
            return e === t.id;
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.default = void 0),
            (i.prototype.root = function (e) {
              var t,
                i = this.listenerMap;
              if (this.rootElement) {
                for (t in i[1])
                  i[1].hasOwnProperty(t) &&
                    this.rootElement.removeEventListener(t, this.handle, !0);
                for (t in i[0])
                  i[0].hasOwnProperty(t) &&
                    this.rootElement.removeEventListener(t, this.handle, !1);
              }
              if (!e || !e.addEventListener)
                return this.rootElement && delete this.rootElement, this;
              for (t in ((this.rootElement = e), i[1]))
                i[1].hasOwnProperty(t) &&
                  this.rootElement.addEventListener(t, this.handle, !0);
              for (t in i[0])
                i[0].hasOwnProperty(t) &&
                  this.rootElement.addEventListener(t, this.handle, !1);
              return this;
            }),
            (i.prototype.captureForType = function (e) {
              return (
                -1 !==
                ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
                  e
                )
              );
            }),
            (i.prototype.on = function (e, t, i, n) {
              var o, s, a;
              if (!e) throw new TypeError("Invalid event type: " + e);
              if (
                ("function" == typeof t && ((n = i), (i = t), (t = null)),
                void 0 === n && (n = this.captureForType(e)),
                "function" != typeof i)
              )
                throw new TypeError("Handler must be a type of Function");
              return (
                (o = this.rootElement),
                (s = this.listenerMap[n ? 1 : 0])[e] ||
                  (o && o.addEventListener(e, this.handle, n), (s[e] = [])),
                (n = t
                  ? /^[a-z]+$/i.test(t)
                    ? ((a = t), r)
                    : /^#[a-z0-9\-_]+$/i.test(t)
                    ? ((a = t.slice(1)), l)
                    : ((a = t), Element.prototype.matches)
                  : ((a = null),
                    function (e, t) {
                      return this.rootElement !== window
                        ? this.rootElement === t
                        : t === document ||
                            t === document.documentElement ||
                            t === window;
                    }.bind(this))),
                s[e].push({
                  selector: t,
                  handler: i,
                  matcher: n,
                  matcherParam: a,
                }),
                this
              );
            }),
            (i.prototype.off = function (e, t, i, n) {
              var o, s, a, r, l;
              if (
                ("function" == typeof t && ((n = i), (i = t), (t = null)),
                void 0 === n)
              )
                return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
              if (((a = this.listenerMap[n ? 1 : 0]), !e)) {
                for (l in a) a.hasOwnProperty(l) && this.off(l, t, i);
                return this;
              }
              if (!(r = a[e]) || !r.length) return this;
              for (o = r.length - 1; 0 <= o; o--)
                (s = r[o]),
                  (t && t !== s.selector) ||
                    (i && i !== s.handler) ||
                    (this._removedListeners.push(s), r.splice(o, 1));
              return (
                r.length ||
                  (delete a[e],
                  this.rootElement &&
                    this.rootElement.removeEventListener(e, this.handle, n)),
                this
              );
            }),
            (i.prototype.handle = function (e) {
              var t,
                i,
                n,
                o,
                s = e.type,
                a = [],
                r = "ftLabsDelegateIgnore";
              if (!0 !== e[r]) {
                switch (
                  (3 === (o = e.target).nodeType && (o = o.parentNode),
                  o.correspondingUseElement && (o = o.correspondingUseElement),
                  (i = this.rootElement),
                  e.eventPhase || (e.target !== e.currentTarget ? 3 : 2))
                ) {
                  case 1:
                    a = this.listenerMap[1][s];
                    break;
                  case 2:
                    this.listenerMap[0] &&
                      this.listenerMap[0][s] &&
                      (a = a.concat(this.listenerMap[0][s])),
                      this.listenerMap[1] &&
                        this.listenerMap[1][s] &&
                        (a = a.concat(this.listenerMap[1][s]));
                    break;
                  case 3:
                    a = this.listenerMap[0][s];
                }
                for (var l, c = [], d = a.length; o && d; ) {
                  for (t = 0; t < d && (n = a[t]); t++)
                    o.tagName &&
                    -1 <
                      ["button", "input", "select", "textarea"].indexOf(
                        o.tagName.toLowerCase()
                      ) &&
                    o.hasAttribute("disabled")
                      ? (c = [])
                      : n.matcher.call(o, n.matcherParam, o) &&
                        c.push([e, o, n]);
                  if (o === i) break;
                  if (
                    ((d = a.length),
                    (o = o.parentElement || o.parentNode) instanceof
                      HTMLDocument)
                  )
                    break;
                }
                for (t = 0; t < c.length; t++)
                  if (
                    !(-1 < this._removedListeners.indexOf(c[t][2])) &&
                    !1 === this.fire.apply(this, c[t])
                  ) {
                    (c[t][0][r] = !0), c[t][0].preventDefault(), (l = !1);
                    break;
                  }
                return l;
              }
            }),
            (i.prototype.fire = function (e, t, i) {
              return i.handler.call(t, e, t);
            }),
            (i.prototype.destroy = function () {
              this.off(), this.root();
            }),
            (t.default = i),
            (e.exports = t.default);
        })
      ),
      E = (function () {
        function e() {
          a(this, e),
            (this.domDelegate = new _(document.body)),
            this._attachListeners();
        }
        return (
          r(e, [
            {
              key: "_attachListeners",
              value: function () {
                this.domDelegate.on(
                  "click",
                  '[data-action="toggle-collapsible"]:not([disabled])',
                  this._toggleCollapsible.bind(this)
                ),
                  document.addEventListener(
                    "collapsible:toggle",
                    this._toggleCollapsible.bind(this)
                  );
              },
            },
            {
              key: "_toggleCollapsible",
              value: function (e, t) {
                var i = this;
                !t &&
                  e.detail &&
                  (t = document.querySelector(
                    '[aria-controls="'.concat(e.detail.id, '"]')
                  ));
                var n = "true" === t.getAttribute("aria-expanded"),
                  e = t.parentNode;
                n ? this._close(e) : this._open(e),
                  "false" !== t.getAttribute("data-close-siblings") &&
                    b.getSiblings(e).forEach(function (e) {
                      return i._close(e);
                    });
              },
            },
            {
              key: "_open",
              value: function (e) {
                var t,
                  i = e.querySelector("[aria-controls]");
                i &&
                  "true" !== i.getAttribute("aria-expanded") &&
                  ((t = e.querySelector(
                    "#".concat(i.getAttribute("aria-controls"))
                  )),
                  i.setAttribute("aria-expanded", "true"),
                  t.hasAttribute("aria-hidden") &&
                    t.setAttribute("aria-hidden", "false"),
                  y.slideDown(t, function () {
                    i.hasAttribute("data-collapsible-force-overflow") &&
                      (t.style.overflow = "visible");
                    var e = t.querySelector("[autofocus]");
                    e && e.focus();
                  }));
              },
            },
            {
              key: "_close",
              value: function (e) {
                var t = e.querySelector("[aria-controls]");
                t &&
                  "false" !== t.getAttribute("aria-expanded") &&
                  ((e = e.querySelector(
                    "#".concat(t.getAttribute("aria-controls"))
                  )),
                  t.hasAttribute("data-collapsible-force-overflow") &&
                    (e.style.overflow = "hidden"),
                  e.hasAttribute("aria-hidden") &&
                    e.setAttribute("aria-hidden", "true"),
                  t.setAttribute("aria-expanded", "false"),
                  y.slideUp(e));
              },
            },
          ]),
          e
        );
      })(),
      S = (function () {
        function i(e, t) {
          a(this, i),
            (this.countrySelect = e),
            (this.provinceSelect = t),
            this.countrySelect &&
              this.provinceSelect &&
              (this._attachListeners(), this._initSelectors());
        }
        return (
          r(i, [
            {
              key: "destroy",
              value: function () {
                this.countrySelect &&
                  this.countrySelect.removeEventListener(
                    "change",
                    this._onCountryChangedListener
                  );
              },
            },
            {
              key: "_initSelectors",
              value: function () {
                var e = this.countrySelect.getAttribute("data-default");
                if (e) {
                  for (var t = 0; t !== this.countrySelect.options.length; ++t)
                    if (this.countrySelect.options[t].text === e) {
                      this.countrySelect.selectedIndex = t;
                      break;
                    }
                } else this.countrySelect.selectedIndex = 0;
                var i = new Event("change", { bubbles: !0 });
                this.countrySelect.dispatchEvent(i);
                var n = this.provinceSelect.getAttribute("data-default");
                if (n)
                  for (var o = 0; o !== this.provinceSelect.options.length; ++o)
                    if (this.provinceSelect.options[o].text === n) {
                      this.provinceSelect.selectedIndex = o;
                      break;
                    }
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._onCountryChangedListener =
                  this._onCountryChanged.bind(this)),
                  this.countrySelect.addEventListener(
                    "change",
                    this._onCountryChangedListener
                  );
              },
            },
            {
              key: "_onCountryChanged",
              value: function () {
                var t = this,
                  e =
                    this.countrySelect.options[
                      this.countrySelect.selectedIndex
                    ];
                e &&
                  ((e = JSON.parse(e.getAttribute("data-provinces") || "[]")),
                  (this.provinceSelect.innerHTML = ""),
                  0 !== e.length
                    ? (e.forEach(function (e) {
                        t.provinceSelect.options.add(new Option(e[1], e[0]));
                      }),
                      (this.provinceSelect.closest(
                        ".form__input-wrapper"
                      ).style.display = "block"))
                    : (this.provinceSelect.closest(
                        ".form__input-wrapper"
                      ).style.display = "none"));
              },
            },
          ]),
          i
        );
      })(),
      k = (function () {
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "matchesBreakpoint",
              value: function (e) {
                switch (e) {
                  case "phone":
                    return window.matchMedia("screen and (max-width: 640px)")
                      .matches;
                  case "tablet":
                    return window.matchMedia(
                      "screen and (min-width: 641px) and (max-width: 1023px)"
                    ).matches;
                  case "tablet-and-up":
                    return window.matchMedia("screen and (min-width: 641px)")
                      .matches;
                  case "pocket":
                    return window.matchMedia("screen and (max-width: 1023px)")
                      .matches;
                  case "lap":
                    return window.matchMedia(
                      "screen and (min-width: 1024px) and (max-width: 1279px)"
                    ).matches;
                  case "lap-and-up":
                    return window.matchMedia("screen and (min-width: 1024px)")
                      .matches;
                  case "desk":
                    return window.matchMedia("screen and (min-width: 1280px)")
                      .matches;
                  case "widescreen":
                    return window.matchMedia("screen and (min-width: 1440px)")
                      .matches;
                  case "supports-hover":
                    return window.matchMedia(
                      "(hover: hover) and (pointer: fine)"
                    ).matches;
                }
              },
            },
            {
              key: "getCurrentBreakpoint",
              value: function () {
                return window.matchMedia("screen and (max-width: 640px)")
                  .matches
                  ? "phone"
                  : window.matchMedia(
                      "screen and (min-width: 641px) and (max-width: 1023px)"
                    ).matches
                  ? "tablet"
                  : window.matchMedia(
                      "screen and (min-width: 1024px) and (max-width: 1279px)"
                    ).matches
                  ? "lap"
                  : window.matchMedia("screen and (min-width: 1280px)").matches
                  ? "desk"
                  : void 0;
              },
            },
          ]),
          e
        );
      })(),
      i = (function () {
        function n(e, t, i) {
          a(this, n),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.delegateRoot = new _(document.documentElement)),
            (this.useInlineNavigation = "inline" === t),
            (this.isNavigationVisible = this.useInlineNavigation),
            (this.openTrigger = i),
            k.matchesBreakpoint("supports-hover") ||
              (this.openTrigger = "click"),
            (this.openItems = []),
            (this.dropdownActivationTimeouts = {}),
            (this.dropdownDeactivationTimeouts = {}),
            (this.DROPDOWN_TIMEOUT = 100),
            this._attachListeners(),
            this.useInlineNavigation && this._setupInlineNavigation();
        }
        return (
          r(n, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off(), this.delegateRoot.off();
              },
            },
            {
              key: "onBlockSelect",
              value: function (t) {
                var i = this;
                this.useInlineNavigation || this._openNavigation(),
                  b
                    .getSiblings(t.target.parentNode, ".is-dropdown-open")
                    .forEach(function (e) {
                      i._deactivateDropdown(
                        t,
                        e.querySelector('[data-type="menuitem"][aria-haspopup]')
                      );
                    }),
                  this._activateDropdown(t, t.target.previousElementSibling);
              },
            },
            {
              key: "onBlockDeselect",
              value: function (e) {
                this.useInlineNavigation || this._closeNavigation(),
                  this._deactivateDropdown(e, e.target.parentNode);
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "focusout",
                  this._onFocusOut.bind(this)
                ),
                  this.delegateRoot.on("click", this._onClick.bind(this)),
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-menu"]',
                    this._toggleNavigation.bind(this)
                  ),
                  "hover" === this.openTrigger
                    ? (this.delegateElement.on(
                        "focusin",
                        '[data-type="menuitem"][aria-haspopup]',
                        this._activateDropdown.bind(this)
                      ),
                      this.delegateElement.on(
                        "mouseover",
                        '[data-type="menuitem"][aria-haspopup]',
                        this._activateDropdown.bind(this)
                      ),
                      this.delegateElement.on(
                        "mouseover",
                        '[data-type="menu"][aria-hidden="false"]',
                        this._blockDropdownDeactivation.bind(this)
                      ),
                      this.delegateElement.on(
                        "focusout",
                        ".is-dropdown-open",
                        this._deactivateDropdown.bind(this)
                      ),
                      this.delegateElement.on(
                        "mouseout",
                        ".is-dropdown-open",
                        this._deactivateDropdown.bind(this)
                      ))
                    : this.delegateElement.on(
                        "click",
                        '[data-type="menuitem"][aria-haspopup]',
                        this._toggleDropdown.bind(this)
                      );
              },
            },
            {
              key: "_onFocusOut",
              value: function (e) {
                null === e.relatedTarget ||
                  this.element.contains(e.relatedTarget) ||
                  this._closeNavigation();
              },
            },
            {
              key: "_onClick",
              value: function (e) {
                this.element.contains(e.target) || this._closeNavigation();
              },
            },
            {
              key: "_openNavigation",
              value: function () {
                this.useInlineNavigation ||
                  (this.element
                    .querySelector('[data-action="toggle-menu"]')
                    .setAttribute("aria-expanded", "true"),
                  this.element
                    .querySelector('[data-type="menu"]')
                    .setAttribute("aria-hidden", "false"),
                  (this.isNavigationVisible = !0));
              },
            },
            {
              key: "_closeNavigation",
              value: function () {
                var t = this;
                this.useInlineNavigation ||
                  (this.element
                    .querySelector('[data-action="toggle-menu"]')
                    .setAttribute("aria-expanded", "false"),
                  this.element
                    .querySelector('[data-type="menu"]')
                    .setAttribute("aria-hidden", "true")),
                  (this.isNavigationVisible = !1),
                  "click" === this.openTrigger &&
                    this.openItems.slice(0).forEach(function (e) {
                      t._deactivateDropdown(event, e);
                    });
              },
            },
            {
              key: "_toggleNavigation",
              value: function (e) {
                this.isNavigationVisible
                  ? this._closeNavigation()
                  : this._openNavigation();
              },
            },
            {
              key: "_toggleDropdown",
              value: function (e, t) {
                "false" === t.getAttribute("aria-expanded") &&
                  e.preventDefault(),
                  "true" === t.getAttribute("aria-expanded")
                    ? "#" === t.getAttribute("href") &&
                      (e.preventDefault(),
                      this._deactivateDropdown(
                        e,
                        t.closest(".is-dropdown-open")
                      ))
                    : this._activateDropdown(e, t);
              },
            },
            {
              key: "_activateDropdown",
              value: function (t, n) {
                var o = this;
                "click" === this.openTrigger &&
                  this.openItems.slice(0).forEach(function (e) {
                    e.contains(n) || o._deactivateDropdown(t, e);
                  });
                function e() {
                  var t, i;
                  n.setAttribute("aria-expanded", "true"),
                    n.parentNode.classList.add("is-dropdown-open"),
                    s.setAttribute("aria-hidden", "false"),
                    "hover" === o.openTrigger &&
                      o.dropdownDeactivationTimeouts[s.id] &&
                      (clearTimeout(o.dropdownDeactivationTimeouts[s.id]),
                      delete o.dropdownDeactivationTimeouts[s.id]),
                    o.useInlineNavigation &&
                      ((t = window.innerWidth),
                      (i = !1),
                      s.querySelectorAll(".nav-dropdown").forEach(function (e) {
                        e.getBoundingClientRect().right > t && (i = !0);
                      }),
                      i && s.classList.add("nav-dropdown--inverse")),
                    n
                      .closest('[data-type="menu"]')
                      .classList.add("nav-dropdown--glued"),
                    s.classList.contains("mega-menu") && o._setupMegaMenu(s),
                    "click" === o.openTrigger && o.openItems.push(n.parentNode);
                }
                var s = b.getSiblings(n, "[aria-hidden]")[0];
                if ("click" === this.openTrigger) e();
                else {
                  for (var i in this.dropdownActivationTimeouts)
                    this.dropdownActivationTimeouts.hasOwnProperty(i) &&
                      (clearTimeout(this.dropdownActivationTimeouts[i]),
                      delete this.dropdownActivationTimeouts[i]);
                  e();
                }
              },
            },
            {
              key: "_deactivateDropdown",
              value: function (t, i) {
                var e,
                  n,
                  o = this;
                ("hover" === this.openTrigger && i.contains(t.relatedTarget)) ||
                  ((e = i.querySelector("[aria-hidden]")),
                  (n = function () {
                    var e;
                    i.classList.remove("is-dropdown-open"),
                      i
                        .querySelector('[data-type="menuitem"]')
                        .setAttribute("aria-expanded", "false"),
                      i
                        .querySelector("[aria-hidden]")
                        .setAttribute("aria-hidden", "true"),
                      i
                        .closest('[data-type="menu"]')
                        .classList.remove("nav-dropdown--glued"),
                      "click" === o.openTrigger &&
                        (i
                          .querySelectorAll(".is-dropdown-open")
                          .forEach(function (e) {
                            o._deactivateDropdown(t, e);
                            e = o.openItems.indexOf(e);
                            -1 < e && o.openItems.splice(e, 1);
                          }),
                        -1 < (e = o.openItems.indexOf(i)) &&
                          o.openItems.splice(e, 1));
                  }),
                  "click" === this.openTrigger
                    ? n()
                    : (this.dropdownDeactivationTimeouts[e.id] = setTimeout(
                        function () {
                          n(), delete o.dropdownDeactivationTimeouts[e.id];
                        },
                        this.DROPDOWN_TIMEOUT
                      )));
              },
            },
            {
              key: "_blockDropdownDeactivation",
              value: function (e, t) {
                if (void 0 !== this.dropdownDeactivationTimeouts[t.id])
                  for (var i in (clearTimeout(
                    this.dropdownDeactivationTimeouts[t.id]
                  ),
                  delete this.dropdownDeactivationTimeouts[t.id],
                  this.dropdownActivationTimeouts))
                    this.dropdownActivationTimeouts.hasOwnProperty(i) &&
                      (clearTimeout(this.dropdownActivationTimeouts[i]),
                      delete this.dropdownActivationTimeouts[i]);
              },
            },
            {
              key: "_setupMegaMenu",
              value: function (e) {
                var t;
                this.useInlineNavigation ||
                  ((t = e.closest(".nav-dropdown").clientWidth),
                  (e.style.maxWidth =
                    Math.min(1400 - t, parseInt(window.innerWidth - t - 80)) +
                    "px"));
              },
            },
            {
              key: "_setupInlineNavigation",
              value: function () {
                var t = this;
                this.element
                  .querySelectorAll(".mega-menu")
                  .forEach(function (e) {
                    e.closest(".nav-bar__item").classList.add(
                      "nav-bar__item--static"
                    );
                  }),
                  "MutationObserver" in window &&
                    ((this.dropdownMenuObserver = new MutationObserver(
                      function (e) {
                        e.forEach(function (e) {
                          "false" === e.target.getAttribute("aria-hidden") &&
                            e.target.style.setProperty(
                              "--distance-to-top",
                              "".concat(
                                e.target.getBoundingClientRect().top,
                                "px"
                              )
                            );
                        });
                      }
                    )),
                    this.element
                      .querySelectorAll(".nav-dropdown .nav-dropdown")
                      .forEach(function (e) {
                        t.dropdownMenuObserver.observe(e, {
                          attributes: !0,
                          attributeFilter: ["aria-hidden"],
                        });
                      }));
              },
            },
          ]),
          n
        );
      })(),
      x = (function () {
        function t(e) {
          a(this, t),
            (this.element = document.getElementById(
              "mobile-collection-filters"
            )),
            (this.delegateRoot = new _(document.documentElement)),
            (this.options = e),
            (this.isOpen = !1),
            this.element && this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateRoot.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateRoot.on(
                  "click",
                  '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]',
                  this.open.bind(this)
                ),
                  this.delegateRoot.on(
                    "click",
                    '#mobile-collection-filters [data-action="close-drawer"]',
                    this.close.bind(this)
                  ),
                  document.addEventListener(
                    "collection-filter:close",
                    this.close.bind(this)
                  ),
                  document.addEventListener(
                    "click",
                    this._detectOutsideClick.bind(this)
                  ),
                  window.addEventListener(
                    "resize",
                    this._computeDrawerHeight.bind(this)
                  );
              },
            },
            {
              key: "open",
              value: function (e) {
                e && e.stopPropagation(),
                  this._computeDrawerHeight(),
                  (this.isOpen = !0),
                  document
                    .querySelector(
                      '[aria-controls="mobile-collection-filters"]'
                    )
                    .setAttribute("aria-expanded", "true"),
                  document
                    .getElementById("mobile-collection-filters")
                    .setAttribute("aria-hidden", "false"),
                  document.body.classList.add("no-mobile-scroll");
              },
            },
            {
              key: "close",
              value: function (e) {
                e && e.stopPropagation(),
                  (this.isOpen = !1),
                  document
                    .querySelector(
                      '[aria-controls="mobile-collection-filters"]'
                    )
                    .setAttribute("aria-expanded", "false"),
                  document
                    .getElementById("mobile-collection-filters")
                    .setAttribute("aria-hidden", "true"),
                  document.body.classList.remove("no-mobile-scroll");
              },
            },
            {
              key: "_computeDrawerHeight",
              value: function () {
                document
                  .getElementById("mobile-collection-filters")
                  .querySelector(".collection-drawer").style.maxHeight =
                  "".concat(window.innerHeight, "px");
              },
            },
            {
              key: "_detectOutsideClick",
              value: function (e) {
                this.isOpen &&
                  !e.target.closest(".collection-drawer__inner") &&
                  this.close();
              },
            },
          ]),
          t
        );
      })(),
      C = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.rootDelegateElement = new _(document.body)),
            (this.options = JSON.parse(e.getAttribute("data-popup-settings"))),
            (this.hasOpenOnceInCurrentPage = !1);
          try {
            "#exit-popup" === window.location.hash &&
              "captcha" !== window.theme.pageType &&
              this._openPopup();
          } catch (e) {}
          this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                var e = this;
                (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                  k.matchesBreakpoint("supports-hover") &&
                    (this.delegateElement.on(
                      "click",
                      '[data-action="close-popup"]',
                      this._closePopup.bind(this)
                    ),
                    document.body.addEventListener("mouseleave", function () {
                      e.hasOpenOnceInCurrentPage ||
                        ((!e.options.showOnlyOnce ||
                          (e.options.showOnlyOnce &&
                            null === localStorage.getItem("themeExitPopup"))) &&
                          e._openPopup());
                    }),
                    (this._clickOutsideListener =
                      this._checkClickOutside.bind(this)));
              },
            },
            {
              key: "_openPopup",
              value: function () {
                window.theme.isNewsletterPopupOpen ||
                  (this.element.setAttribute("aria-hidden", "false"),
                  localStorage.setItem("themeExitPopup", "true"),
                  (this.hasOpenOnceInCurrentPage = !0),
                  (window.theme.isExitPopupOpen = !0),
                  this.delegateElement.on("click", this._clickOutsideListener),
                  this.rootDelegateElement.on(
                    "keyup",
                    this._onKeyPressedListener
                  ));
              },
            },
            {
              key: "_closePopup",
              value: function () {
                this.element.setAttribute("aria-hidden", "true"),
                  (window.theme.isExitPopupOpen = !1),
                  this.delegateElement.off("click", this._clickOutsideListener),
                  this.rootDelegateElement.off(
                    "keyup",
                    this._onKeyPressedListener
                  );
              },
            },
            {
              key: "_checkClickOutside",
              value: function (e) {
                (this.element.contains(e.target) &&
                  this.element !== e.target) ||
                  this._closePopup();
              },
            },
            {
              key: "_onKeyPressed",
              value: function (e) {
                "Escape" === e.key && this._closePopup();
              },
            },
          ]),
          t
        );
      })(),
      L = (function () {
        function e() {
          a(this, e),
            (this.element = document.querySelector(".loading-bar")),
            this.element &&
              (document.addEventListener(
                "theme:loading:start",
                this._onLoadingStart.bind(this)
              ),
              document.addEventListener(
                "theme:loading:end",
                this._onLoadingEnd.bind(this)
              ),
              this.element.addEventListener(
                "transitionend",
                this._onTransitionEnd.bind(this)
              ));
        }
        return (
          r(e, [
            {
              key: "_onLoadingStart",
              value: function () {
                this.element.classList.add("is-visible"),
                  (this.element.style.transform = "scaleX(0.4)");
              },
            },
            {
              key: "_onLoadingEnd",
              value: function () {
                (this.element.style.transform = "scaleX(1)"),
                  this.element.classList.add("is-finished");
              },
            },
            {
              key: "_onTransitionEnd",
              value: function (e) {
                "transform" === e.propertyName &&
                  this.element.classList.contains("is-finished") &&
                  (this.element.classList.remove("is-visible"),
                  this.element.classList.remove("is-finished"),
                  (this.element.style.transform = "scaleX(0)"));
              },
            },
          ]),
          e
        );
      })(),
      A = (function () {
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "trapFocus",
              value: function (t, e) {
                this.listeners = this.listeners || {};
                var i = t.querySelector("[autofocus]") || t;
                t.setAttribute("tabindex", "-1"),
                  i.focus(),
                  (this.listeners[e] = function (e) {
                    t === e.target || t.contains(e.target) || i.focus();
                  }),
                  document.addEventListener("focusin", this.listeners[e]);
              },
            },
            {
              key: "removeTrapFocus",
              value: function (e, t) {
                e && e.removeAttribute("tabindex"),
                  document.removeEventListener("focusin", this.listeners[t]);
              },
            },
            {
              key: "clearTrapFocus",
              value: function () {
                for (var e in this.listeners)
                  this.listeners.hasOwnProperty(e) &&
                    document.removeEventListener("focusin", this.listeners[e]);
                this.listeners = {};
              },
            },
          ]),
          e
        );
      })(),
      T = (function () {
        function i(e, t) {
          a(this, i),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.delegateRoot = new _(document.documentElement)),
            (this.options = t),
            this.element &&
              ((this.miniCartElement =
                this.element.querySelector(".mini-cart")),
              (this.isMiniCartOpen = !1),
              "cart" !== window.theme.pageType &&
                this.miniCartElement &&
                ((this.miniCartToggleElement = this.element.querySelector(
                  '[aria-controls="'.concat(this.miniCartElement.id, '"]')
                )),
                this._checkMiniCartScrollability()),
              (this.itemCount = window.theme.cartCount),
              this._attachListeners());
        }
        return (
          r(i, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off(),
                  this.delegateRoot.off(),
                  window.removeEventListener(
                    "resize",
                    this._calculateMiniCartHeightListener
                  );
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                var t;
                (this._calculateMiniCartHeightListener =
                  this._calculateMiniCartHeight.bind(this)),
                  "cart" !== window.theme.pageType &&
                    "page" !== window.theme.cartType &&
                    (this.delegateElement.on(
                      "click",
                      '[data-action="toggle-mini-cart"]',
                      this._toggleMiniCart.bind(this)
                    ),
                    this.delegateElement.on(
                      "keyup",
                      this._checkMiniCartClose.bind(this)
                    ),
                    (t = this).delegateRoot.on(
                      "click",
                      ".site-popup-close",
                      function (e) {
                        $('[data-action="toggle-mini-cart"]').attr(
                          "aria-expanded",
                          "false"
                        ),
                          $(".header__cart-icon").attr(
                            "aria-expanded",
                            "false"
                          ),
                          $(".mini-cart").attr("aria-hidden", "true"),
                          $("html").removeClass("cart-d-open"),
                          (t.isMiniCartOpen = !1),
                          document.body.classList.remove("no-mobile-scroll"),
                          $(".cart-drawer-header .when-add-cart").hide(),
                          $(".cart-drawer-header .view-add-cart").show(),
                          $("html").removeClass("item-added-cart");
                      }
                    ),
                    this.delegateRoot.on(
                      "click",
                      ".site-popup-mask",
                      function () {
                        $(".site-popup-close").click();
                      }
                    ),
                    this.delegateRoot.on(
                      "click",
                      this._onWindowClick.bind(this)
                    ),
                    window.addEventListener(
                      "resize",
                      this._calculateMiniCartHeightListener
                    )),
                  this.delegateRoot.on(
                    "click",
                    '[data-action="decrease-quantity"]',
                    this._updateQuantity.bind(this)
                  ),
                  this.delegateRoot.on(
                    "click",
                    '[data-action="increase-quantity"]',
                    this._updateQuantity.bind(this)
                  ),
                  this.delegateRoot.on(
                    "change",
                    ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value",
                    this._updateQuantity.bind(this)
                  ),
                  this.delegateRoot.on(
                    "keyup",
                    ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value",
                    this._updateQuantitySize.bind(this)
                  ),
                  this.delegateRoot.on(
                    "keydown",
                    ".quantity-selector__value",
                    this._blockEnterKey.bind(this)
                  ),
                  this.delegateRoot.on(
                    "product:added",
                    this._onProductAdded.bind(this)
                  ),
                  this.delegateRoot.on(
                    "cart:refresh",
                    this._onCartRefresh.bind(this)
                  );
              },
            },
            {
              key: "_toggleMiniCart",
              value: function (e) {
                e && e.preventDefault(),
                  this.isMiniCartOpen
                    ? this._closeMiniCart()
                    : this._openMiniCart();
              },
            },
            {
              key: "_openMiniCart",
              value: function () {
                this.miniCartToggleElement.setAttribute(
                  "aria-expanded",
                  "true"
                ),
                  "phone" === k.getCurrentBreakpoint() &&
                    this.miniCartToggleElement
                      .querySelector(".header__cart-icon")
                      .setAttribute("aria-expanded", "true"),
                  this.miniCartElement.setAttribute("aria-hidden", "false"),
                  (this.isMiniCartOpen = !0),
                  this._calculateMiniCartHeight(),
                  $("html").addClass("cart-d-open"),
                  document.body.classList.add("no-mobile-scroll");
              },
            },
            {
              key: "_closeMiniCart",
              value: function () {
                this.miniCartToggleElement.setAttribute(
                  "aria-expanded",
                  "false"
                ),
                  $("html").removeClass("cart-d-open"),
                  "phone" === k.getCurrentBreakpoint() &&
                    (this.miniCartToggleElement
                      .querySelector(".header__cart-icon")
                      .setAttribute("aria-expanded", "false"),
                    (this.miniCartElement.style.maxHeight = "")),
                  this.miniCartElement.setAttribute("aria-hidden", "true"),
                  (this.isMiniCartOpen = !1),
                  document.body.classList.remove("no-mobile-scroll");
              },
            },
            {
              key: "_checkMiniCartClose",
              value: function (e) {
                this.isMiniCartOpen &&
                  "Escape" === e.key &&
                  this._closeMiniCart();
              },
            },
            {
              key: "_calculateMiniCartHeight",
              value: function () {
                var t, e, i, n;
                "phone" === k.getCurrentBreakpoint() && this.isMiniCartOpen
                  ? ((t = 0),
                    Array.from(
                      document.querySelectorAll(
                        ".shopify-section-group-header-group"
                      )
                    ).forEach(function (e) {
                      (e.classList.contains(
                        "shopify-section--announcement-bar"
                      ) &&
                        window.scrollY > e.clientHeight) ||
                        (t += e.clientHeight);
                    }),
                    (e = window.innerHeight - t),
                    (this.miniCartElement.style.maxHeight = "".concat(e, "px")),
                    (i = this.miniCartElement.querySelector(
                      ".mini-cart__content"
                    )),
                    (n =
                      this.miniCartElement.querySelector(
                        ".mini-cart__recap"
                      )) &&
                      (i.style.maxHeight = "".concat(e - n.clientHeight, "px")))
                  : ((this.miniCartElement.style.maxHeight = ""),
                    (this.miniCartElement.querySelector(
                      ".mini-cart__content"
                    ).style.maxHeight = ""));
              },
            },
            {
              key: "_updateQuantity",
              value: function (e, t) {
                var i = this,
                  n = 1,
                  n =
                    "INPUT" === t.tagName
                      ? parseInt(t.value)
                      : parseInt(t.getAttribute("data-quantity"));
                "page" !== window.theme.cartType
                  ? (document.dispatchEvent(
                      new CustomEvent("theme:loading:start")
                    ),
                    fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                      body: JSON.stringify({
                        line: t.getAttribute("data-line"),
                        quantity: n,
                      }),
                      credentials: "same-origin",
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                      },
                    }).then(function (e) {
                      e.json().then(function (e) {
                        (i.itemCount = e.item_count),
                          i._rerender(!1).then(function () {
                            document.dispatchEvent(
                              new CustomEvent("theme:loading:end")
                            );
                          });
                      });
                    }),
                    e.preventDefault())
                  : t.hasAttribute("data-href")
                  ? (window.location.href = t.getAttribute("data-href"))
                  : (window.location.href = ""
                      .concat(window.routes.cartChangeUrl, "?line=")
                      .concat(t.getAttribute("data-line"), "&quantity=")
                      .concat(n));
              },
            },
            {
              key: "_updateQuantitySize",
              value: function (e, t) {
                t.setAttribute("size", Math.max(t.value.length, 2));
              },
            },
            {
              key: "_blockEnterKey",
              value: function (e) {
                if ("Enter" === e.key) return !1;
              },
            },
            {
              key: "_rerender",
              value: function () {
                var e,
                  o = this,
                  s =
                    !(0 < arguments.length && void 0 !== arguments[0]) ||
                    arguments[0],
                  t = "";
                return (
                  (t =
                    "cart" !== window.theme.pageType
                      ? "".concat(
                          window.routes.cartUrl,
                          "?section_id=mini-cart"
                        )
                      : ((e = document.querySelector(
                          '[data-section-type="cart"]'
                        )),
                        ""
                          .concat(window.routes.cartUrl, "?section_id=")
                          .concat(e.getAttribute("data-section-id")))),
                  fetch(t, {
                    credentials: "same-origin",
                    method: "GET",
                    headers: { "Cache-Control": "no-cache" },
                  }).then(function (e) {
                    e.text().then(function (e) {
                      var t,
                        i,
                        n = document.createElement("div");
                      (n.innerHTML = e),
                        (n = n.firstElementChild).firstElementChild &&
                          n.firstElementChild.hasAttribute("data-item-count") &&
                          (o.itemCount = parseInt(
                            n.firstElementChild.getAttribute("data-item-count")
                          )),
                        (o.element.querySelector(
                          ".header__cart-count"
                        ).textContent = o.itemCount),
                        "page" !== window.theme.cartType &&
                          ("cart" !== window.theme.pageType
                            ? (((t = document.createElement("div")).innerHTML =
                                e),
                              (i = null),
                              (n = o.miniCartElement.querySelector(
                                ".mini-cart__line-item-list"
                              )) && (i = n.scrollTop),
                              (o.miniCartElement.innerHTML =
                                t.querySelector(".mini-cart").innerHTML),
                              (t = o.miniCartElement.querySelector(
                                ".mini-cart__line-item-list"
                              )) &&
                                null !== i &&
                                (t.scrollTop = i),
                              o._checkMiniCartScrollability(),
                              o._calculateMiniCartHeight(),
                              o.element.dispatchEvent(
                                new CustomEvent("cart:rerendered")
                              ))
                            : (((i = document.createElement("div")).innerHTML =
                                e),
                              (document.querySelector(
                                '[data-section-type="cart"]'
                              ).innerHTML = i.querySelector(
                                '[data-section-type="cart"]'
                              ).innerHTML),
                              s &&
                                window.scrollTo({ top: 0, behavior: "smooth" }),
                              o.element.dispatchEvent(
                                new CustomEvent("cart:rerendered", {
                                  bubbles: !0,
                                })
                              )));
                    });
                  })
                );
              },
            },
            {
              key: "_checkMiniCartScrollability",
              value: function () {
                var e = this.miniCartElement.querySelector(
                  ".mini-cart__line-item-list"
                );
                e &&
                  e.scrollHeight > e.clientHeight &&
                  e.classList.add("is-scrollable");
              },
            },
            {
              key: "_onProductAdded",
              value: function (t) {
                var i = this;
                (this.itemCount += t.detail.quantity),
                  $("html").addClass("item-added-cart"),
                  this._onCartRefresh().then(function () {
                    var e;
                    "cart" !== window.theme.pageType &&
                      ("drawer" !== window.theme.cartType ||
                        i.options.useStickyHeader ||
                        ((
                          window.scrollTo({ top: 0, behavior: "smooth" }),
                          window.innerWidth <= 1024 && openCartPage()
                        ),
                        window.addEventListener("scrollend", function () {
                          return i._calculateMiniCartHeight();
                        })),
                      "message" === window.theme.cartType &&
                        t.detail.button &&
                        ((e = t.detail.button.innerHTML),
                        (t.detail.button.innerHTML =
                          window.languages.productAddedShort),
                        setTimeout(function () {
                          t.detail.button.innerHTML = e;
                        }, 1500)),
                      "cart" !== window.theme.pageType &&
                        "drawer" === window.theme.cartType &&
                        i._openMiniCart(),
                      setTimeout(function () {
                        $(".cart-drawer-header .when-add-cart").show(),
                          $(".cart-drawer-header .view-add-cart").hide();
                      }, 500));
                  });
              },
            },
            {
              key: "_onCartRefresh",
              value: function (e) {
                var t = !0;
                return (
                  e && e.detail && (t = e.detail.scrollToTop),
                  this._rerender(t).then(function () {
                    document.dispatchEvent(
                      new CustomEvent("theme:loading:end")
                    );
                  })
                );
              },
            },
            {
              key: "_onWindowClick",
              value: function (e) {
                this.miniCartElement &&
                  this.isMiniCartOpen &&
                  !this.element.contains(e.target) &&
                  this._closeMiniCart();
              },
            },
          ]),
          i
        );
      })(),
      I = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.delegateRoot = new _(document.documentElement)),
            (this.mobileMenuElement =
              this.element.querySelector(".mobile-menu")),
            (this.mobileMenuToggleElement = this.element.querySelector(
              '[aria-controls="'.concat(this.mobileMenuElement.id, '"]')
            )),
            (this.isOpen = !1),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off(),
                  this.delegateRoot.off(),
                  window.removeEventListener(
                    "resize",
                    this._calculatMaxHeightListener
                  );
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._calculatMaxHeightListener =
                  this._calculateMaxHeight.bind(this)),
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-menu"]',
                    this._toggleMenu.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="open-panel"]',
                    this._openPanel.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="close-panel"]',
                    this._closePanel.bind(this)
                  ),
                  this.delegateRoot.on("click", this._onWindowClick.bind(this)),
                  window.addEventListener(
                    "resize",
                    this._calculatMaxHeightListener
                  );
              },
            },
            {
              key: "_toggleMenu",
              value: function () {
                (this.isOpen = !this.isOpen),
                  this.mobileMenuToggleElement.setAttribute(
                    "aria-expanded",
                    this.isOpen ? "true" : "false"
                  ),
                  this.mobileMenuElement.setAttribute(
                    "aria-hidden",
                    this.isOpen ? "false" : "true"
                  ),
                  this.isOpen
                    ? (this._calculateMaxHeight(),
                      document.body.classList.add("no-mobile-scroll"))
                    : ((this.mobileMenuElement.style.maxHeight = ""),
                      this.element
                        .querySelectorAll(".mobile-menu__panel.is-open")
                        .forEach(function (e) {
                          e.classList.remove("is-open");
                        }),
                      document.body.classList.remove("no-mobile-scroll"));
              },
            },
            {
              key: "_openPanel",
              value: function (e, t) {
                t.setAttribute("aria-expanded", "true"),
                  this.element
                    .querySelector("#".concat(t.getAttribute("aria-controls")))
                    .classList.add("is-open");
              },
            },
            {
              key: "_closePanel",
              value: function (e, t) {
                t = t.closest(".mobile-menu__panel.is-open");
                t.classList.remove("is-open"),
                  this.element
                    .querySelector('[aria-controls="'.concat(t.id, '"]'))
                    .setAttribute("aria-expanded", "false");
              },
            },
            {
              key: "_calculateMaxHeight",
              value: function () {
                this.isOpen &&
                  (this.mobileMenuElement.style.maxHeight = "".concat(
                    window.innerHeight -
                      document.querySelector(".header").getBoundingClientRect()
                        .bottom,
                    "px"
                  ));
              },
            },
            {
              key: "_onWindowClick",
              value: function (e) {
                this.isOpen &&
                  !this.element.contains(e.target) &&
                  this._toggleMenu();
              },
            },
          ]),
          t
        );
      })(),
      M = (function () {
        function t() {
          a(this, t),
            (this.domDelegate = new _(document.body)),
            (this.activeModalsQueue = []);
          var e = document.querySelector('.modal[aria-hidden="false"]');
          e && this.activeModalsQueue.push(e), this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "_attachListeners",
              value: function () {
                (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                  this.domDelegate.on(
                    "click",
                    '[data-action="open-modal"]',
                    this._openModal.bind(this)
                  ),
                  this.domDelegate.on(
                    "click",
                    '[data-action="close-modal"]',
                    this._closeModal.bind(this)
                  ),
                  document.addEventListener(
                    "modal:close",
                    this._closeModal.bind(this)
                  ),
                  (this._clickOutsideListener =
                    this._checkClickOutside.bind(this)),
                  0 < this.activeModalsQueue.length &&
                    (document.documentElement.classList.add("is-locked"),
                    this.domDelegate.on("click", this._clickOutsideListener));
              },
            },
            {
              key: "_openModal",
              value: function (e, t) {
                var i = this,
                  n = document.querySelector(
                    "#".concat(t.getAttribute("aria-controls"))
                  );
                if (n) {
                  t = function e(t) {
                    "visibility" === t.propertyName &&
                      (n.removeEventListener("transitionend", e),
                      A.trapFocus(n, "modal" + n.id),
                      i.activeModalsQueue.push(n));
                  };
                  return (
                    n.addEventListener("transitionend", t),
                    n.setAttribute("aria-hidden", "false"),
                    document.documentElement.classList.add("is-locked"),
                    this.domDelegate.on("click", this._clickOutsideListener),
                    this.domDelegate.on("keyup", this._onKeyPressedListener),
                    !1
                  );
                }
              },
            },
            {
              key: "_closeModal",
              value: function () {
                var i, e;
                0 < this.activeModalsQueue.length &&
                  ((e = function e(t) {
                    "visibility" === t.propertyName &&
                      (i.removeEventListener("transitionend", e),
                      A.removeTrapFocus(i, "modal" + i.id),
                      i.dispatchEvent(new CustomEvent("modal:closed")));
                  }),
                  (i = this.activeModalsQueue.pop()).addEventListener(
                    "transitionend",
                    e
                  ),
                  i.setAttribute("aria-hidden", "true"),
                  document.documentElement.classList.remove("is-locked"),
                  this.domDelegate.off("click", this._clickOutsideListener),
                  this.domDelegate.off("keyup", this._onKeyPressedListener));
              },
            },
            {
              key: "_checkClickOutside",
              value: function (e) {
                var t;
                0 !== this.activeModalsQueue.length &&
                  (!(t =
                    this.activeModalsQueue[
                      this.activeModalsQueue.length - 1
                    ]) ||
                    (t.contains(e.target) && t !== e.target) ||
                    this._closeModal());
              },
            },
            {
              key: "_onKeyPressed",
              value: function (e) {
                "Escape" === e.key && this._closeModal();
              },
            },
          ]),
          t
        );
      })(),
      P = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.rootDelegateElement = new _(document.body)),
            (this.options = JSON.parse(e.getAttribute("data-popup-settings")));
          try {
            "#newsletter-popup" === window.location.hash &&
            "captcha" !== window.theme.pageType
              ? this._openPopup()
              : (!this.options.showOnlyOnce ||
                  (this.options.showOnlyOnce &&
                    null === localStorage.getItem("themePopup"))) &&
                setTimeout(
                  this._openPopup.bind(this),
                  1e3 * this.options.apparitionDelay
                );
          } catch (e) {}
          this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                  this.delegateElement.on(
                    "click",
                    '[data-action="close-popup"]',
                    this._closePopup.bind(this)
                  ),
                  (this._clickOutsideListener =
                    this._checkClickOutside.bind(this));
              },
            },
            {
              key: "_openPopup",
              value: function () {
                window.theme.isExitPopupOpen ||
                  (this.element.setAttribute("aria-hidden", "false"),
                  localStorage.setItem("themePopup", "true"),
                  (window.theme.isNewsletterPopupOpen = !0),
                  this.delegateElement.on("click", this._clickOutsideListener),
                  this.rootDelegateElement.on(
                    "keyup",
                    this._onKeyPressedListener
                  ));
              },
            },
            {
              key: "_closePopup",
              value: function () {
                this.element.setAttribute("aria-hidden", "true"),
                  (window.theme.isNewsletterPopupOpen = !1),
                  this.delegateElement.off("click"),
                  this.rootDelegateElement.off(
                    "keyup",
                    this._onKeyPressedListener
                  );
              },
            },
            {
              key: "_checkClickOutside",
              value: function (e) {
                (this.element.contains(e.target) &&
                  this.element !== e.target) ||
                  this._closePopup();
              },
            },
            {
              key: "_onKeyPressed",
              value: function (e) {
                "Escape" === e.key && this._closePopup();
              },
            },
          ]),
          t
        );
      })(),
      D = t(function (l) {
        !(function (e) {
          var o = function () {},
            t =
              e.requestAnimationFrame ||
              e.webkitRequestAnimationFrame ||
              e.mozRequestAnimationFrame ||
              e.msRequestAnimationFrame ||
              function (e) {
                return setTimeout(e, 16);
              };
          function i() {
            (this.reads = []), (this.writes = []), (this.raf = t.bind(e));
          }
          function s(e) {
            e.scheduled ||
              ((e.scheduled = !0),
              e.raf(
                function (e) {
                  var t,
                    i = e.writes,
                    n = e.reads;
                  try {
                    o("flushing reads", n.length),
                      a(n),
                      o("flushing writes", i.length),
                      a(i);
                  } catch (e) {
                    t = e;
                  }
                  (e.scheduled = !1), (n.length || i.length) && s(e);
                  if (t) {
                    if ((o("task errored", t.message), !e.catch)) throw t;
                    e.catch(t);
                  }
                }.bind(null, e)
              ));
          }
          function a(e) {
            for (var t; (t = e.shift()); ) t();
          }
          function n(e, t) {
            t = e.indexOf(t);
            return !!~t && !!e.splice(t, 1);
          }
          i.prototype = {
            constructor: i,
            measure: function (e, t) {
              e = t ? e.bind(t) : e;
              return this.reads.push(e), s(this), e;
            },
            mutate: function (e, t) {
              e = t ? e.bind(t) : e;
              return this.writes.push(e), s(this), e;
            },
            clear: function (e) {
              return n(this.reads, e) || n(this.writes, e);
            },
            extend: function (e) {
              if ("object" != wi(e)) throw new Error("expected object");
              var t = Object.create(this);
              return (
                (function (e, t) {
                  for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                })(t, e),
                (t.fastdom = this),
                t.initialize && t.initialize(),
                t
              );
            },
            catch: null,
          };
          var r = (e.fastdom = e.fastdom || new i());
          l.exports = r;
        })("undefined" != typeof window ? window : w);
      }),
      z = (function () {
        function i(e, t) {
          a(this, i),
            e &&
              ((this.element = e),
              (this.options = t),
              (this.lastKnownY = window.scrollY),
              (this.currentTop = 0),
              (this.initialTopOffset =
                t.offsetTop ||
                parseInt(window.getComputedStyle(this.element).top)),
              this._attachListeners());
        }
        return (
          r(i, [
            {
              key: "destroy",
              value: function () {
                window.removeEventListener(
                  "scroll",
                  this._checkPositionListener
                );
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._checkPositionListener = this._checkPosition.bind(this)),
                  window.addEventListener(
                    "scroll",
                    this._checkPositionListener
                  );
              },
            },
            {
              key: "_checkPosition",
              value: function () {
                var i = this;
                D.measure(function () {
                  var e =
                      i.element.getBoundingClientRect().top +
                      window.scrollY -
                      i.element.offsetTop +
                      i.initialTopOffset,
                    t =
                      i.element.clientHeight -
                      window.innerHeight +
                      (i.options.offsetBottom || 0);
                  window.scrollY < i.lastKnownY
                    ? (i.currentTop -= window.scrollY - i.lastKnownY)
                    : (i.currentTop += i.lastKnownY - window.scrollY),
                    (i.currentTop = Math.min(
                      Math.max(i.currentTop, -t),
                      e,
                      i.initialTopOffset
                    )),
                    (i.lastKnownY = window.scrollY);
                }),
                  D.mutate(function () {
                    i.element.style.top = "".concat(i.currentTop, "px");
                  });
              },
            },
          ]),
          i
        );
      })(),
      O = (function () {
        function e() {
          a(this, e),
            (this.delegateElement = new _(document.body)),
            (this.delegateRoot = new _(document.documentElement)),
            (this.activePopover = null),
            this._attachListeners();
        }
        return (
          r(e, [
            {
              key: "_attachListeners",
              value: function () {
                (this._onLooseFocusListener = this._onLooseFocus.bind(this)),
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-popover"]',
                    this._togglePopover.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="show-popover-panel"]',
                    this._showPanel.bind(this)
                  ),
                  this.delegateRoot.on("click", this._onWindowClick.bind(this)),
                  document.addEventListener(
                    "popover:close",
                    this._closeActivePopover.bind(this)
                  ),
                  window.addEventListener(
                    "resize",
                    this._windowResized.bind(this)
                  );
              },
            },
            {
              key: "_togglePopover",
              value: function (e, t) {
                var i = null !== this.activePopover,
                  n = this.activePopover ? this.activePopover.id : null;
                (t.hasAttribute("data-follow-link") &&
                  k.matchesBreakpoint(t.getAttribute("data-follow-link"))) ||
                  (i && this._closeActivePopover(),
                  (!i || (i && t.getAttribute("aria-controls") !== n)) &&
                    this._openPopover(t),
                  e.preventDefault());
              },
            },
            {
              key: "_closeActivePopover",
              value: function () {
                this.activePopover.setAttribute("aria-hidden", "true"),
                  document
                    .querySelector(
                      '[aria-controls="'.concat(this.activePopover.id, '"]')
                    )
                    .setAttribute("aria-expanded", "false"),
                  this.activePopover.removeEventListener(
                    "focusout",
                    this._onLooseFocusListener
                  ),
                  (this.activePopover = null);
              },
            },
            {
              key: "_openPopover",
              value: function (e) {
                var t = document.getElementById(
                  e.getAttribute("aria-controls")
                );
                e.setAttribute("aria-expanded", "true"),
                  t.setAttribute("aria-hidden", "false"),
                  "phone" === k.getCurrentBreakpoint()
                    ? (t.style.height = "".concat(
                        window.innerHeight -
                          document
                            .querySelector(".header")
                            .getBoundingClientRect().bottom,
                        "px"
                      ))
                    : ((t.style.height = ""),
                      (e = t.querySelector(".popover__panel-list")) &&
                        (e.style.height = "".concat(e.clientHeight, "px"))),
                  (this.activePopover = t),
                  this.activePopover.addEventListener(
                    "focusout",
                    this._onLooseFocusListener
                  );
              },
            },
            {
              key: "_showPanel",
              value: function (e, t) {
                this.activePopover &&
                  this.activePopover
                    .querySelectorAll(".popover__panel")
                    .forEach(function (e) {
                      e.id === t.getAttribute("aria-controls")
                        ? (e.classList.add("is-selected"),
                          (e.closest(".popover__panel-list").style.height =
                            "".concat(e.clientHeight, "px")))
                        : e.classList.remove("is-selected");
                    });
              },
            },
            {
              key: "_onWindowClick",
              value: function (e) {
                "toggle-popover" === e.target.getAttribute("data-action") ||
                  e.target.closest('[data-action="toggle-popover"]') ||
                  (this.activePopover &&
                    !this.activePopover.contains(e.target) &&
                    this._closeActivePopover());
              },
            },
            {
              key: "_onLooseFocus",
              value: function (e) {
                this.activePopover &&
                  null !== e.relatedTarget &&
                  !this.activePopover.contains(e.relatedTarget) &&
                  this._closeActivePopover();
              },
            },
            {
              key: "_windowResized",
              value: function () {
                "phone" === k.getCurrentBreakpoint() &&
                  this.activePopover &&
                  (this.activePopover.style.height = "".concat(
                    window.innerHeight -
                      document.querySelector(".header").getBoundingClientRect()
                        .bottom,
                    "px"
                  ));
              },
            },
          ]),
          e
        );
      })(),
      q = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            this._attachListeners(),
            this.recalculateSwatches();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off(),
                  window.removeEventListener(
                    "resize",
                    this._recalculateSwatchesListener
                  );
              },
            },
            {
              key: "recalculateSwatches",
              value: function () {
                var e = this;
                D.measure(function () {
                  e.element
                    .querySelectorAll(".product-item__swatch-list")
                    .forEach(function (e) {
                      var t = e.clientWidth,
                        t = parseInt(Math.min(t, 200)),
                        n = Math.floor(t / 30);
                      D.mutate(function () {
                        var i = e.querySelectorAll(".color-swatch");
                        i.forEach(function (e, t) {
                          e.classList.remove("color-swatch--view-more"),
                            n === t + 1 &&
                              n !== i.length &&
                              e.classList.add("color-swatch--view-more");
                        });
                      });
                    });
                });
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._recalculateSwatchesListener =
                  this.recalculateSwatches.bind(this)),
                  this.delegateElement.on(
                    "change",
                    ".product-item__swatch-list .color-swatch__radio",
                    this._colorChanged.bind(this)
                  ),
                  window.addEventListener(
                    "resize",
                    this._recalculateSwatchesListener
                  );
              },
            },
            {
              key: "_colorChanged",
              value: function (e, t) {
                var i = t.closest(".product-item"),
                  n = t.getAttribute("data-variant-url");
                i
                  .querySelector(".product-item__image-wrapper")
                  .setAttribute("href", n),
                  i
                    .querySelector(".product-item__title")
                    .setAttribute("href", n);
                n = i.querySelector(".product-item__primary-image");
                t.hasAttribute("data-image-url") &&
                  t.getAttribute("data-media-id") !==
                    n.getAttribute("data-media-id") &&
                  (((i = document.createElement("img")).className =
                    "product-item__primary-image"),
                  i.setAttribute(
                    "data-media-id",
                    t.getAttribute("data-media-id")
                  ),
                  i.setAttribute("src", t.getAttribute("data-image-url")),
                  (n.parentNode.style.paddingBottom = "".concat(
                    100 / i.getAttribute("data-image-aspect-ratio"),
                    "%"
                  )),
                  n.parentNode.replaceChild(i, n));
              },
            },
          ]),
          t
        );
      })(),
      B = (function () {
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "formatMoney",
              value: function (e, t) {
                "string" == typeof e && (e = e.replace(".", ""));
                var i = /\{\{\s*(\w+)\s*\}\}/,
                  t = t || "${{amount}}";
                function o(e, t) {
                  return null == e || e != e ? t : e;
                }
                function n(e, t, i, n) {
                  if (
                    ((t = o(t, 2)),
                    (i = o(i, ",")),
                    (n = o(n, ".")),
                    isNaN(e) || null == e)
                  )
                    return 0;
                  e = (e = (e / 100).toFixed(t)).split(".");
                  return (
                    e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
                    (e[1] ? n + e[1] : "")
                  );
                }
                var s = "";
                switch (t.match(i)[1]) {
                  case "amount":
                    s = n(e, 2);
                    break;
                  case "amount_no_decimals":
                    s = n(e, 0);
                    break;
                  case "amount_with_space_separator":
                    s = n(e, 2, " ", ".");
                    break;
                  case "amount_with_comma_separator":
                    s = n(e, 2, ".", ",");
                    break;
                  case "amount_with_apostrophe_separator":
                    s = n(e, 2, "'", ".");
                    break;
                  case "amount_no_decimals_with_comma_separator":
                    s = n(e, 0, ".", ",");
                    break;
                  case "amount_no_decimals_with_space_separator":
                    s = n(e, 0, " ");
                    break;
                  case "amount_no_decimals_with_apostrophe_separator":
                    s = n(e, 0, "'");
                }
                return t.indexOf("with_comma_separator"), t.replace(i, s);
              },
            },
          ]),
          e
        );
      })();
      B.formatMoneySplit = function (e, t) {
        if (typeof e === "string") e = e.replace(".", "");
      
        const formatTemplate = t || "${{amount}}";
        const tokenRegex = /\{\{\s*(\w+)\s*\}\}/;
      
        function fallback(val, fallback) {
          return val == null || val !== val ? fallback : val;
        }
      
        function formatNumber(val, precision, thousandsSep, decimalSep) {
          precision = fallback(precision, 2);
          thousandsSep = fallback(thousandsSep, ",");
          decimalSep = fallback(decimalSep, ".");
      
          if (isNaN(val) || val == null) return "0";
      
          val = (val / 100).toFixed(precision).split(".");
      
          const whole = val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousandsSep);
          const decimal = val[1];
      
          return { whole, decimal, decimalSep };
        }
      
        const formatKey = formatTemplate.match(tokenRegex)[1];
        let moneyParts;
      
        switch (formatKey) {
          case "amount":
            moneyParts = formatNumber(e, 2);
            break;
          case "amount_no_decimals":
            moneyParts = formatNumber(e, 0);
            break;
          case "amount_with_space_separator":
            moneyParts = formatNumber(e, 2, " ", ".");
            break;
          case "amount_with_comma_separator":
            moneyParts = formatNumber(e, 2, ".", ",");
            break;
          case "amount_with_apostrophe_separator":
            moneyParts = formatNumber(e, 2, "'", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            moneyParts = formatNumber(e, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            moneyParts = formatNumber(e, 0, " ");
            break;
          case "amount_no_decimals_with_apostrophe_separator":
            moneyParts = formatNumber(e, 0, "'");
            break;
          default:
            moneyParts = formatNumber(e, 2);
        }
      
        // 💡 Get symbol from <body data-curr-symbol="">
        const currencySymbol = document.body.getAttribute("data-curr-symbol") || "";
      
        const html =
          (currencySymbol ? `<span>${currencySymbol}</span>` : "") +
          `<span>${moneyParts.whole}</span>` +
          (moneyParts.decimal ? `<span>${moneyParts.decimalSep}</span><span>${moneyParts.decimal}</span>` : "");
      
        return html;
      };
      
      
    void 0 === window.CurrencyClass && (window.CurrencyClass = B);
    var R = (function () {
        function s() {
          a(this, s);
        }
        return (
          r(s, null, [
            {
              key: "serialize",
              value: function (e) {
                for (var t = {}, i = 0, n = e.elements.length; i < n; i++) {
                  var o = e.elements[i];
                  "" === o.name ||
                    o.disabled ||
                    (o.name &&
                      !o.disabled &&
                      (o.checked ||
                        /select|textarea/i.test(o.nodeName) ||
                        /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                          o.type
                        )) &&
                      ((o = (function e(t, i) {
                        var n = t.lastIndexOf("[");
                        if (-1 === n) {
                          var o = {};
                          return (o[t] = i), o;
                        }
                        var s = t.substr(0, n),
                          o = {};
                        return (
                          (o[t.substring(n + 1, t.length - 1)] = i), e(s, o)
                        );
                      })(o.name, o.value)),
                      (t = s.extend(t, o))));
                }
                return t;
              },
            },
            {
              key: "extend",
              value: function () {
                for (var i = {}, e = 0; e < arguments.length; e++)
                  !(function (e) {
                    for (var t in e)
                      e.hasOwnProperty(t) &&
                        ("[object Object]" ===
                        Object.prototype.toString.call(e[t])
                          ? (i[t] = s.extend(i[t], e[t]))
                          : (i[t] = e[t]));
                  })(arguments[e]);
                return i;
              },
            },
          ]),
          s
        );
      })(),
      H = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            !this.element ||
              ((e = this.element.querySelector(
                ".store-availabilities-modal"
              )) &&
                document.body.appendChild(e));
        }
        return (
          r(t, [
            {
              key: "updateWithVariant",
              value: function (e) {
                this.element &&
                  (e
                    ? this._renderAvailabilitySection(e.id)
                    : (this.element.textContent = ""));
              },
            },
            {
              key: "_renderAvailabilitySection",
              value: function (i) {
                var n = this;
                this.element.innerHTML = "";
                var e = document.getElementById(
                  "StoreAvailabilityModal-".concat(i)
                );
                return (
                  e && e.remove(),
                  fetch(
                    ""
                      .concat(window.routes.rootUrlWithoutSlash, "/variants/")
                      .concat(i, "?section_id=store-availability")
                  ).then(function (e) {
                    return e.text().then(function (e) {
                      var t = document.createElement("div");
                      (t.innerHTML = e),
                        (t.innerHTML = t.firstElementChild.innerHTML),
                        "0" !==
                          t.firstElementChild.getAttribute("data-count") &&
                          ((n.element.innerHTML = t.innerHTML),
                          (t = document.getElementById(
                            "StoreAvailabilityModal-".concat(i)
                          )),
                          document.body.appendChild(t));
                    });
                  })
                );
              },
            },
          ]),
          t
        );
      })(),
      N = (function () {
        function o(e, t) {
          var i = this;
          a(this, o),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = t);
          var n,
            t = this.element.querySelector("[data-product-json]");
          t &&
            ((n = JSON.parse(t.innerHTML)),
            (this.productData = n.product),
            (this.productOptionsWithValues = n.options_with_values),
            (this.productTemplate = n.template),
            (this.variantsInventories = n.inventories || {}),
            (this.variantSelectors = this.element.querySelectorAll(
              ".product-form__option[data-selector-type]"
            )),
            (this.masterSelector = this.element.querySelector(
              "#product-select-".concat(this.productData.id)
            )),
            this.productData.variants.forEach(function (e) {
              e.id === n.selected_variant_id &&
                ((i.currentVariant = e),
                (i.option1 = e.option1),
                (i.option2 = e.option2),
                (i.option3 = e.option3));
            }),
            (this.storeAvailability = new H(
              this.element.querySelector(
                ".product-meta__store-availability-container"
              )
            ))),
            this._updateSelectors(this.currentVariant),
            this._setupStockCountdown(),
            this._attachListeners();
        }
        return (
          r(o, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off("click");
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "change",
                  ".product-form__single-selector",
                  this._onOptionChanged.bind(this)
                ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="add-to-cart"]',
                    this._addToCart.bind(this)
                  );
              },
            },
            {
              key: "_onVariantChanged",
              value: function (e, t) {
                this._updateProductPrices(t, e),
                  this._updateInventory(t, e),
                  this._updateSku(t, e),
                  this._updateDiscountLabel(t, e),
                  this._updateUnitPrice(t, e),
                  this._updateSelectors(t, e),
                  this._updateAddToCartButton(t, e),
                  this._changeDescriptionContent(t, e),
                  this._updateVariantMetafieldBtnLink(t, e),
                  // Added backorder functionality
                  this._updateInventoryWithBackorder(t, e),
                  this.storeAvailability.updateWithVariant(t),
                  this.element.dispatchEvent(
                    new CustomEvent("variant:changed", {
                      bubbles: !0,
                      detail: { variant: t, previousVariant: e },
                    })
                  ),
                  this.masterSelector.dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  );
              },
            },
            {
              key: "_updateProductPrices",
              value: function (s, a) {
                var r = this.element.querySelector(".price-list"),
                  l = window.theme.currencyCodeEnabled
                    ? window.theme.moneyWithCurrencyFormat
                    : window.theme.moneyFormat,
                  c = document.getElementById("custom-sticky-bar-title"),
                  d = document.getElementById("custom-apr-link");
                if (
                  (d &&
                    (d.href =
                      "https://admin.shopify.com/store/bayland/apps/auto-pricing-rules-v2/app/variant-with-apr?shopify_variant_id=" +
                      s.id),
                  c && (c.innerHTML = s.public_title),
                  r)
                )
                  if (s) {
                    if (
                      !a ||
                      a.price !== s.price ||
                      a.compare_at_price !== s.compare_at_price
                    ) {
                      let e = B.formatMoney(s.price, l);
                      e = e.replace(/^[^\d]+/, "");
                      var u = jQuery("body").attr("data-curr");
                      let t = "";
                      "INR" === u && (e = e.replace("Rs.", "₹")),
                        (t =
                          "EUR" === u ||
                          "QAR" === u ||
                          "RON" === u ||
                          "PLN" === u ||
                          "HUF" === u ||
                          "DKK" === u ||
                          "CZK" === u ||
                          "BAM" === u
                            ? ","
                            : ".");
                      d = t;
                      let i;
                      i = "," === d ? e.split(",") : e.split(".");
                      c = jQuery("body").attr("data-curr-symbol");
                      let n = i[0];
                      n.match(/[^\d.,]+/);
                      a = n.replace(/[^\d.,]+/, "");
                      let o = 1 < i.length ? i[1] : "";
                      o.match(/\D/) &&
                        ((d = o.split(/(\D+)/)), (o = d.shift()), d.join("")),
                        "00" == o && (o = ""),
                        (a =
                          "CAD" === u ||
                          "AUD" === u ||
                          "SGD" === u ||
                          "NZD" === u ||
                          "HKD" === u
                            ? "<span>" +
                              c +
                              "</span>" +
                              "<span>"+ a +"</span>" +
                              "<span class='relative start-px top-0.5 text-xs rtl:me-px'>" +
                              o +
                              "</span><span class='ms-1 font-normal text-sm flex items-end'>" +
                              u +
                              "</span>"
                            : "TRY" === u
                            ? "<span>" +
                              c +
                              "</span>" +
                              "<span>"+ a +"</span>" +
                              "<span class='relative start-px top-0.5 text-xs rtl:me-px'>" +
                              o +
                              "</span><span class='ms-1 font-normal text-sm flex items-end'> TL</span>"
                            : "<span>" +
                              c +
                              "</span>" +
                              "<span>"+ a +"</span>" +
                              "<span class='relative start-px top-0.5 text-xs rtl:me-px'>" +
                              o +
                              "</span>"),
                        (r.innerHTML = ""),
                        s.compare_at_price > s.price
                          ? ((r.innerHTML +=
                              '<span class="text-red-600 text-2xl font-medium flex me-4"><span class="visually-hidden">'
                                .concat(
                                  window.languages.productSalePrice,
                                  "</span>"
                                )
                                .concat(a, "</span>")),
                            (r.innerHTML +=
                              '<span class="text-base line-through flex font-medium text-gray-500"><span class="visually-hidden">'
                                .concat(
                                  window.languages.productRegularPrice,
                                  "</span>"
                                )
                                .concat(
                                  B.formatMoneySplit(s.compare_at_price, l),
                                  "</span>"
                                )))
                          : (r.innerHTML +=
                              '<span class="price"><span class="visually-hidden">'
                                .concat(
                                  window.languages.productSalePrice,
                                  "</span>"
                                )
                                .concat(a, "</span>"));
                      l = document.getElementById("custom-sticky-bar-price");
                      l &&
                        (l.innerHTML =
                          '<span class="text-[#e00] text-[25px] !font-medium flex mr-[17px]"><span class="visually-hidden">'
                            .concat(
                              window.languages.productSalePrice,
                              "</span>"
                            )
                            .concat(a, "</span>")),
                        (r.style.display = "");
                    }
                  } else r.style.display = "none";
              },
            },
            {
              key: "_updateInventory",
              value: function (e) {
                var t, i, n, o, s, a, r, l, c, d, u, h, p;
                this.options.showInventoryQuantity &&
                  e &&
                  ((t = this.element.querySelector(".product-form__inventory")),
                  (i = this.variantsInventories[e.id].inventory_management),
                  (n = this.variantsInventories[e.id].inventory_policy),
                  (p = this.variantsInventories[e.id].inventory_quantity),
                  this.variantsInventories[e.id].inventory_message,
                  (o = this.variantsInventories[e.id].inventory_shipping),
                  (s = this.variantsInventories[e.id].inventory_Warranty),
                  (a = this.variantsInventories[e.id].inventory_Coverage),
                  (r = this.variantsInventories[e.id].inventory_hideprice),
                  (l =
                    this.variantsInventories[e.id]
                      .inventory_moneyback_guarantee),
                  (c = this.variantsInventories[e.id].inventory_saw_for_less),
                  (h =
                    this.variantsInventories[e.id]
                      .inventory_want_for_lower_price),
                  (d =
                    this.variantsInventories[e.id].inventory_buyback_guarantee),
                  (u = this.element.querySelector(".pro-vendor").textContent),
                  t &&
                    (t.classList.remove("inventory--high"),
                    t.classList.remove("inventory--low"),
                    e.available &&
                      (null !== i &&
                      "deny" === n &&
                      0 < this.options.lowInventoryThreshold &&
                      p <= this.options.lowInventoryThreshold
                        ? t.classList.add("inventory--low")
                        : t.classList.add("inventory--high"),
                      "hide" == o
                        ? jQuery(".stock-shipping").addClass("d_none")
                        : jQuery(".stock-shipping").removeClass("d_none"),
                      (document.getElementById("shipping_here").innerHTML =
                        null == o ? " 24-48 Hours" : o),
                      "yes" == l || "Yes" == l || "Y" == l || "y" == l
                        ? jQuery(".show_moneyback_guarantee").show()
                        : jQuery(".show_moneyback_guarantee").hide(),
                      "yes" == r || "Yes" == r || "Y" == r || "y" == r
                        ? (jQuery(".hide-price_option").hide(),
                          jQuery(".hide-addbtn_option").hide(),
                          jQuery(".requestq-btn").removeClass("d_none"),
                          jQuery(".rfq-btn").addClass("d_none"),
                          jQuery(".pro-info-main-price").removeClass(
                            "price-border"
                          ))
                        : (jQuery(".hide-price_option").show(),
                          jQuery(".hide-addbtn_option").show(),
                          jQuery(".requestq-btn").addClass("d_none"),
                          jQuery(".rfq-btn").removeClass("d_none"),
                          jQuery(".pro-info-main-price").addClass(
                            "price-border"
                          )),
                      "" != c && jQuery(".custom-raq-saw-text").show(),
                      null == c && jQuery(".custom-raq-saw-text").hide(),
                      "" != h && jQuery(".custom-raq-want-text").show(),
                      null == h && jQuery(".custom-raq-want-text").hide(),
                      jQuery(document).ready(function () {
                        jQuery(".pro-Warranty").text(s),
                          jQuery(".pro-Coverage").text(a),
                          "barco" == u.toLowerCase()
                            ? jQuery(".pro-wtolp").attr(
                                "data-tooltip",
                                "- " +
                                  s +
                                  "-year premium Monitors.com warranty on parts & labor \n - " +
                                  s +
                                  "-year premium Monitors.com loaner coverage \n - " +
                                  s +
                                  "-year premium Monitors.com technical support"
                              )
                            : jQuery(".pro-wtolp").attr(
                                "data-tooltip",
                                "- " +
                                  s +
                                  "-year warranty on parts & labor \n - " +
                                  s +
                                  "-year loaner coverage \n - " +
                                  s +
                                  "-year premium technical support"
                              );
                        var e = jQuery(".buyback_guarantee");
                        "Y" == d || "y" == d || "Yes" == d || "yes" == d
                          ? e.show()
                          : e.hide();
                      })),
                    (h = this.element.querySelector(".inventory-bar")) &&
                      ((p = Math.min(
                        Math.max(
                          (p /
                            parseInt(
                              h.getAttribute("data-stock-countdown-max")
                            )) *
                            100,
                          0
                        ),
                        100
                      )),
                      h.classList.toggle("inventory-bar--hidden", 0 === p),
                      (h.firstElementChild.style.width = "".concat(p, "%")))));
              },
            },
            {
              key: "_updateInventoryWithBackorder",
              value: function(variant, previousVariant) {
                if (!variant) return;
                
                const inventoryContainer = document.querySelector('.product-form__info-content');
                if (!inventoryContainer) return;
                
                // Get variant data from the window.productVariantsData
                const variantData = window.productVariantsData ? window.productVariantsData[variant.id] : null;
                
                if (!variantData) return;
                
                // Get shipping time handle and value
                const shippingHandle = variantData.shipping_time ? variantData.shipping_time.handle : null;
                const shippingValue = variantData.shipping_time ? variantData.shipping_time.value : null;
                
                let showInStock = false;
                let showBackorder = false;
                let showOutOfStock = false;
                let useShippingLogic = false;
                
                if (shippingHandle) {
                  useShippingLogic = true;
                  
                  // Split the handle by dash and get the last part
                  const handleParts = shippingHandle.split('-');
                  const lastPart = handleParts[handleParts.length - 1];
                  
                  // Check the last part to determine time unit
                  if (shippingHandle === 'today' || lastPart === 'hours') {
                    // Today or hours - show stock status
                    if (variant.available) {
                      showInStock = true;
                    } else {
                      showOutOfStock = true;
                    }
                  } else if (lastPart === 'weeks') {
                    // Weeks - show backorder
                    showBackorder = true;
                  } else if (lastPart === 'days') {
                    // Days - show stock status  
                    if (variant.available) {
                      showInStock = true;
                    } else {
                      showOutOfStock = true;
                    }
                  }
                }
                
                // Update inventory display
                const inventorySpan = inventoryContainer.querySelector('.product-form__inventory');
                if (inventorySpan) {
                  // Clear existing classes
                  inventorySpan.className = 'product-form__inventory inventory';
                  
                  if (useShippingLogic) {
                    if (showOutOfStock) {
                      inventorySpan.innerHTML = window.languages.productFormSoldOut || 'Sold out';
                    } else if (showBackorder) {
                      inventorySpan.classList.add('inventory--backorder', 'custom-product-inventory--backorder');
                      inventorySpan.className += ' !text-sm !font-medium !text-red-400 tracking-[.21px]';
                      inventorySpan.innerHTML = window.translations?.custom?.backorder || 'Backorder';
                    } else if (showInStock) {
                      inventorySpan.classList.add('inventory--high', 'custom-product-inventory--high');
                      inventorySpan.innerHTML = window.translations?.custom?.in_stock || 'In stock';
                    }
                  } else {
                    // Fallback to original logic if no shipping time
                    if (variant.available) {
                      if (variantData.backorder) {
                        inventorySpan.classList.add('inventory--backorder', 'custom-product-inventory--backorder');
                        inventorySpan.className += ' !text-sm !font-medium !text-red-400 tracking-[.21px]';
                        inventorySpan.innerHTML = window.translations?.custom?.backorder || 'Backorder';
                      } else {
                        inventorySpan.classList.add('inventory--high', 'custom-product-inventory--high');
                        inventorySpan.innerHTML = window.translations?.custom?.in_stock || 'In stock';
                      }
                    } else {
                      inventorySpan.innerHTML = window.languages.productFormSoldOut || 'Sold out';
                    }
                  }
                }
                
                // Update shipping text
                const shippingElement = document.getElementById('shipping_here');
                if (shippingElement && shippingValue) {
                  shippingElement.innerHTML = shippingValue;
                } else if (shippingElement && variantData.shipping) {
                  shippingElement.innerHTML = variantData.shipping;
                }
              },
            },
            {
              key: "_changeDescriptionContent",
              value: function (e, t) {
                // console.log("Description update function called.");
                
                if (window.productVariantsData && e && window.productVariantsData[e.id]) {
                  const variantData = window.productVariantsData[e.id];
                  const whatsIncluded = variantData.whats_included;
                  
                  if (whatsIncluded && Array.isArray(whatsIncluded) && whatsIncluded.length > 0) {
                    
                    // Update Key Features section
                    const keyFeaturesContainer = document.querySelector('.key-features ul');
                    if (keyFeaturesContainer) {
                      
                      keyFeaturesContainer.innerHTML = '';
                      
                      // Add features from whats_included variants that have shortDescription
                      whatsIncluded.forEach(function(item) {
                        if (item.shortDescription && item.shortDescription.trim() !== '') {
                          const li = document.createElement('li');
                          li.innerHTML = item.shortDescription;
                          keyFeaturesContainer.appendChild(li);
                        }
                      });
                    }
                    
                    // Update What's Included section
                    const whatsIncludedContainer = document.querySelector('.whats-included .included-items');
                    if (whatsIncludedContainer) {
                      
                      whatsIncludedContainer.innerHTML = '';
                      
                      // Add product titles from whats_included variants
                      whatsIncluded.forEach(function(item) {
                        if (item.productTitle && item.productTitle.trim() !== '') {
                          const li = document.createElement('li');
                          li.classList.add('included-item', 'mb-2');
                          
                          // Create content with product title and variant title
                          // let content = '<a href="' + item.productUrl + '">' + item.productTitle + '</a>';
                          let content =  item.productTitle;


                          
                          li.innerHTML = content;
                          whatsIncludedContainer.appendChild(li);
                        }
                      });
                    }
                    
                  } else {
                    // Clear sections if no whats_included data
                    const keyFeaturesContainer = document.querySelector('.key-features ul');
                    const whatsIncludedContainer = document.querySelector('.whats-included .included-items');
                    
                    if (keyFeaturesContainer) {
                      keyFeaturesContainer.innerHTML = '';
                    }
                    if (whatsIncludedContainer) {
                      whatsIncludedContainer.innerHTML = '';
                    }
                  }
                }
              }
            },
            {
              key: "_updateVariantMetafieldBtnLink",
              value: function (e, t){
                const variantMetafieldBtn = document.querySelector('.edit-variant-metafield-custom-btn');

                if(variantMetafieldBtn){
                  let url = `https://admin.shopify.com/store/bayland/products/${this.productData.id}/variants/${e.id}/metafields`;
                  variantMetafieldBtn.setAttribute('href', url);
                }
              }
            },
            {
              key: "_updateSku",
              value: function (e, t) {
                var i,
                  n = this.element.querySelector(".product-meta__sku");

                // Update SKU display
                if (n) {
                  i = n.querySelector(".product-meta__sku-number");
                  if (e && e.sku !== "") {
                    if (!t || t.sku !== e.sku) {
                      i.innerHTML = e.sku;
                      n.style.display = "";
                    }
                  } else {
                    n.style.display = "none";
                  }
                }

                // Set data-product-variant on compare checkbox
                var checkbox = this.element.querySelector(
                  ".product-block-list__item--info .compare-checkbox"
                );
                if (checkbox && e && e.id) {
                  checkbox.setAttribute("data-product-variant", e.id);
                }
              },
            },
            {
              key: "_updateDiscountLabel",
              value: function (e, t) {
                var i, n;
                !window.theme.showDiscount ||
                  ((i = this.element.querySelector(
                    ".product-meta .product-label--on-sale"
                  )) &&
                    (e && e.price < e.compare_at_price
                      ? ((n = null),
                        (n =
                          "percentage" === window.theme.discountMode
                            ? "".concat(
                                Math.round(
                                  (100 * (e.compare_at_price - e.price)) /
                                    e.compare_at_price
                                ),
                                "%"
                              )
                            : "<span>".concat(
                                B.formatMoney(
                                  e.compare_at_price - e.price,
                                  window.theme.moneyFormat
                                ).replace(/\.00$/, ""),
                                "</span>"
                              )),
                        (i.innerHTML = "".concat(
                          window.languages.collectionOnSaleLabel.replace(
                            "{{savings}}",
                            n
                          )
                        )),
                        (i.style.display = "inline-block"))
                      : (i.style.display = "none")));
              },
            },
            {
              key: "_updateUnitPrice",
              value: function (e, t) {
                var i,
                  n = this.element.querySelector(".unit-price-measurement");
                n &&
                  (e && e.unit_price_measurement
                    ? ((n.parentNode.style.display = "block"),
                      (n.querySelector(
                        ".unit-price-measurement__price"
                      ).innerHTML = B.formatMoney(
                        e.unit_price,
                        window.theme.moneyFormat
                      )),
                      (n.querySelector(
                        ".unit-price-measurement__reference-unit"
                      ).innerHTML = e.unit_price_measurement.reference_unit),
                      ((i = n.querySelector(
                        ".unit-price-measurement__reference-value"
                      )).innerHTML = e.unit_price_measurement.reference_value),
                      (i.style.display =
                        1 === e.unit_price_measurement.reference_value
                          ? "none"
                          : "inline"))
                    : (n.parentNode.style.display = "none"));
              },
            },
            {
              key: "_updateSelectors",
              value: function (e) {
                function i(e, t, i) {
                  switch (e.getAttribute("data-selector-type")) {
                    case "color":
                      e.querySelector(
                        ".color-swatch:nth-child(".concat(t + 1, ")")
                      ).classList.toggle("color-swatch--disabled", !i);
                      break;
                    case "variant":
                      e.querySelector(
                        ".variant-swatch:nth-child(".concat(t + 1, ")")
                      ).classList.toggle("variant-swatch--disabled", !i);
                      break;
                    case "block":
                      e.querySelector(
                        ".block-swatch:nth-child(".concat(t + 1, ")")
                      ).classList.toggle("block-swatch--disabled", !i);
                  }
                }
                var n = this;
                this.variantSelectors &&
                  this.variantSelectors[0] &&
                  this.productOptionsWithValues[0].values.forEach(function (
                    t,
                    e
                  ) {
                    i(
                      n.variantSelectors[0],
                      e,
                      n.productData.variants.some(function (e) {
                        return e.option1 === t && e.available;
                      })
                    ),
                      n.variantSelectors[1] &&
                        n.productOptionsWithValues[1].values.forEach(function (
                          t,
                          e
                        ) {
                          i(
                            n.variantSelectors[1],
                            e,
                            n.productData.variants.some(function (e) {
                              return (
                                e.option2 === t &&
                                e.option1 === n.option1 &&
                                e.available
                              );
                            })
                          ),
                            n.variantSelectors[2] &&
                              n.productOptionsWithValues[2].values.forEach(
                                function (t, e) {
                                  i(
                                    n.variantSelectors[2],
                                    e,
                                    n.productData.variants.some(function (e) {
                                      return (
                                        e.option3 === t &&
                                        e.option1 === n.option1 &&
                                        e.option2 === n.option2 &&
                                        e.available
                                      );
                                    })
                                  );
                                }
                              );
                        });
                  });
              },
            },
            {
              key: "_updateAddToCartButton",
              value: function (e) {
                var t = this.element.querySelector(".product-form__add-button"),
                  i = this.element.querySelector(".product-form__info-list");
                t &&
                  (e
                    ? ((i.style.display = "block"),
                      e.available
                        ? (t.removeAttribute("disabled"),
                          t.classList.remove("button--disabled"),
                          t.classList.add("button--primary"),
                          t.setAttribute("data-action", "add-to-cart"),
                          (t.innerHTML =
                            "pre-order" === this.productTemplate
                              ? window.languages.productFormPreOrder
                              : window.languages.productFormAddToCart),
                          jQuery(".flinine").show(),
                          jQuery(".flinine .service-list").show(),
                          jQuery(
                            ".product-form__info-list .product-form__info-content"
                          ).css("display", ""),
                          jQuery(".free-shipp").css("display", ""),
                          jQuery(".product-form__variants .stock-av").show(),
                          jQuery(".product-add-on-section").css("display", ""),
                          jQuery(
                            ".product-meta .product-meta__label-list"
                          ).show())
                        : (t.setAttribute("disabled", "disabled"),
                          t.classList.add("button--disabled"),
                          t.classList.remove("button--primary"),
                          t.removeAttribute("data-action"),
                          (t.innerHTML = window.languages.productFormSoldOut),
                          jQuery(".product-form__variants .stock-av").hide()))
                    : (t.setAttribute("disabled", "disabled"),
                      t.classList.add("button--disabled"),
                      t.classList.remove("button--primary"),
                      t.removeAttribute("data-action"),
                      (t.innerHTML = window.languages.productFormUnavailable),
                      (i.style.display = "none")),
                  !this.options.showPaymentButton ||
                    ((i = this.element.querySelector(
                      ".shopify-payment-button"
                    )) &&
                      (e && e.available
                        ? (i.style.display = "block")
                        : (i.style.display = "none"))));
              },
            },
            {
              key: "_onOptionChanged",
              value: function (e, t) {
                (this["option" + t.getAttribute("data-option-position")] =
                  t.value),
                  this._getCurrentVariantFromOptions().available ||
                    (function (t) {
                      let i = !0;
                      for (let e = 0; e < t.length; e++)
                        if (t[e].available) {
                          i = !1;
                          break;
                        }
                      return i;
                    })(this.productData.variants) ||
                    ((i = (function (t, i) {
                      let n = -1;
                      for (let e = 0; e < t.length; e++)
                        if (t[e].id === i) {
                          n = e;
                          break;
                        }
                      for (;;) {
                        var e = (n + 1) % t.length;
                        if (t[e].available) return e;
                        n += 1;
                      }
                    })(
                      this.productData.variants,
                      this._getCurrentVariantFromOptions().id
                    )),
                    (function (n) {
                      if (n.options && n.options.length)
                        for (let i = 0; i < n.options.length; i++) {
                          var e = '[data-option-position="' + (i + 1) + '"]';
                          const o = document.querySelectorAll(e);
                          let t = !1;
                          o.forEach((e) => {
                            e.checked && e.value == n.options[i] && (t = !0);
                          }),
                            t ||
                              o.forEach((e) => {
                                var t;
                                e.value == n.options[i] &&
                                  ((e.checked = !0),
                                  (t = new Event("change", { bubbles: !0 })),
                                  e.dispatchEvent(t));
                              });
                        }
                    })(this.productData.variants[i]));
                var i = t
                  .closest(".product-form__option")
                  .querySelector(".product-form__selected-value");
                i && (i.innerHTML = t.value);
                t = this.currentVariant;
                (this.currentVariant = this._getCurrentVariantFromOptions()),
                  this._onVariantChanged(t, this.currentVariant),
                  this.currentVariant &&
                    (this.options.enableHistoryState &&
                      history.replaceState &&
                      ((n = ""
                        .concat(window.location.protocol, "//")
                        .concat(window.location.host)
                        .concat(window.location.pathname, "?variant=")
                        .concat(this.currentVariant.id)),
                      window.history.replaceState({ path: n }, "", n)),
                    this.masterSelector
                      .querySelector("[selected]")
                      .removeAttribute("selected"),
                    this.masterSelector
                      .querySelector(
                        '[value="'.concat(this.currentVariant.id, '"]')
                      )
                      .setAttribute("selected", "selected"));
                var n = jQuery(".select-wrapper select").val();
                jQuery(".addon-product-list > li." + n).length;
                jQuery(".addon-product-list li .add-on-access-checkbox").prop(
                  "checked",
                  !1
                ),
                  jQuery(".product." + n).show(),
                  renderProductRecommendedAddonsDynamically(n),
                  "USD" == Shopify.currency.active &&
                    renderVariantWiseshopPay(this.currentVariant),
                  renderNewRenewedData(this.currentVariant);
              },
            },
            {
              key: "_getCurrentVariantFromOptions",
              value: function () {
                var t = this,
                  i = !1;
                return (
                  this.productData.variants.forEach(function (e) {
                    e.option1 === t.option1 &&
                      e.option2 === t.option2 &&
                      e.option3 === t.option3 &&
                      (i = e);
                  }),
                  i || null
                );
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i = this,
                  n = this.element.querySelector('form[action*="/cart/add"]');
                n.reportValidity() &&
                  "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  setTimeout(function () {
                    fetch("".concat(window.routes.cartAddUrl, ".js"), {
                      body: JSON.stringify(R.serialize(n)),
                      credentials: "same-origin",
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                      },
                    }).then(function (e) {
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      ),
                      e.ok
                      ? (i.element.dispatchEvent(
                            new CustomEvent("product:added", {
                              bubbles: !0,
                              detail: {
                                variant: i.currentVariant,
                                button: t,
                                quantity: parseInt(
                                  n.querySelector('[name="quantity"]').value
                                ),
                              },
                            })
                          ),
                          openCart(),
                          window.dispatchEvent(new CustomEvent('product:added_to_cart', {
                            detail: {
                              currency: window.Shopify.currency.active,
                              value: i.currentVariant.price * parseInt(
                                  n.querySelector('[name="quantity"]').value
                                ) / 100,
                              items: [
                                {
                                  item_id: i.productData.id || undefined,
                                  item_sku: i.currentVariant.sku || undefined,
                                  variant_id: i.currentVariant.id || undefined,
                                  item_name: i.productData.title || "Unknown Product",
                                  item_brand: i.productData.vendor || "Unknown",
                                  item_category: i.productData.type || "Uncategorized",
                                  item_variant: i.currentVariant.name || undefined,
                                  price: i.currentVariant.price / 100,
                                  quantity: parseInt(
                                    n.querySelector('[name="quantity"]').value
                                  )
                                }
                              ]
                            }
                          })),
                          i.options.isQuickView &&
                            "drawer" === window.theme.cartType &&
                            document.dispatchEvent(
                              new CustomEvent("modal:close")
                            ),
                          "message" === window.theme.cartType &&
                            i._showAlert(
                              window.languages.productAdded,
                              "success",
                              t
                            ))
                      : e.json().then(function (e) {
                          i._showAlert(e.description, "error", t);
                          openCart();
                        });                    
                    }),
                      e.preventDefault();
                  }, 1e3));
              },
            },
            {
              key: "_setupStockCountdown",
              value: function () {
                var t,
                  i,
                  n = this,
                  o = this.element.querySelector(".inventory-bar");
                o &&
                  ((t = function () {
                    var e =
                        n.variantsInventories[n.currentVariant.id]
                          .inventory_quantity,
                      e = Math.min(
                        Math.max(
                          (e /
                            parseInt(
                              o.getAttribute("data-stock-countdown-max")
                            )) *
                            100,
                          0
                        ),
                        100
                      );
                    o.classList.toggle("inventory-bar--hidden", 0 === e),
                      (o.firstElementChild.style.width = "".concat(e, "%"));
                  }),
                  window.IntersectionObserver
                    ? (i = new IntersectionObserver(function (e) {
                        e.forEach(function (e) {
                          e.isIntersecting && (t(), i.disconnect());
                        });
                      })).observe(o)
                    : t());
              },
            },
            {
              key: "_showAlert",
              value: function (e, t, i) {
                var n = document.createElement("div");
                (n.className = "product-form__status-message"),
                  (n.innerHTML = '<p class="alert '
                    .concat(
                      "success" === t ? "alert--success" : "alert--error",
                      '">'
                    )
                    .concat(e, "</p>")),
                  i.removeAttribute("disabled"),
                  i.parentNode.insertAdjacentElement("afterend", n),
                  y.slideDown(n),
                  setTimeout(function () {
                    y.slideUp(n, function () {
                      n.remove();
                    });
                  }, 5500);
              },
            },
          ]),
          o
        );
      })(),
      F = t(function (e) {
        var t, i;
        (t = "undefined" != typeof window ? window : w),
          (i = function () {
            function e() {}
            var t = e.prototype;
            return (
              (t.on = function (e, t) {
                if (e && t) {
                  var i = (this._events = this._events || {}),
                    e = (i[e] = i[e] || []);
                  return -1 == e.indexOf(t) && e.push(t), this;
                }
              }),
              (t.once = function (e, t) {
                if (e && t) {
                  this.on(e, t);
                  var i = (this._onceEvents = this._onceEvents || {});
                  return ((i[e] = i[e] || {})[t] = !0), this;
                }
              }),
              (t.off = function (e, t) {
                e = this._events && this._events[e];
                if (e && e.length) {
                  t = e.indexOf(t);
                  return -1 != t && e.splice(t, 1), this;
                }
              }),
              (t.emitEvent = function (e, t) {
                var i = this._events && this._events[e];
                if (i && i.length) {
                  (i = i.slice(0)), (t = t || []);
                  for (
                    var n = this._onceEvents && this._onceEvents[e], o = 0;
                    o < i.length;
                    o++
                  ) {
                    var s = i[o];
                    n && n[s] && (this.off(e, s), delete n[s]),
                      s.apply(this, t);
                  }
                  return this;
                }
              }),
              (t.allOff = function () {
                delete this._events, delete this._onceEvents;
              }),
              e
            );
          }),
          e.exports ? (e.exports = i()) : (t.EvEmitter = i());
      }),
      U = t(function (e) {
        var t, i;
        (t = window),
          (i = function () {
            function p(e) {
              var t = parseFloat(e);
              return -1 == e.indexOf("%") && !isNaN(t) && t;
            }
            var t =
                "undefined" == typeof console
                  ? function () {}
                  : function (e) {
                      console.error(e);
                    },
              m = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
              ],
              f = m.length;
            function g(e) {
              e = getComputedStyle(e);
              return (
                e ||
                  t(
                    "Style returned " +
                      e +
                      ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                  ),
                e
              );
            }
            var v,
              y = !1;
            function b(e) {
              if (
                (y ||
                  ((y = !0),
                  ((h = document.createElement("div")).style.width = "200px"),
                  (h.style.padding = "1px 2px 3px 4px"),
                  (h.style.borderStyle = "solid"),
                  (h.style.borderWidth = "1px 2px 3px 4px"),
                  (h.style.boxSizing = "border-box"),
                  (u = document.body || document.documentElement).appendChild(
                    h
                  ),
                  (d = g(h)),
                  (v = 200 == Math.round(p(d.width))),
                  (b.isBoxSizeOuter = v),
                  u.removeChild(h)),
                "string" == typeof e && (e = document.querySelector(e)),
                e && "object" == wi(e) && e.nodeType)
              ) {
                var t = g(e);
                if ("none" == t.display)
                  return (function () {
                    for (
                      var e = {
                          width: 0,
                          height: 0,
                          innerWidth: 0,
                          innerHeight: 0,
                          outerWidth: 0,
                          outerHeight: 0,
                        },
                        t = 0;
                      t < f;
                      t++
                    )
                      e[m[t]] = 0;
                    return e;
                  })();
                var i = {};
                (i.width = e.offsetWidth), (i.height = e.offsetHeight);
                for (
                  var n = (i.isBorderBox = "border-box" == t.boxSizing), o = 0;
                  o < f;
                  o++
                ) {
                  var s = m[o],
                    a = t[s],
                    a = parseFloat(a);
                  i[s] = isNaN(a) ? 0 : a;
                }
                var r = i.paddingLeft + i.paddingRight,
                  l = i.paddingTop + i.paddingBottom,
                  c = i.marginLeft + i.marginRight,
                  d = i.marginTop + i.marginBottom,
                  u = i.borderLeftWidth + i.borderRightWidth,
                  h = i.borderTopWidth + i.borderBottomWidth,
                  e = n && v,
                  n = p(t.width);
                !1 !== n && (i.width = n + (e ? 0 : r + u));
                n = p(t.height);
                return (
                  !1 !== n && (i.height = n + (e ? 0 : l + h)),
                  (i.innerWidth = i.width - (r + u)),
                  (i.innerHeight = i.height - (l + h)),
                  (i.outerWidth = i.width + c),
                  (i.outerHeight = i.height + d),
                  i
                );
              }
            }
            return b;
          }),
          e.exports ? (e.exports = i()) : (t.getSize = i());
      }),
      W = t(function (e) {
        var t, i;
        (t = window),
          (i = function () {
            var i = (function () {
              var e = window.Element.prototype;
              if (e.matches) return "matches";
              if (e.matchesSelector) return "matchesSelector";
              for (
                var t = ["webkit", "moz", "ms", "o"], i = 0;
                i < t.length;
                i++
              ) {
                var n = t[i] + "MatchesSelector";
                if (e[n]) return n;
              }
            })();
            return function (e, t) {
              return e[i](t);
            };
          }),
          e.exports ? (e.exports = i()) : (t.matchesSelector = i());
      }),
      j = t(function (e) {
        var t, i;
        (t = window),
          (i = function (i, s) {
            var c = {
                extend: function (e, t) {
                  for (var i in t) e[i] = t[i];
                  return e;
                },
                modulo: function (e, t) {
                  return ((e % t) + t) % t;
                },
              },
              t = Array.prototype.slice;
            (c.makeArray = function (e) {
              return Array.isArray(e)
                ? e
                : null == e
                ? []
                : "object" == wi(e) && "number" == typeof e.length
                ? t.call(e)
                : [e];
            }),
              (c.removeFrom = function (e, t) {
                t = e.indexOf(t);
                -1 != t && e.splice(t, 1);
              }),
              (c.getParent = function (e, t) {
                for (; e.parentNode && e != document.body; )
                  if (((e = e.parentNode), s(e, t))) return e;
              }),
              (c.getQueryElement = function (e) {
                return "string" == typeof e ? document.querySelector(e) : e;
              }),
              (c.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
              }),
              (c.filterFindElements = function (e, n) {
                e = c.makeArray(e);
                var o = [];
                return (
                  e.forEach(function (e) {
                    if (e instanceof HTMLElement)
                      if (n) {
                        s(e, n) && o.push(e);
                        for (
                          var t = e.querySelectorAll(n), i = 0;
                          i < t.length;
                          i++
                        )
                          o.push(t[i]);
                      } else o.push(e);
                  }),
                  o
                );
              }),
              (c.debounceMethod = function (e, t, n) {
                n = n || 100;
                var o = e.prototype[t],
                  s = t + "Timeout";
                e.prototype[t] = function () {
                  var e = this[s];
                  clearTimeout(e);
                  var t = arguments,
                    i = this;
                  this[s] = setTimeout(function () {
                    o.apply(i, t), delete i[s];
                  }, n);
                };
              }),
              (c.docReady = function (e) {
                var t = document.readyState;
                "complete" == t || "interactive" == t
                  ? setTimeout(e)
                  : document.addEventListener("DOMContentLoaded", e);
              }),
              (c.toDashed = function (e) {
                return e
                  .replace(/(.)([A-Z])/g, function (e, t, i) {
                    return t + "-" + i;
                  })
                  .toLowerCase();
              });
            var d = i.console;
            return (
              (c.htmlInit = function (r, l) {
                c.docReady(function () {
                  var e = c.toDashed(l),
                    o = "data-" + e,
                    t = document.querySelectorAll("[" + o + "]"),
                    e = document.querySelectorAll(".js-" + e),
                    e = c.makeArray(t).concat(c.makeArray(e)),
                    s = o + "-options",
                    a = i.jQuery;
                  e.forEach(function (t) {
                    var e,
                      i = t.getAttribute(o) || t.getAttribute(s);
                    try {
                      e = i && JSON.parse(i);
                    } catch (e) {
                      return void (
                        d &&
                        d.error(
                          "Error parsing " + o + " on " + t.className + ": " + e
                        )
                      );
                    }
                    var n = new r(t, e);
                    a && a.data(t, l, n);
                  });
                });
              }),
              c
            );
          }),
          e.exports
            ? (e.exports = i(t, W))
            : (t.fizzyUIUtils = i(t, t.matchesSelector));
      }),
      V = t(function (e) {
        var t, i;
        (t = window),
          (i = function (e, t) {
            function i(e, t) {
              (this.element = e), (this.parent = t), this.create();
            }
            var n = i.prototype;
            return (
              (n.create = function () {
                (this.element.style.position = "absolute"),
                  this.element.setAttribute("aria-hidden", "true"),
                  (this.x = 0),
                  (this.shift = 0);
              }),
              (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var e = this.parent.originSide;
                this.element.style[e] = "";
              }),
              (n.getSize = function () {
                this.size = t(this.element);
              }),
              (n.setPosition = function (e) {
                (this.x = e), this.updateTarget(), this.renderPosition(e);
              }),
              (n.updateTarget = n.setDefaultTarget =
                function () {
                  var e =
                    "left" == this.parent.originSide
                      ? "marginLeft"
                      : "marginRight";
                  this.target =
                    this.x +
                    this.size[e] +
                    this.size.width * this.parent.cellAlign;
                }),
              (n.renderPosition = function (e) {
                var t = this.parent.originSide;
                this.element.style[t] = this.parent.getPositionValue(e);
              }),
              (n.select = function () {
                this.element.classList.add("is-selected"),
                  this.element.removeAttribute("aria-hidden");
              }),
              (n.unselect = function () {
                this.element.classList.remove("is-selected"),
                  this.element.setAttribute("aria-hidden", "true");
              }),
              (n.wrapShift = function (e) {
                (this.shift = e),
                  this.renderPosition(this.x + this.parent.slideableWidth * e);
              }),
              (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
              }),
              i
            );
          }),
          e.exports
            ? (e.exports = i(0, U))
            : ((t.Flickity = t.Flickity || {}),
              (t.Flickity.Cell = i(0, t.getSize)));
      }),
      X = t(function (e) {
        var t, i;
        (t = window),
          (i = function () {
            function e(e) {
              (this.parent = e),
                (this.isOriginLeft = "left" == e.originSide),
                (this.cells = []),
                (this.outerWidth = 0),
                (this.height = 0);
            }
            var t = e.prototype;
            return (
              (t.addCell = function (e) {
                var t;
                this.cells.push(e),
                  (this.outerWidth += e.size.outerWidth),
                  (this.height = Math.max(e.size.outerHeight, this.height)),
                  1 == this.cells.length &&
                    ((this.x = e.x),
                    (t = this.isOriginLeft ? "marginLeft" : "marginRight"),
                    (this.firstMargin = e.size[t]));
              }),
              (t.updateTarget = function () {
                var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                  t = this.getLastCell(),
                  e = t ? t.size[e] : 0,
                  e = this.outerWidth - (this.firstMargin + e);
                this.target =
                  this.x + this.firstMargin + e * this.parent.cellAlign;
              }),
              (t.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (t.select = function () {
                this.cells.forEach(function (e) {
                  e.select();
                });
              }),
              (t.unselect = function () {
                this.cells.forEach(function (e) {
                  e.unselect();
                });
              }),
              (t.getCellElements = function () {
                return this.cells.map(function (e) {
                  return e.element;
                });
              }),
              e
            );
          }),
          e.exports
            ? (e.exports = i())
            : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = i()));
      }),
      Q = t(function (e) {
        var t, i;
        (t = window),
          (i = function (e, t) {
            var i = {
              startAnimation: function () {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  (this.restingFrames = 0),
                  this.animate());
              },
              animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var e,
                  t = this.x;
                this.integratePhysics(),
                  this.positionSlider(),
                  this.settle(t),
                  this.isAnimating &&
                    ((e = this),
                    requestAnimationFrame(function () {
                      e.animate();
                    }));
              },
              positionSlider: function () {
                var e = this.x;
                this.options.wrapAround &&
                  1 < this.cells.length &&
                  ((e = t.modulo(e, this.slideableWidth)),
                  (e -= this.slideableWidth),
                  this.shiftWrapCells(e)),
                  this.setTranslateX(e, this.isAnimating),
                  this.dispatchScrollEvent();
              },
              setTranslateX: function (e, t) {
                (e += this.cursorPosition),
                  (e = this.options.rightToLeft ? -e : e);
                e = this.getPositionValue(e);
                this.slider.style.transform = t
                  ? "translate3d(" + e + ",0,0)"
                  : "translateX(" + e + ")";
              },
              dispatchScrollEvent: function () {
                var e,
                  t = this.slides[0];
                t &&
                  ((t = (e = -this.x - t.target) / this.slidesWidth),
                  this.dispatchEvent("scroll", null, [t, e]));
              },
              positionSliderAtSelected: function () {
                this.cells.length &&
                  ((this.x = -this.selectedSlide.target),
                  (this.velocity = 0),
                  this.positionSlider());
              },
              getPositionValue: function (e) {
                return this.options.percentPosition
                  ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%"
                  : Math.round(e) + "px";
              },
              settle: function (e) {
                this.isPointerDown ||
                  Math.round(100 * this.x) != Math.round(100 * e) ||
                  this.restingFrames++,
                  2 < this.restingFrames &&
                    ((this.isAnimating = !1),
                    delete this.isFreeScrolling,
                    this.positionSlider(),
                    this.dispatchEvent("settle", null, [this.selectedIndex]));
              },
              shiftWrapCells: function (e) {
                var t = this.cursorPosition + e;
                this._shiftCells(this.beforeShiftCells, t, -1);
                e =
                  this.size.innerWidth -
                  (e + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, e, 1);
              },
              _shiftCells: function (e, t, i) {
                for (var n = 0; n < e.length; n++) {
                  var o = e[n],
                    s = 0 < t ? i : 0;
                  o.wrapShift(s), (t -= o.size.outerWidth);
                }
              },
              _unshiftCells: function (e) {
                if (e && e.length)
                  for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
              },
              integratePhysics: function () {
                (this.x += this.velocity),
                  (this.velocity *= this.getFrictionFactor());
              },
              applyForce: function (e) {
                this.velocity += e;
              },
              getFrictionFactor: function () {
                return (
                  1 -
                  this.options[
                    this.isFreeScrolling ? "freeScrollFriction" : "friction"
                  ]
                );
              },
              getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
              },
              applyDragForce: function () {
                var e;
                this.isDraggable &&
                  this.isPointerDown &&
                  ((e = this.dragX - this.x - this.velocity),
                  this.applyForce(e));
              },
              applySelectedAttraction: function () {
                var e;
                (this.isDraggable && this.isPointerDown) ||
                  this.isFreeScrolling ||
                  !this.slides.length ||
                  ((e =
                    (-1 * this.selectedSlide.target - this.x) *
                    this.options.selectedAttraction),
                  this.applyForce(e));
              },
            };
            return i;
          }),
          e.exports
            ? (e.exports = i(0, j))
            : ((t.Flickity = t.Flickity || {}),
              (t.Flickity.animatePrototype = i(0, t.fizzyUIUtils)));
      }),
      Y = t(function (e) {
        var t, i;
        (t = window),
          (i = function (n, e, t, a, i, r, o) {
            var s = n.jQuery,
              l = n.getComputedStyle,
              c = n.console;
            function d(e, t) {
              for (e = a.makeArray(e); e.length; ) t.appendChild(e.shift());
            }
            var u = 0,
              h = {};
            function p(e, t) {
              var i = a.getQueryElement(e);
              if (i) {
                if (((this.element = i), this.element.flickityGUID)) {
                  var n = h[this.element.flickityGUID];
                  return n.option(t), n;
                }
                s && (this.$element = s(this.element)),
                  (this.options = a.extend({}, this.constructor.defaults)),
                  this.option(t),
                  this._create();
              } else c && c.error("Bad element for Flickity: " + (i || e));
            }
            (p.defaults = {
              accessibility: !0,
              cellAlign: "center",
              freeScrollFriction: 0.075,
              friction: 0.28,
              namespaceJQueryEvents: !0,
              percentPosition: !0,
              resize: !0,
              selectedAttraction: 0.025,
              setGallerySize: !0,
            }),
              (p.createMethods = []);
            var m = p.prototype;
            a.extend(m, e.prototype),
              (m._create = function () {
                var e,
                  t = (this.guid = ++u);
                for (e in ((this.element.flickityGUID = t),
                ((h[t] = this).selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickity-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) &&
                  n.addEventListener("resize", this),
                this.options.on)) {
                  var i = this.options.on[e];
                  this.on(e, i);
                }
                p.createMethods.forEach(function (e) {
                  this[e]();
                }, this),
                  this.options.watchCSS ? this.watchCSS() : this.activate();
              }),
              (m.option = function (e) {
                a.extend(this.options, e);
              }),
              (m.activate = function () {
                this.isActive ||
                  ((this.isActive = !0),
                  this.element.classList.add("flickity-enabled"),
                  this.options.rightToLeft &&
                    this.element.classList.add("flickity-rtl"),
                  this.getSize(),
                  d(
                    this._filterFindCellElements(this.element.children),
                    this.slider
                  ),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility &&
                    ((this.element.tabIndex = 0),
                    this.element.addEventListener("keydown", this)),
                  this.emitEvent("activate"),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent("ready"));
              }),
              (m._createSlider = function () {
                var e = document.createElement("div");
                (e.className = "flickity-slider"),
                  (e.style[this.originSide] = 0),
                  (this.slider = e);
              }),
              (m._filterFindCellElements = function (e) {
                return a.filterFindElements(e, this.options.cellSelector);
              }),
              (m.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize();
              }),
              (m._makeCells = function (e) {
                return this._filterFindCellElements(e).map(function (e) {
                  return new i(e, this);
                }, this);
              }),
              (m.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (m.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
              }),
              (m.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
              }),
              (m._positionCells = function (e) {
                (e = e || 0),
                  (this.maxCellHeight = (e && this.maxCellHeight) || 0);
                var t,
                  i = 0;
                0 < e && (i = (t = this.cells[e - 1]).x + t.size.outerWidth);
                for (var n = this.cells.length, o = e; o < n; o++) {
                  var s = this.cells[o];
                  s.setPosition(i),
                    (i += s.size.outerWidth),
                    (this.maxCellHeight = Math.max(
                      s.size.outerHeight,
                      this.maxCellHeight
                    ));
                }
                (this.slideableWidth = i),
                  this.updateSlides(),
                  this._containSlides(),
                  (this.slidesWidth = n
                    ? this.getLastSlide().target - this.slides[0].target
                    : 0);
              }),
              (m._sizeCells = function (e) {
                e.forEach(function (e) {
                  e.getSize();
                });
              }),
              (m.updateSlides = function () {
                var n, o, s;
                (this.slides = []),
                  this.cells.length &&
                    ((n = new r(this)),
                    this.slides.push(n),
                    (o =
                      "left" == this.originSide ? "marginRight" : "marginLeft"),
                    (s = this._getCanCellFit()),
                    this.cells.forEach(function (e, t) {
                      var i;
                      n.cells.length &&
                        ((i =
                          n.outerWidth -
                          n.firstMargin +
                          (e.size.outerWidth - e.size[o])),
                        s.call(this, t, i) ||
                          (n.updateTarget(),
                          (n = new r(this)),
                          this.slides.push(n))),
                        n.addCell(e);
                    }, this),
                    n.updateTarget(),
                    this.updateSelectedSlide());
              }),
              (m._getCanCellFit = function () {
                var e = this.options.groupCells;
                if (!e)
                  return function () {
                    return !1;
                  };
                if ("number" == typeof e) {
                  var t = parseInt(e, 10);
                  return function (e) {
                    return e % t != 0;
                  };
                }
                var e = "string" == typeof e && e.match(/^(\d+)%$/),
                  i = e ? parseInt(e[1], 10) / 100 : 1;
                return function (e, t) {
                  return t <= (this.size.innerWidth + 1) * i;
                };
              }),
              (m._init = m.reposition =
                function () {
                  this.positionCells(), this.positionSliderAtSelected();
                }),
              (m.getSize = function () {
                (this.size = t(this.element)),
                  this.setCellAlign(),
                  (this.cursorPosition = this.size.innerWidth * this.cellAlign);
              });
            var f = {
              center: { left: 0.5, right: 0.5 },
              left: { left: 0, right: 1 },
              right: { right: 0, left: 1 },
            };
            return (
              (m.setCellAlign = function () {
                var e = f[this.options.cellAlign];
                this.cellAlign = e
                  ? e[this.originSide]
                  : this.options.cellAlign;
              }),
              (m.setGallerySize = function () {
                var e;
                this.options.setGallerySize &&
                  ((e =
                    this.options.adaptiveHeight && this.selectedSlide
                      ? this.selectedSlide.height
                      : this.maxCellHeight),
                  (this.viewport.style.height = e + "px"));
              }),
              (m._getWrapShiftCells = function () {
                var e, t;
                this.options.wrapAround &&
                  (this._unshiftCells(this.beforeShiftCells),
                  this._unshiftCells(this.afterShiftCells),
                  (e = this.cursorPosition),
                  (t = this.cells.length - 1),
                  (this.beforeShiftCells = this._getGapCells(e, t, -1)),
                  (e = this.size.innerWidth - this.cursorPosition),
                  (this.afterShiftCells = this._getGapCells(e, 0, 1)));
              }),
              (m._getGapCells = function (e, t, i) {
                for (var n = []; 0 < e; ) {
                  var o = this.cells[t];
                  if (!o) break;
                  n.push(o), (t += i), (e -= o.size.outerWidth);
                }
                return n;
              }),
              (m._containSlides = function () {
                var e, t, i, n, o, s;
                this.options.contain &&
                  !this.options.wrapAround &&
                  this.cells.length &&
                  ((e = (t = this.options.rightToLeft)
                    ? "marginRight"
                    : "marginLeft"),
                  (t = t ? "marginLeft" : "marginRight"),
                  (i = this.slideableWidth - this.getLastCell().size[t]),
                  (n = i < this.size.innerWidth),
                  (o = this.cursorPosition + this.cells[0].size[e]),
                  (s = i - this.size.innerWidth * (1 - this.cellAlign)),
                  this.slides.forEach(function (e) {
                    n
                      ? (e.target = i * this.cellAlign)
                      : ((e.target = Math.max(e.target, o)),
                        (e.target = Math.min(e.target, s)));
                  }, this));
              }),
              (m.dispatchEvent = function (e, t, i) {
                var n = t ? [t].concat(i) : i;
                this.emitEvent(e, n),
                  s &&
                    this.$element &&
                    ((n = e +=
                      this.options.namespaceJQueryEvents ? ".flickity" : ""),
                    t && (((t = s.Event(t)).type = e), (n = t)),
                    this.$element.trigger(n, i));
              }),
              (m.select = function (e, t, i) {
                this.isActive &&
                  ((e = parseInt(e, 10)),
                  this._wrapSelect(e),
                  (this.options.wrapAround || t) &&
                    (e = a.modulo(e, this.slides.length)),
                  this.slides[e] &&
                    ((t = this.selectedIndex),
                    (this.selectedIndex = e),
                    this.updateSelectedSlide(),
                    i ? this.positionSliderAtSelected() : this.startAnimation(),
                    this.options.adaptiveHeight && this.setGallerySize(),
                    this.dispatchEvent("select", null, [e]),
                    e != t && this.dispatchEvent("change", null, [e]),
                    this.dispatchEvent("cellSelect")));
              }),
              (m._wrapSelect = function (e) {
                var t = this.slides.length;
                if (!(this.options.wrapAround && 1 < t)) return e;
                var i = a.modulo(e, t),
                  n = Math.abs(i - this.selectedIndex),
                  o = Math.abs(i + t - this.selectedIndex),
                  i = Math.abs(i - t - this.selectedIndex);
                !this.isDragSelect && o < n
                  ? (e += t)
                  : !this.isDragSelect && i < n && (e -= t),
                  e < 0
                    ? (this.x -= this.slideableWidth)
                    : t <= e && (this.x += this.slideableWidth);
              }),
              (m.previous = function (e, t) {
                this.select(this.selectedIndex - 1, e, t);
              }),
              (m.next = function (e, t) {
                this.select(this.selectedIndex + 1, e, t);
              }),
              (m.updateSelectedSlide = function () {
                var e = this.slides[this.selectedIndex];
                e &&
                  (this.unselectSelectedSlide(),
                  (this.selectedSlide = e).select(),
                  (this.selectedCells = e.cells),
                  (this.selectedElements = e.getCellElements()),
                  (this.selectedCell = e.cells[0]),
                  (this.selectedElement = this.selectedElements[0]));
              }),
              (m.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
              }),
              (m.selectInitialIndex = function () {
                var e = this.options.initialIndex;
                if (this.isInitActivated)
                  this.select(this.selectedIndex, !1, !0);
                else {
                  if (e && "string" == typeof e)
                    if (this.queryCell(e))
                      return void this.selectCell(e, !1, !0);
                  var t = 0;
                  e && this.slides[e] && (t = e), this.select(t, !1, !0);
                }
              }),
              (m.selectCell = function (e, t, i) {
                e = this.queryCell(e);
                e && ((e = this.getCellSlideIndex(e)), this.select(e, t, i));
              }),
              (m.getCellSlideIndex = function (e) {
                for (var t = 0; t < this.slides.length; t++)
                  if (-1 != this.slides[t].cells.indexOf(e)) return t;
              }),
              (m.getCell = function (e) {
                for (var t = 0; t < this.cells.length; t++) {
                  var i = this.cells[t];
                  if (i.element == e) return i;
                }
              }),
              (m.getCells = function (e) {
                e = a.makeArray(e);
                var t = [];
                return (
                  e.forEach(function (e) {
                    e = this.getCell(e);
                    e && t.push(e);
                  }, this),
                  t
                );
              }),
              (m.getCellElements = function () {
                return this.cells.map(function (e) {
                  return e.element;
                });
              }),
              (m.getParentCell = function (e) {
                var t = this.getCell(e);
                return (
                  t ||
                  ((e = a.getParent(e, ".flickity-slider > *")),
                  this.getCell(e))
                );
              }),
              (m.getAdjacentCellElements = function (e, t) {
                if (!e) return this.selectedSlide.getCellElements();
                t = void 0 === t ? this.selectedIndex : t;
                var i = this.slides.length;
                if (i <= 1 + 2 * e) return this.getCellElements();
                for (var n = [], o = t - e; o <= t + e; o++) {
                  var s = this.options.wrapAround ? a.modulo(o, i) : o,
                    s = this.slides[s];
                  s && (n = n.concat(s.getCellElements()));
                }
                return n;
              }),
              (m.queryCell = function (e) {
                if ("number" == typeof e) return this.cells[e];
                if ("string" == typeof e) {
                  if (e.match(/^[#\.]?[\d\/]/)) return;
                  e = this.element.querySelector(e);
                }
                return this.getCell(e);
              }),
              (m.uiChange = function () {
                this.emitEvent("uiChange");
              }),
              (m.childUIPointerDown = function (e) {
                "touchstart" != e.type && e.preventDefault(), this.focus();
              }),
              (m.onresize = function () {
                this.watchCSS(), this.resize();
              }),
              a.debounceMethod(p, "onresize", 150),
              (m.resize = function () {
                var e;
                this.isActive &&
                  (this.getSize(),
                  this.options.wrapAround &&
                    (this.x = a.modulo(this.x, this.slideableWidth)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize(),
                  this.emitEvent("resize"),
                  (e = this.selectedElements && this.selectedElements[0]),
                  this.selectCell(e, !1, !0));
              }),
              (m.watchCSS = function () {
                this.options.watchCSS &&
                  (-1 != l(this.element, ":after").content.indexOf("flickity")
                    ? this.activate()
                    : this.deactivate());
              }),
              (m.onkeydown = function (e) {
                var t =
                  document.activeElement &&
                  document.activeElement != this.element;
                !this.options.accessibility ||
                  t ||
                  ((e = p.keyboardHandlers[e.keyCode]) && e.call(this));
              }),
              (p.keyboardHandlers = {
                37: function () {
                  var e = this.options.rightToLeft ? "next" : "previous";
                  this.uiChange(), this[e]();
                },
                39: function () {
                  var e = this.options.rightToLeft ? "previous" : "next";
                  this.uiChange(), this[e]();
                },
              }),
              (m.focus = function () {
                var e = n.pageYOffset;
                this.element.focus({ preventScroll: !0 }),
                  n.pageYOffset != e && n.scrollTo(n.pageXOffset, e);
              }),
              (m.deactivate = function () {
                this.isActive &&
                  (this.element.classList.remove("flickity-enabled"),
                  this.element.classList.remove("flickity-rtl"),
                  this.unselectSelectedSlide(),
                  this.cells.forEach(function (e) {
                    e.destroy();
                  }),
                  this.element.removeChild(this.viewport),
                  d(this.slider.children, this.element),
                  this.options.accessibility &&
                    (this.element.removeAttribute("tabIndex"),
                    this.element.removeEventListener("keydown", this)),
                  (this.isActive = !1),
                  this.emitEvent("deactivate"));
              }),
              (m.destroy = function () {
                this.deactivate(),
                  n.removeEventListener("resize", this),
                  this.allOff(),
                  this.emitEvent("destroy"),
                  s && this.$element && s.removeData(this.element, "flickity"),
                  delete this.element.flickityGUID,
                  delete h[this.guid];
              }),
              a.extend(m, o),
              (p.data = function (e) {
                e = (e = a.getQueryElement(e)) && e.flickityGUID;
                return e && h[e];
              }),
              a.htmlInit(p, "flickity"),
              s && s.bridget && s.bridget("flickity", p),
              (p.setJQuery = function (e) {
                s = e;
              }),
              (p.Cell = i),
              (p.Slide = r),
              p
            );
          }),
          e.exports
            ? (e.exports = i(t, F, U, j, V, X, Q))
            : ((e = t.Flickity),
              (t.Flickity = i(
                t,
                t.EvEmitter,
                t.getSize,
                t.fizzyUIUtils,
                e.Cell,
                e.Slide,
                e.animatePrototype
              )));
      }),
      Z = t(function (e) {
        var t, i;
        (t = window),
          (i = function (n, e) {
            function t() {}
            e = t.prototype = Object.create(e.prototype);
            (e.bindStartEvent = function (e) {
              this._bindStartEvent(e, !0);
            }),
              (e.unbindStartEvent = function (e) {
                this._bindStartEvent(e, !1);
              }),
              (e._bindStartEvent = function (e, t) {
                var i = (t = void 0 === t || t)
                    ? "addEventListener"
                    : "removeEventListener",
                  t = "mousedown";
                n.PointerEvent
                  ? (t = "pointerdown")
                  : "ontouchstart" in n && (t = "touchstart"),
                  e[i](t, this);
              }),
              (e.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
              }),
              (e.getTouch = function (e) {
                for (var t = 0; t < e.length; t++) {
                  var i = e[t];
                  if (i.identifier == this.pointerIdentifier) return i;
                }
              }),
              (e.onmousedown = function (e) {
                var t = e.button;
                (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
              }),
              (e.ontouchstart = function (e) {
                this._pointerDown(e, e.changedTouches[0]);
              }),
              (e.onpointerdown = function (e) {
                this._pointerDown(e, e);
              }),
              (e._pointerDown = function (e, t) {
                e.button ||
                  this.isPointerDown ||
                  ((this.isPointerDown = !0),
                  (this.pointerIdentifier =
                    void 0 !== t.pointerId ? t.pointerId : t.identifier),
                  this.pointerDown(e, t));
              }),
              (e.pointerDown = function (e, t) {
                this._bindPostStartEvents(e),
                  this.emitEvent("pointerDown", [e, t]);
              });
            var i = {
              mousedown: ["mousemove", "mouseup"],
              touchstart: ["touchmove", "touchend", "touchcancel"],
              pointerdown: ["pointermove", "pointerup", "pointercancel"],
            };
            return (
              (e._bindPostStartEvents = function (e) {
                e &&
                  ((e = i[e.type]).forEach(function (e) {
                    n.addEventListener(e, this);
                  }, this),
                  (this._boundPointerEvents = e));
              }),
              (e._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                  (this._boundPointerEvents.forEach(function (e) {
                    n.removeEventListener(e, this);
                  }, this),
                  delete this._boundPointerEvents);
              }),
              (e.onmousemove = function (e) {
                this._pointerMove(e, e);
              }),
              (e.onpointermove = function (e) {
                e.pointerId == this.pointerIdentifier &&
                  this._pointerMove(e, e);
              }),
              (e.ontouchmove = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerMove(e, t);
              }),
              (e._pointerMove = function (e, t) {
                this.pointerMove(e, t);
              }),
              (e.pointerMove = function (e, t) {
                this.emitEvent("pointerMove", [e, t]);
              }),
              (e.onmouseup = function (e) {
                this._pointerUp(e, e);
              }),
              (e.onpointerup = function (e) {
                e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
              }),
              (e.ontouchend = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerUp(e, t);
              }),
              (e._pointerUp = function (e, t) {
                this._pointerDone(), this.pointerUp(e, t);
              }),
              (e.pointerUp = function (e, t) {
                this.emitEvent("pointerUp", [e, t]);
              }),
              (e._pointerDone = function () {
                this._pointerReset(),
                  this._unbindPostStartEvents(),
                  this.pointerDone();
              }),
              (e._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
              }),
              (e.pointerDone = function () {}),
              (e.onpointercancel = function (e) {
                e.pointerId == this.pointerIdentifier &&
                  this._pointerCancel(e, e);
              }),
              (e.ontouchcancel = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerCancel(e, t);
              }),
              (e._pointerCancel = function (e, t) {
                this._pointerDone(), this.pointerCancel(e, t);
              }),
              (e.pointerCancel = function (e, t) {
                this.emitEvent("pointerCancel", [e, t]);
              }),
              (t.getPointerPoint = function (e) {
                return { x: e.pageX, y: e.pageY };
              }),
              t
            );
          }),
          e.exports
            ? (e.exports = i(t, F))
            : (t.Unipointer = i(t, t.EvEmitter));
      }),
      G = t(function (e) {
        var t, i;
        (t = window),
          (i = function (s, e) {
            function t() {}
            var i = (t.prototype = Object.create(e.prototype));
            (i.bindHandles = function () {
              this._bindHandles(!0);
            }),
              (i.unbindHandles = function () {
                this._bindHandles(!1);
              }),
              (i._bindHandles = function (e) {
                for (
                  var t = (e = void 0 === e || e)
                      ? "addEventListener"
                      : "removeEventListener",
                    i = e ? this._touchActionValue : "",
                    n = 0;
                  n < this.handles.length;
                  n++
                ) {
                  var o = this.handles[n];
                  this._bindStartEvent(o, e),
                    o[t]("click", this),
                    s.PointerEvent && (o.style.touchAction = i);
                }
              }),
              (i._touchActionValue = "none"),
              (i.pointerDown = function (e, t) {
                this.okayPointerDown(e) &&
                  ((this.pointerDownPointer = {
                    pageX: t.pageX,
                    pageY: t.pageY,
                  }),
                  e.preventDefault(),
                  this.pointerDownBlur(),
                  this._bindPostStartEvents(e),
                  this.emitEvent("pointerDown", [e, t]));
              });
            var n = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
              o = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0,
              };
            return (
              (i.okayPointerDown = function (e) {
                var t = n[e.target.nodeName],
                  e = o[e.target.type],
                  e = !t || e;
                return e || this._pointerReset(), e;
              }),
              (i.pointerDownBlur = function () {
                var e = document.activeElement;
                e && e.blur && e != document.body && e.blur();
              }),
              (i.pointerMove = function (e, t) {
                var i = this._dragPointerMove(e, t);
                this.emitEvent("pointerMove", [e, t, i]),
                  this._dragMove(e, t, i);
              }),
              (i._dragPointerMove = function (e, t) {
                var i = {
                  x: t.pageX - this.pointerDownPointer.pageX,
                  y: t.pageY - this.pointerDownPointer.pageY,
                };
                return (
                  !this.isDragging &&
                    this.hasDragStarted(i) &&
                    this._dragStart(e, t),
                  i
                );
              }),
              (i.hasDragStarted = function (e) {
                return 3 < Math.abs(e.x) || 3 < Math.abs(e.y);
              }),
              (i.pointerUp = function (e, t) {
                this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
              }),
              (i._dragPointerUp = function (e, t) {
                this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
              }),
              (i._dragStart = function (e, t) {
                (this.isDragging = !0),
                  (this.isPreventingClicks = !0),
                  this.dragStart(e, t);
              }),
              (i.dragStart = function (e, t) {
                this.emitEvent("dragStart", [e, t]);
              }),
              (i._dragMove = function (e, t, i) {
                this.isDragging && this.dragMove(e, t, i);
              }),
              (i.dragMove = function (e, t, i) {
                e.preventDefault(), this.emitEvent("dragMove", [e, t, i]);
              }),
              (i._dragEnd = function (e, t) {
                (this.isDragging = !1),
                  setTimeout(
                    function () {
                      delete this.isPreventingClicks;
                    }.bind(this)
                  ),
                  this.dragEnd(e, t);
              }),
              (i.dragEnd = function (e, t) {
                this.emitEvent("dragEnd", [e, t]);
              }),
              (i.onclick = function (e) {
                this.isPreventingClicks && e.preventDefault();
              }),
              (i._staticClick = function (e, t) {
                (this.isIgnoringMouseUp && "mouseup" == e.type) ||
                  (this.staticClick(e, t),
                  "mouseup" != e.type &&
                    ((this.isIgnoringMouseUp = !0),
                    setTimeout(
                      function () {
                        delete this.isIgnoringMouseUp;
                      }.bind(this),
                      400
                    )));
              }),
              (i.staticClick = function (e, t) {
                this.emitEvent("staticClick", [e, t]);
              }),
              (t.getPointerPoint = e.getPointerPoint),
              t
            );
          }),
          e.exports
            ? (e.exports = i(t, Z))
            : (t.Unidragger = i(t, t.Unipointer));
      }),
      K =
        (t(function (e) {
          var t, i;
          (t = window),
            (i = function (i, e, t, s) {
              s.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                e.createMethods.push("_createDrag");
              var n = e.prototype;
              s.extend(n, t.prototype), (n._touchActionValue = "pan-y");
              var o = "createTouch" in document,
                a = !1;
              (n._createDrag = function () {
                this.on("activate", this.onActivateDrag),
                  this.on("uiChange", this._uiChangeDrag),
                  this.on("deactivate", this.onDeactivateDrag),
                  this.on("cellChange", this.updateDraggable),
                  o &&
                    !a &&
                    (i.addEventListener("touchmove", function () {}), (a = !0));
              }),
                (n.onActivateDrag = function () {
                  (this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable();
                }),
                (n.onDeactivateDrag = function () {
                  this.unbindHandles(),
                    this.element.classList.remove("is-draggable");
                }),
                (n.updateDraggable = function () {
                  ">1" == this.options.draggable
                    ? (this.isDraggable = 1 < this.slides.length)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                      ? this.element.classList.add("is-draggable")
                      : this.element.classList.remove("is-draggable");
                }),
                (n.bindDrag = function () {
                  (this.options.draggable = !0), this.updateDraggable();
                }),
                (n.unbindDrag = function () {
                  (this.options.draggable = !1), this.updateDraggable();
                }),
                (n._uiChangeDrag = function () {
                  delete this.isFreeScrolling;
                }),
                (n.pointerDown = function (e, t) {
                  this.isDraggable
                    ? this.okayPointerDown(e) &&
                      (this._pointerDownPreventDefault(e),
                      this.pointerDownFocus(e),
                      document.activeElement != this.element &&
                        this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = l()),
                      i.addEventListener("scroll", this),
                      this._pointerDownDefault(e, t))
                    : this._pointerDownDefault(e, t);
                }),
                (n._pointerDownDefault = function (e, t) {
                  (this.pointerDownPointer = {
                    pageX: t.pageX,
                    pageY: t.pageY,
                  }),
                    this._bindPostStartEvents(e),
                    this.dispatchEvent("pointerDown", e, [t]);
                });
              var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
              function l() {
                return { x: i.pageXOffset, y: i.pageYOffset };
              }
              return (
                (n.pointerDownFocus = function (e) {
                  r[e.target.nodeName] || this.focus();
                }),
                (n._pointerDownPreventDefault = function (e) {
                  var t = "touchstart" == e.type,
                    i = "touch" == e.pointerType,
                    n = r[e.target.nodeName];
                  t || i || n || e.preventDefault();
                }),
                (n.hasDragStarted = function (e) {
                  return Math.abs(e.x) > this.options.dragThreshold;
                }),
                (n.pointerUp = function (e, t) {
                  delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", e, [t]),
                    this._dragPointerUp(e, t);
                }),
                (n.pointerDone = function () {
                  i.removeEventListener("scroll", this),
                    delete this.pointerDownScroll;
                }),
                (n.dragStart = function (e, t) {
                  this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    i.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", e, [t]));
                }),
                (n.pointerMove = function (e, t) {
                  var i = this._dragPointerMove(e, t);
                  this.dispatchEvent("pointerMove", e, [t, i]),
                    this._dragMove(e, t, i);
                }),
                (n.dragMove = function (e, t, i) {
                  var n, o;
                  this.isDraggable &&
                    (e.preventDefault(),
                    (this.previousDragX = this.dragX),
                    (o = this.options.rightToLeft ? -1 : 1),
                    this.options.wrapAround &&
                      (i.x = i.x % this.slideableWidth),
                    (n = this.dragStartPosition + i.x * o),
                    !this.options.wrapAround &&
                      this.slides.length &&
                      (n =
                        (n =
                          (o = Math.max(
                            -this.slides[0].target,
                            this.dragStartPosition
                          )) < n
                            ? 0.5 * (n + o)
                            : n) <
                        (o = Math.min(
                          -this.getLastSlide().target,
                          this.dragStartPosition
                        ))
                          ? 0.5 * (n + o)
                          : n),
                    (this.dragX = n),
                    (this.dragMoveTime = new Date()),
                    this.dispatchEvent("dragMove", e, [t, i]));
                }),
                (n.dragEnd = function (e, t) {
                  var i, n;
                  this.isDraggable &&
                    (this.options.freeScroll && (this.isFreeScrolling = !0),
                    (i = this.dragEndRestingSelect()),
                    this.options.freeScroll && !this.options.wrapAround
                      ? ((n = this.getRestingPosition()),
                        (this.isFreeScrolling =
                          -n > this.slides[0].target &&
                          -n < this.getLastSlide().target))
                      : this.options.freeScroll ||
                        i != this.selectedIndex ||
                        (i += this.dragEndBoostSelect()),
                    delete this.previousDragX,
                    (this.isDragSelect = this.options.wrapAround),
                    this.select(i),
                    delete this.isDragSelect,
                    this.dispatchEvent("dragEnd", e, [t]));
                }),
                (n.dragEndRestingSelect = function () {
                  var e = this.getRestingPosition(),
                    t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                    i = this._getClosestResting(e, t, 1),
                    t = this._getClosestResting(e, t, -1);
                  return (i.distance < t.distance ? i : t).index;
                }),
                (n._getClosestResting = function (e, t, i) {
                  for (
                    var n = this.selectedIndex,
                      o = 1 / 0,
                      s =
                        this.options.contain && !this.options.wrapAround
                          ? function (e, t) {
                              return e <= t;
                            }
                          : function (e, t) {
                              return e < t;
                            };
                    s(t, o) &&
                    ((n += i),
                    (o = t),
                    null !== (t = this.getSlideDistance(-e, n)));

                  )
                    t = Math.abs(t);
                  return { distance: o, index: n - i };
                }),
                (n.getSlideDistance = function (e, t) {
                  var i = this.slides.length,
                    n = this.options.wrapAround && 1 < i,
                    o = n ? s.modulo(t, i) : t,
                    o = this.slides[o];
                  if (!o) return null;
                  i = n ? this.slideableWidth * Math.floor(t / i) : 0;
                  return e - (o.target + i);
                }),
                (n.dragEndBoostSelect = function () {
                  if (
                    void 0 === this.previousDragX ||
                    !this.dragMoveTime ||
                    100 < new Date() - this.dragMoveTime
                  )
                    return 0;
                  var e = this.getSlideDistance(
                      -this.dragX,
                      this.selectedIndex
                    ),
                    t = this.previousDragX - this.dragX;
                  return 0 < e && 0 < t ? 1 : e < 0 && t < 0 ? -1 : 0;
                }),
                (n.staticClick = function (e, t) {
                  var i = this.getParentCell(e.target),
                    n = i && i.element,
                    i = i && this.cells.indexOf(i);
                  this.dispatchEvent("staticClick", e, [t, n, i]);
                }),
                (n.onscroll = function () {
                  var e = l(),
                    t = this.pointerDownScroll.x - e.x,
                    e = this.pointerDownScroll.y - e.y;
                  (3 < Math.abs(t) || 3 < Math.abs(e)) && this._pointerDone();
                }),
                e
              );
            }),
            e.exports
              ? (e.exports = i(t, Y, G, j))
              : (t.Flickity = i(t, t.Flickity, t.Unidragger, t.fizzyUIUtils));
        }),
        t(function (e) {
          var t, i;
          (t = window),
            (i = function (e, t, i, n) {
              var o = "http://www.w3.org/2000/svg";
              function s(e, t) {
                (this.direction = e), (this.parent = t), this._create();
              }
              ((s.prototype = Object.create(i.prototype))._create =
                function () {
                  (this.isEnabled = !0),
                    (this.isPrevious = -1 == this.direction);
                  var e = this.parent.options.rightToLeft ? 1 : -1;
                  this.isLeft = this.direction == e;
                  var t = (this.element = document.createElement("button"));
                  (t.className = "flickity-button flickity-prev-next-button"),
                    (t.className += this.isPrevious ? " previous" : " next"),
                    t.setAttribute("type", "button"),
                    this.disable(),
                    t.setAttribute(
                      "aria-label",
                      this.isPrevious ? "Previous" : "Next"
                    );
                  e = this.createSVG();
                  t.appendChild(e),
                    this.parent.on("select", this.update.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (s.prototype.activate = function () {
                  this.bindStartEvent(this.element),
                    this.element.addEventListener("click", this),
                    this.parent.element.appendChild(this.element);
                }),
                (s.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.element),
                    this.unbindStartEvent(this.element),
                    this.element.removeEventListener("click", this);
                }),
                (s.prototype.createSVG = function () {
                  var e = document.createElementNS(o, "svg");
                  e.setAttribute("class", "flickity-button-icon"),
                    e.setAttribute("viewBox", "0 0 100 100");
                  var t,
                    i = document.createElementNS(o, "path"),
                    t =
                      "string" != typeof (t = this.parent.options.arrowShape)
                        ? "M " +
                          t.x0 +
                          ",50 L " +
                          t.x1 +
                          "," +
                          (t.y1 + 50) +
                          " L " +
                          t.x2 +
                          "," +
                          (t.y2 + 50) +
                          " L " +
                          t.x3 +
                          ",50  L " +
                          t.x2 +
                          "," +
                          (50 - t.y2) +
                          " L " +
                          t.x1 +
                          "," +
                          (50 - t.y1) +
                          " Z"
                        : t;
                  return (
                    i.setAttribute("d", t),
                    i.setAttribute("class", "arrow"),
                    this.isLeft ||
                      i.setAttribute(
                        "transform",
                        "translate(100, 100) rotate(180) "
                      ),
                    e.appendChild(i),
                    e
                  );
                }),
                (s.prototype.handleEvent = n.handleEvent),
                (s.prototype.onclick = function () {
                  var e;
                  this.isEnabled &&
                    (this.parent.uiChange(),
                    (e = this.isPrevious ? "previous" : "next"),
                    this.parent[e]());
                }),
                (s.prototype.enable = function () {
                  this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0));
                }),
                (s.prototype.disable = function () {
                  this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1));
                }),
                (s.prototype.update = function () {
                  var e = this.parent.slides;
                  this.parent.options.wrapAround && 1 < e.length
                    ? this.enable()
                    : ((e = e.length ? e.length - 1 : 0),
                      (e = this.isPrevious ? 0 : e),
                      this[
                        this.parent.selectedIndex == e ? "disable" : "enable"
                      ]());
                }),
                (s.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                n.extend(t.defaults, {
                  prevNextButtons: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30,
                  },
                }),
                t.createMethods.push("_createPrevNextButtons");
              n = t.prototype;
              return (
                (n._createPrevNextButtons = function () {
                  this.options.prevNextButtons &&
                    ((this.prevButton = new s(-1, this)),
                    (this.nextButton = new s(1, this)),
                    this.on("activate", this.activatePrevNextButtons));
                }),
                (n.activatePrevNextButtons = function () {
                  this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (n.deactivatePrevNextButtons = function () {
                  this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (t.PrevNextButton = s),
                t
              );
            }),
            e.exports
              ? (e.exports = i(0, Y, Z, j))
              : i(0, t.Flickity, t.Unipointer, t.fizzyUIUtils);
        }),
        t(function (e) {
          var t, i;
          (t = window),
            (i = function (e, t, i, n) {
              function o(e) {
                (this.parent = e), this._create();
              }
              ((o.prototype = Object.create(i.prototype))._create =
                function () {
                  (this.holder = document.createElement("ol")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []),
                    (this.handleClick = this.onClick.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (o.prototype.activate = function () {
                  this.setDots(),
                    this.holder.addEventListener("click", this.handleClick),
                    this.bindStartEvent(this.holder),
                    this.parent.element.appendChild(this.holder);
                }),
                (o.prototype.deactivate = function () {
                  this.holder.removeEventListener("click", this.handleClick),
                    this.unbindStartEvent(this.holder),
                    this.parent.element.removeChild(this.holder);
                }),
                (o.prototype.setDots = function () {
                  var e = this.parent.slides.length - this.dots.length;
                  0 < e ? this.addDots(e) : e < 0 && this.removeDots(-e);
                }),
                (o.prototype.addDots = function (e) {
                  for (
                    var t = document.createDocumentFragment(),
                      i = [],
                      n = this.dots.length,
                      o = n + e,
                      s = n;
                    s < o;
                    s++
                  ) {
                    var a = document.createElement("li");
                    (a.className = "dot"),
                      a.setAttribute("aria-label", "Page dot " + (s + 1)),
                      t.appendChild(a),
                      i.push(a);
                  }
                  this.holder.appendChild(t), (this.dots = this.dots.concat(i));
                }),
                (o.prototype.removeDots = function (e) {
                  this.dots
                    .splice(this.dots.length - e, e)
                    .forEach(function (e) {
                      this.holder.removeChild(e);
                    }, this);
                }),
                (o.prototype.updateSelected = function () {
                  this.selectedDot &&
                    ((this.selectedDot.className = "dot"),
                    this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length &&
                      ((this.selectedDot =
                        this.dots[this.parent.selectedIndex]),
                      (this.selectedDot.className = "dot is-selected"),
                      this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (o.prototype.onTap = o.prototype.onClick =
                  function (e) {
                    e = e.target;
                    "LI" == e.nodeName &&
                      (this.parent.uiChange(),
                      (e = this.dots.indexOf(e)),
                      this.parent.select(e));
                  }),
                (o.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                (t.PageDots = o),
                n.extend(t.defaults, { pageDots: !0 }),
                t.createMethods.push("_createPageDots");
              n = t.prototype;
              return (
                (n._createPageDots = function () {
                  this.options.pageDots &&
                    ((this.pageDots = new o(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
                }),
                (n.activatePageDots = function () {
                  this.pageDots.activate();
                }),
                (n.updateSelectedPageDots = function () {
                  this.pageDots.updateSelected();
                }),
                (n.updatePageDots = function () {
                  this.pageDots.setDots();
                }),
                (n.deactivatePageDots = function () {
                  this.pageDots.deactivate();
                }),
                (t.PageDots = o),
                t
              );
            }),
            e.exports
              ? (e.exports = i(0, Y, Z, j))
              : i(0, t.Flickity, t.Unipointer, t.fizzyUIUtils);
        }),
        t(function (e) {
          var t, i;
          (t = window),
            (i = function (e, t, i) {
              function n(e) {
                (this.parent = e),
                  (this.state = "stopped"),
                  (this.onVisibilityChange = this.visibilityChange.bind(this)),
                  (this.onVisibilityPlay = this.visibilityPlay.bind(this));
              }
              ((n.prototype = Object.create(e.prototype)).play = function () {
                "playing" != this.state &&
                  (document.hidden
                    ? document.addEventListener(
                        "visibilitychange",
                        this.onVisibilityPlay
                      )
                    : ((this.state = "playing"),
                      document.addEventListener(
                        "visibilitychange",
                        this.onVisibilityChange
                      ),
                      this.tick()));
              }),
                (n.prototype.tick = function () {
                  var e, t;
                  "playing" == this.state &&
                    ((e =
                      "number" == typeof (e = this.parent.options.autoPlay)
                        ? e
                        : 3e3),
                    (t = this).clear(),
                    (this.timeout = setTimeout(function () {
                      t.parent.next(!0), t.tick();
                    }, e)));
                }),
                (n.prototype.stop = function () {
                  (this.state = "stopped"),
                    this.clear(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityChange
                    );
                }),
                (n.prototype.clear = function () {
                  clearTimeout(this.timeout);
                }),
                (n.prototype.pause = function () {
                  "playing" == this.state &&
                    ((this.state = "paused"), this.clear());
                }),
                (n.prototype.unpause = function () {
                  "paused" == this.state && this.play();
                }),
                (n.prototype.visibilityChange = function () {
                  this[document.hidden ? "pause" : "unpause"]();
                }),
                (n.prototype.visibilityPlay = function () {
                  this.play(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityPlay
                    );
                }),
                t.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                i.createMethods.push("_createPlayer");
              t = i.prototype;
              return (
                (t._createPlayer = function () {
                  (this.player = new n(this)),
                    this.on("activate", this.activatePlayer),
                    this.on("uiChange", this.stopPlayer),
                    this.on("pointerDown", this.stopPlayer),
                    this.on("deactivate", this.deactivatePlayer);
                }),
                (t.activatePlayer = function () {
                  this.options.autoPlay &&
                    (this.player.play(),
                    this.element.addEventListener("mouseenter", this));
                }),
                (t.playPlayer = function () {
                  this.player.play();
                }),
                (t.stopPlayer = function () {
                  this.player.stop();
                }),
                (t.pausePlayer = function () {
                  this.player.pause();
                }),
                (t.unpausePlayer = function () {
                  this.player.unpause();
                }),
                (t.deactivatePlayer = function () {
                  this.player.stop(),
                    this.element.removeEventListener("mouseenter", this);
                }),
                (t.onmouseenter = function () {
                  this.options.pauseAutoPlayOnHover &&
                    (this.player.pause(),
                    this.element.addEventListener("mouseleave", this));
                }),
                (t.onmouseleave = function () {
                  this.player.unpause(),
                    this.element.removeEventListener("mouseleave", this);
                }),
                (i.Player = n),
                i
              );
            }),
            e.exports
              ? (e.exports = i(F, j, Y))
              : i(t.EvEmitter, t.fizzyUIUtils, t.Flickity);
        }),
        t(function (e) {
          var t, i;
          (t = window),
            (i = function (e, t, n) {
              var i = t.prototype;
              return (
                (i.insert = function (e, t) {
                  var i,
                    n,
                    o,
                    s,
                    a = this._makeCells(e);
                  a &&
                    a.length &&
                    ((s = this.cells.length),
                    (t = void 0 === t ? s : t),
                    (o = a),
                    (n = document.createDocumentFragment()),
                    o.forEach(function (e) {
                      n.appendChild(e.element);
                    }),
                    (i = n),
                    (e = t == s)
                      ? this.slider.appendChild(i)
                      : ((o = this.cells[t].element),
                        this.slider.insertBefore(i, o)),
                    0 === t
                      ? (this.cells = a.concat(this.cells))
                      : e
                      ? (this.cells = this.cells.concat(a))
                      : ((s = this.cells.splice(t, s - t)),
                        (this.cells = this.cells.concat(a).concat(s))),
                    this._sizeCells(a),
                    this.cellChange(t, !0));
                }),
                (i.append = function (e) {
                  this.insert(e, this.cells.length);
                }),
                (i.prepend = function (e) {
                  this.insert(e, 0);
                }),
                (i.remove = function (e) {
                  var i,
                    e = this.getCells(e);
                  e &&
                    e.length &&
                    ((i = this.cells.length - 1),
                    e.forEach(function (e) {
                      e.remove();
                      var t = this.cells.indexOf(e);
                      (i = Math.min(t, i)), n.removeFrom(this.cells, e);
                    }, this),
                    this.cellChange(i, !0));
                }),
                (i.cellSizeChange = function (e) {
                  e = this.getCell(e);
                  e &&
                    (e.getSize(),
                    (e = this.cells.indexOf(e)),
                    this.cellChange(e));
                }),
                (i.cellChange = function (e, t) {
                  var i = this.selectedElement;
                  this._positionCells(e),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                  i = this.getCell(i);
                  i && (this.selectedIndex = this.getCellSlideIndex(i)),
                    (this.selectedIndex = Math.min(
                      this.slides.length - 1,
                      this.selectedIndex
                    )),
                    this.emitEvent("cellChange", [e]),
                    this.select(this.selectedIndex),
                    t && this.positionSliderAtSelected();
                }),
                t
              );
            }),
            e.exports
              ? (e.exports = i(0, Y, j))
              : i(0, t.Flickity, t.fizzyUIUtils);
        }),
        t(function (e) {
          var t, i;
          (t = window),
            (i = function (e, t, o) {
              t.createMethods.push("_createLazyload");
              var i = t.prototype;
              function n(e, t) {
                (this.img = e), (this.flickity = t), this.load();
              }
              return (
                (i._createLazyload = function () {
                  this.on("select", this.lazyLoad);
                }),
                (i.lazyLoad = function () {
                  var t,
                    e = this.options.lazyLoad;
                  e &&
                    ((e = "number" == typeof e ? e : 0),
                    (e = this.getAdjacentCellElements(e)),
                    (t = []),
                    e.forEach(function (e) {
                      e = (function (e) {
                        if ("IMG" == e.nodeName) {
                          var t = e.getAttribute("data-flickity-lazyload"),
                            i = e.getAttribute("data-flickity-lazyload-src"),
                            n = e.getAttribute("data-flickity-lazyload-srcset");
                          if (t || i || n) return [e];
                        }
                        e = e.querySelectorAll(
                          "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
                        );
                        return o.makeArray(e);
                      })(e);
                      t = t.concat(e);
                    }),
                    t.forEach(function (e) {
                      new n(e, this);
                    }, this));
                }),
                (n.prototype.handleEvent = o.handleEvent),
                (n.prototype.load = function () {
                  this.img.addEventListener("load", this),
                    this.img.addEventListener("error", this);
                  var e =
                      this.img.getAttribute("data-flickity-lazyload") ||
                      this.img.getAttribute("data-flickity-lazyload-src"),
                    t = this.img.getAttribute("data-flickity-lazyload-srcset");
                  (this.img.src = e),
                    t && this.img.setAttribute("srcset", t),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                }),
                (n.prototype.onload = function (e) {
                  this.complete(e, "flickity-lazyloaded");
                }),
                (n.prototype.onerror = function (e) {
                  this.complete(e, "flickity-lazyerror");
                }),
                (n.prototype.complete = function (e, t) {
                  this.img.removeEventListener("load", this),
                    this.img.removeEventListener("error", this);
                  var i = this.flickity.getParentCell(this.img),
                    i = i && i.element;
                  this.flickity.cellSizeChange(i),
                    this.img.classList.add(t),
                    this.flickity.dispatchEvent("lazyLoad", e, i);
                }),
                (t.LazyLoader = n),
                t
              );
            }),
            e.exports
              ? (e.exports = i(0, Y, j))
              : i(0, t.Flickity, t.fizzyUIUtils);
        }),
        t(function (e) {
          var t;
          window,
            (t = function (e) {
              return e;
            }),
            e.exports && (e.exports = t(Y));
        })),
      J = t(function (e) {
        var t, i;
        (t = w),
          (i = function (e, n) {
            var t = e.Slide,
              o = t.prototype.updateTarget;
            (t.prototype.updateTarget = function () {
              var i, n;
              o.apply(this, arguments),
                this.parent.options.fade &&
                  ((i = this.target - this.x),
                  (n = this.cells[0].x),
                  this.cells.forEach(function (e) {
                    var t = e.x - n - i;
                    e.renderPosition(t);
                  }));
            }),
              (t.prototype.setOpacity = function (t) {
                this.cells.forEach(function (e) {
                  e.element.style.opacity = t;
                });
              });
            t = e.prototype;
            e.createMethods.push("_createFade"),
              (t._createFade = function () {
                (this.fadeIndex = this.selectedIndex),
                  (this.prevSelectedIndex = this.selectedIndex),
                  this.on("select", this.onSelectFade),
                  this.on("dragEnd", this.onDragEndFade),
                  this.on("settle", this.onSettleFade),
                  this.on("activate", this.onActivateFade),
                  this.on("deactivate", this.onDeactivateFade);
              });
            var i = t.updateSlides;
            (t.updateSlides = function () {
              i.apply(this, arguments),
                this.options.fade &&
                  this.slides.forEach(function (e, t) {
                    t = t == this.selectedIndex ? 1 : 0;
                    e.setOpacity(t);
                  }, this);
            }),
              (t.onSelectFade = function () {
                (this.fadeIndex = Math.min(
                  this.prevSelectedIndex,
                  this.slides.length - 1
                )),
                  (this.prevSelectedIndex = this.selectedIndex);
              }),
              (t.onSettleFade = function () {
                delete this.didDragEnd,
                  this.options.fade &&
                    (this.selectedSlide.setOpacity(1),
                    this.slides[this.fadeIndex] &&
                      this.fadeIndex != this.selectedIndex &&
                      this.slides[this.fadeIndex].setOpacity(0));
              }),
              (t.onDragEndFade = function () {
                this.didDragEnd = !0;
              }),
              (t.onActivateFade = function () {
                this.options.fade && this.element.classList.add("is-fade");
              }),
              (t.onDeactivateFade = function () {
                this.options.fade &&
                  (this.element.classList.remove("is-fade"),
                  this.slides.forEach(function (e) {
                    e.setOpacity("");
                  }));
              });
            var s = t.positionSlider;
            t.positionSlider = function () {
              this.options.fade
                ? (this.fadeSlides(), this.dispatchScrollEvent())
                : s.apply(this, arguments);
            };
            var a = t.positionSliderAtSelected;
            (t.positionSliderAtSelected = function () {
              this.options.fade && this.setTranslateX(0),
                a.apply(this, arguments);
            }),
              (t.fadeSlides = function () {
                var e, t, i, n, o;
                this.slides.length < 2 ||
                  ((e = this.getFadeIndexes()),
                  (t = this.slides[e.a]),
                  (o = this.slides[e.b]),
                  (i = this.wrapDifference(t.target, o.target)),
                  (n = this.wrapDifference(t.target, -this.x)),
                  (n /= i),
                  t.setOpacity(1 - n),
                  o.setOpacity(n),
                  (o = e.a),
                  this.isDragging && (o = 0.5 < n ? e.a : e.b),
                  null != this.fadeHideIndex &&
                    this.fadeHideIndex != o &&
                    this.fadeHideIndex != e.a &&
                    this.fadeHideIndex != e.b &&
                    this.slides[this.fadeHideIndex].setOpacity(0),
                  (this.fadeHideIndex = o));
              }),
              (t.getFadeIndexes = function () {
                return this.isDragging || this.didDragEnd
                  ? this.options.wrapAround
                    ? this.getFadeDragWrapIndexes()
                    : this.getFadeDragLimitIndexes()
                  : { a: this.fadeIndex, b: this.selectedIndex };
              }),
              (t.getFadeDragWrapIndexes = function () {
                var e = this.slides.map(function (e, t) {
                    return this.getSlideDistance(-this.x, t);
                  }, this),
                  t = e.map(function (e) {
                    return Math.abs(e);
                  }),
                  i = Math.min.apply(Math, t),
                  t = t.indexOf(i),
                  i = e[t],
                  e = this.slides.length,
                  i = 0 <= i ? 1 : -1;
                return { a: t, b: n.modulo(t + i, e) };
              }),
              (t.getFadeDragLimitIndexes = function () {
                for (var e = 0, t = 0; t < this.slides.length - 1; t++) {
                  var i = this.slides[t];
                  if (-this.x < i.target) break;
                  e = t;
                }
                return { a: e, b: e + 1 };
              }),
              (t.wrapDifference = function (e, t) {
                var i = t - e;
                if (!this.options.wrapAround) return i;
                (t = i + this.slideableWidth), (e = i - this.slideableWidth);
                return (
                  Math.abs(t) < Math.abs(i) && (i = t),
                  Math.abs(e) < Math.abs(i) && (i = e),
                  i
                );
              });
            var r = t._getWrapShiftCells;
            t._getWrapShiftCells = function () {
              this.options.fade || r.apply(this, arguments);
            };
            var l = t.shiftWrapCells;
            return (
              (t.shiftWrapCells = function () {
                this.options.fade || l.apply(this, arguments);
              }),
              e
            );
          }),
          e.exports ? (e.exports = i(K, j)) : i(t.Flickity, t.fizzyUIUtils);
      }),
      ee = t(function (e, t) {
        e.exports = function (p, i, e, t) {
          var m = {
            features: null,
            bind: function (e, t, i, n) {
              var o = (n ? "remove" : "add") + "EventListener";
              t = t.split(" ");
              for (var s = 0; s < t.length; s++) t[s] && e[o](t[s], i, !1);
            },
            isArray: function (e) {
              return e instanceof Array;
            },
            createEl: function (e, t) {
              t = document.createElement(t || "div");
              return e && (t.className = e), t;
            },
            getScrollY: function () {
              var e = window.pageYOffset;
              return void 0 !== e ? e : document.documentElement.scrollTop;
            },
            unbind: function (e, t, i) {
              m.bind(e, t, i, !0);
            },
            removeClass: function (e, t) {
              t = new RegExp("(\\s|^)" + t + "(\\s|$)");
              e.className = e.className
                .replace(t, " ")
                .replace(/^\s\s*/, "")
                .replace(/\s\s*$/, "");
            },
            addClass: function (e, t) {
              m.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
            },
            hasClass: function (e, t) {
              return (
                e.className &&
                new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
              );
            },
            getChildByClass: function (e, t) {
              for (var i = e.firstChild; i; ) {
                if (m.hasClass(i, t)) return i;
                i = i.nextSibling;
              }
            },
            arraySearch: function (e, t, i) {
              for (var n = e.length; n--; ) if (e[n][i] === t) return n;
              return -1;
            },
            extend: function (e, t, i) {
              for (var n in t)
                t.hasOwnProperty(n) &&
                  ((i && e.hasOwnProperty(n)) || (e[n] = t[n]));
            },
            easing: {
              sine: {
                out: function (e) {
                  return Math.sin(e * (Math.PI / 2));
                },
                inOut: function (e) {
                  return -(Math.cos(Math.PI * e) - 1) / 2;
                },
              },
              cubic: {
                out: function (e) {
                  return --e * e * e + 1;
                },
              },
            },
            detectFeatures: function () {
              if (m.features) return m.features;
              var e,
                t,
                i = m.createEl().style,
                n = "",
                o = {};
              (o.oldIE = document.all && !document.addEventListener),
                (o.touch = "ontouchstart" in window),
                window.requestAnimationFrame &&
                  ((o.raf = window.requestAnimationFrame),
                  (o.caf = window.cancelAnimationFrame)),
                (o.pointerEvent =
                  !!window.PointerEvent || navigator.msPointerEnabled),
                o.pointerEvent ||
                  ((e = navigator.userAgent),
                  !/iP(hone|od)/.test(navigator.platform) ||
                    ((t = navigator.appVersion.match(
                      /OS (\d+)_(\d+)_?(\d+)?/
                    )) &&
                      0 < t.length &&
                      1 <= (t = parseInt(t[1], 10)) &&
                      t < 8 &&
                      (o.isOldIOSPhone = !0)),
                  (t = (t = e.match(/Android\s([0-9\.]*)/)) ? t[1] : 0),
                  1 <= (t = parseFloat(t)) &&
                    (t < 4.4 && (o.isOldAndroid = !0), (o.androidVersion = t)),
                  (o.isMobileOpera = /opera mini|opera mobi/i.test(e)));
              for (
                var s,
                  a,
                  r,
                  l = ["transform", "perspective", "animationName"],
                  c = ["", "webkit", "Moz", "ms", "O"],
                  d = 0;
                d < 4;
                d++
              ) {
                n = c[d];
                for (var u = 0; u < 3; u++)
                  (s = l[u]),
                    (a = n + (n ? s.charAt(0).toUpperCase() + s.slice(1) : s)),
                    !o[s] && a in i && (o[s] = a);
                n &&
                  !o.raf &&
                  ((n = n.toLowerCase()),
                  (o.raf = window[n + "RequestAnimationFrame"]),
                  o.raf &&
                    (o.caf =
                      window[n + "CancelAnimationFrame"] ||
                      window[n + "CancelRequestAnimationFrame"]));
              }
              return (
                o.raf ||
                  ((r = 0),
                  (o.raf = function (e) {
                    var t = new Date().getTime(),
                      i = Math.max(0, 16 - (t - r)),
                      n = window.setTimeout(function () {
                        e(t + i);
                      }, i);
                    return (r = t + i), n;
                  }),
                  (o.caf = function (e) {
                    clearTimeout(e);
                  })),
                (o.svg =
                  !!document.createElementNS &&
                  !!document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "svg"
                  ).createSVGRect),
                (m.features = o)
              );
            },
          };
          m.detectFeatures(),
            m.features.oldIE &&
              (m.bind = function (e, t, i, n) {
                t = t.split(" ");
                for (
                  var o,
                    s = (n ? "detach" : "attach") + "Event",
                    a = function () {
                      i.handleEvent.call(i);
                    },
                    r = 0;
                  r < t.length;
                  r++
                )
                  if ((o = t[r]))
                    if ("object" === wi(i) && i.handleEvent) {
                      if (n) {
                        if (!i["oldIE" + o]) return !1;
                      } else i["oldIE" + o] = a;
                      e[s]("on" + o, i["oldIE" + o]);
                    } else e[s]("on" + o, i);
              });
          var f = this,
            g = {
              allowPanToNext: !0,
              spacing: 0.12,
              bgOpacity: 1,
              mouseUsed: !1,
              loop: !0,
              pinchToClose: !0,
              closeOnScroll: !0,
              closeOnVerticalDrag: !0,
              verticalDragRange: 0.75,
              hideAnimationDuration: 333,
              showAnimationDuration: 333,
              showHideOpacity: !1,
              focus: !0,
              escKey: !0,
              arrowKeys: !0,
              mainScrollEndFriction: 0.35,
              panEndFriction: 0.35,
              isClickableElement: function (e) {
                return "A" === e.tagName;
              },
              getDoubleTapZoom: function (e, t) {
                return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
              },
              maxSpreadZoom: 1.33,
              modal: !0,
              scaleMode: "fit",
            };
          m.extend(g, t);
          function n() {
            return { x: 0, y: 0 };
          }
          function o(e, t) {
            m.extend(f, t.publicMethods), et.push(e);
          }
          function a(e) {
            var t = Xt();
            return t - 1 < e ? e - t : e < 0 ? t + e : e;
          }
          function s(e, t) {
            return nt[e] || (nt[e] = []), nt[e].push(t);
          }
          function v(e) {
            var t = nt[e];
            if (t) {
              var i = Array.prototype.slice.call(arguments);
              i.shift();
              for (var n = 0; n < t.length; n++) t[n].apply(f, i);
            }
          }
          function d() {
            return new Date().getTime();
          }
          function y(e) {
            (Ue = e), (f.bg.style.opacity = e * g.bgOpacity);
          }
          function r(e, t, i, n, o) {
            (!it || (o && o !== f.currItem)) &&
              (n /= (o || f.currItem).fitRatio),
              (e[de] = ee + t + "px, " + i + "px" + te + " scale(" + n + ")");
          }
          function u(e, t) {
            var i;
            !g.loop &&
              t &&
              ((i = X + ($e.x * Ze - e) / $e.x),
              (t = Math.round(e - Et.x)),
              ((i < 0 && 0 < t) || (i >= Xt() - 1 && t < 0)) &&
                (e = Et.x + t * g.mainScrollEndFriction)),
              (Et.x = e),
              at(e, Q);
          }
          function l(e, t) {
            var i = St[e] - Ge[e];
            return Xe[e] + Ve[e] + i - (t / J) * i;
          }
          function b(e, t) {
            (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
          }
          function c(e) {
            (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
          }
          function h() {
            rt &&
              (m.unbind(document, "mousemove", h),
              m.addClass(p, "pswp--has_mouse"),
              (g.mouseUsed = !0),
              v("mouseUsed")),
              (rt = setTimeout(function () {
                rt = null;
              }, 100));
          }
          function w(e, t) {
            return (e = $t(f.currItem, Ye, e)), t && (qe = e), e;
          }
          function _(e) {
            return (e = e || f.currItem).initialZoomLevel;
          }
          function E(e) {
            return 0 < (e = e || f.currItem).w ? g.maxSpreadZoom : 1;
          }
          function S(e, t, i, n) {
            return n === f.currItem.initialZoomLevel
              ? ((i[e] = f.currItem.initialPosition[e]), !0)
              : ((i[e] = l(e, n)),
                i[e] > t.min[e]
                  ? ((i[e] = t.min[e]), !0)
                  : i[e] < t.max[e] && ((i[e] = t.max[e]), !0));
          }
          function k(e) {
            var t = "";
            g.escKey && 27 === e.keyCode
              ? (t = "close")
              : g.arrowKeys &&
                (37 === e.keyCode
                  ? (t = "prev")
                  : 39 === e.keyCode && (t = "next")),
              t &&
                (e.ctrlKey ||
                  e.altKey ||
                  e.shiftKey ||
                  e.metaKey ||
                  (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                  f[t]()));
          }
          function x(e) {
            e &&
              (Ie || Te || Re || xe) &&
              (e.preventDefault(), e.stopPropagation());
          }
          function C() {
            f.setScrollOffset(0, m.getScrollY());
          }
          function L(e) {
            lt[e] && (lt[e].raf && me(lt[e].raf), ct--, delete lt[e]);
          }
          function A(e) {
            lt[e] && L(e), lt[e] || (ct++, (lt[e] = {}));
          }
          function T() {
            for (var e in lt) lt.hasOwnProperty(e) && L(e);
          }
          function I(t, i, n, o, s, a, r) {
            var l,
              c = d();
            A(t),
              (function e() {
                if (lt[t]) {
                  if (((l = d() - c), o <= l))
                    return L(t), a(n), void (r && r());
                  a((n - i) * s(l / o) + i), (lt[t].raf = pe(e));
                }
              })();
          }
          function M(e, t) {
            return (
              (yt.x = Math.abs(e.x - t.x)),
              (yt.y = Math.abs(e.y - t.y)),
              Math.sqrt(yt.x * yt.x + yt.y * yt.y)
            );
          }
          function P() {
            Le && ((Me = pe(P)), It());
          }
          function D(e, t) {
            return (
              !(!e || e === document) &&
              !(
                e.getAttribute("class") &&
                -1 < e.getAttribute("class").indexOf("pswp__scroll-wrap")
              ) &&
              (t(e) ? e : D(e.parentNode, t))
            );
          }
          function z(e, t) {
            return (
              (Ct.prevent = !D(e.target, g.isClickableElement)),
              v("preventDragEvent", e, t, Ct),
              Ct.prevent
            );
          }
          function O(e, t) {
            return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
          }
          function q(e, t, i) {
            (i.x = 0.5 * (e.x + t.x)), (i.y = 0.5 * (e.y + t.y));
          }
          function B() {
            var e = Qe.y - f.currItem.initialPosition.y;
            return 1 - Math.abs(e / (Ye.y / 2));
          }
          function R(e) {
            for (; 0 < Tt.length; ) Tt.pop();
            return (
              ue
                ? ((je = 0),
                  ft.forEach(function (e) {
                    0 === je ? (Tt[0] = e) : 1 === je && (Tt[1] = e), je++;
                  }))
                : -1 < e.type.indexOf("touch")
                ? e.touches &&
                  0 < e.touches.length &&
                  ((Tt[0] = O(e.touches[0], Lt)),
                  1 < e.touches.length && (Tt[1] = O(e.touches[1], At)))
                : ((Lt.x = e.pageX),
                  (Lt.y = e.pageY),
                  (Lt.id = ""),
                  (Tt[0] = Lt)),
              Tt
            );
          }
          function H(e, t) {
            var i,
              n,
              o,
              s = Qe[e] + t[e],
              a = 0 < t[e],
              r = Et.x + t.x,
              l = Et.x - gt.x,
              c = s > qe.min[e] || s < qe.max[e] ? g.panEndFriction : 1,
              s = Qe[e] + t[e] * c;
            if (
              (g.allowPanToNext || K === f.currItem.initialZoomLevel) &&
              (Be
                ? "h" !== He ||
                  "x" !== e ||
                  Te ||
                  (a
                    ? (s > qe.min[e] &&
                        ((c = g.panEndFriction),
                        qe.min[e],
                        (i = qe.min[e] - Xe[e])),
                      (i <= 0 || l < 0) && 1 < Xt()
                        ? ((o = r), l < 0 && r > gt.x && (o = gt.x))
                        : qe.min.x !== qe.max.x && (n = s))
                    : (s < qe.max[e] &&
                        ((c = g.panEndFriction),
                        qe.max[e],
                        (i = Xe[e] - qe.max[e])),
                      (i <= 0 || 0 < l) && 1 < Xt()
                        ? ((o = r), 0 < l && r < gt.x && (o = gt.x))
                        : qe.min.x !== qe.max.x && (n = s)))
                : (o = r),
              "x" === e)
            )
              return (
                void 0 !== o && (u(o, !0), (Pe = o !== gt.x)),
                qe.min.x !== qe.max.x &&
                  (void 0 !== n ? (Qe.x = n) : Pe || (Qe.x += t.x * c)),
                void 0 !== o
              );
            Re || Pe || (K > f.currItem.fitRatio && (Qe[e] += t[e] * c));
          }
          function N(e) {
            var t;
            ("mousedown" === e.type && 0 < e.button) ||
              (jt
                ? e.preventDefault()
                : (Ce && "mousedown" === e.type) ||
                  (z(e, !0) && e.preventDefault(),
                  v("pointerDown"),
                  ue &&
                    ((t = m.arraySearch(ft, e.pointerId, "id")) < 0 &&
                      (t = ft.length),
                    (ft[t] = { x: e.pageX, y: e.pageY, id: e.pointerId })),
                  (e = (t = R(e)).length),
                  (De = null),
                  T(),
                  (Le && 1 !== e) ||
                    ((Le = Ne = !0),
                    m.bind(window, Z, f),
                    (ke = We = Fe = xe = Pe = Ie = Ae = Te = !1),
                    (He = null),
                    v("firstTouchStart", t),
                    b(Xe, Qe),
                    (Ve.x = Ve.y = 0),
                    b(pt, t[0]),
                    b(mt, pt),
                    (gt.x = $e.x * Ze),
                    (vt = [{ x: pt.x, y: pt.y }]),
                    (Ee = _e = d()),
                    w(K, !0),
                    xt(),
                    P()),
                  !ze &&
                    1 < e &&
                    !Re &&
                    !Pe &&
                    ((J = K),
                    (ze = Ae = !(Te = !1)),
                    (Ve.y = Ve.x = 0),
                    b(Xe, Qe),
                    b(dt, t[0]),
                    b(ut, t[1]),
                    q(dt, ut, kt),
                    (St.x = Math.abs(kt.x) - Qe.x),
                    (St.y = Math.abs(kt.y) - Qe.y),
                    (Oe = M(dt, ut)))));
          }
          function F(e) {
            var t, i;
            e.preventDefault(),
              !ue ||
                (-1 < (t = m.arraySearch(ft, e.pointerId, "id")) &&
                  (((i = ft[t]).x = e.pageX), (i.y = e.pageY))),
              Le &&
                ((i = R(e)),
                He || Ie || ze
                  ? (De = i)
                  : Et.x !== $e.x * Ze
                  ? (He = "h")
                  : ((e = Math.abs(i[0].x - pt.x) - Math.abs(i[0].y - pt.y)),
                    10 <= Math.abs(e) && ((He = 0 < e ? "h" : "v"), (De = i))));
          }
          function U(e) {
            if (be.isOldAndroid) {
              if (Ce && "mouseup" === e.type) return;
              -1 < e.type.indexOf("touch") &&
                (clearTimeout(Ce),
                (Ce = setTimeout(function () {
                  Ce = 0;
                }, 600)));
            }
            v("pointerUp"),
              z(e, !1) && e.preventDefault(),
              !ue ||
                (-1 < (i = m.arraySearch(ft, e.pointerId, "id")) &&
                  ((s = ft.splice(i, 1)[0]),
                  navigator.msPointerEnabled
                    ? ((s.type = { 4: "mouse", 2: "touch", 3: "pen" }[
                        e.pointerType
                      ]),
                      s.type || (s.type = e.pointerType || "mouse"))
                    : (s.type = e.pointerType || "mouse")));
            var t = R(e),
              i = t.length;
            if (("mouseup" === e.type && (i = 0), 2 === i)) return !(De = null);
            1 === i && b(mt, t[0]),
              0 !== i ||
                He ||
                Re ||
                (s ||
                  ("mouseup" === e.type
                    ? (s = { x: e.pageX, y: e.pageY, type: "mouse" })
                    : e.changedTouches &&
                      e.changedTouches[0] &&
                      (s = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: "touch",
                      })),
                v("touchRelease", e, s));
            var n,
              o,
              s = -1;
            if (
              (0 === i &&
                ((Le = !1),
                m.unbind(window, Z, f),
                xt(),
                ze ? (s = 0) : -1 !== _t && (s = d() - _t)),
              (_t = 1 === i ? d() : -1),
              (s = -1 !== s && s < 150 ? "zoom" : "swipe"),
              ze &&
                i < 2 &&
                ((ze = !1),
                1 === i && (s = "zoomPointerUp"),
                v("zoomGestureEnded")),
              (De = null),
              Ie || Te || Re || xe)
            )
              if ((T(), (Se = Se || Mt()).calculateSwipeSpeed("x"), xe))
                B() < g.verticalDragRange
                  ? f.close()
                  : ((n = Qe.y),
                    (o = Ue),
                    I(
                      "verticalDrag",
                      0,
                      1,
                      300,
                      m.easing.cubic.out,
                      function (e) {
                        (Qe.y = (f.currItem.initialPosition.y - n) * e + n),
                          y((1 - o) * e + o),
                          ot();
                      }
                    ),
                    v("onVerticalDrag", 1));
              else {
                if ((Pe || Re) && 0 === i) {
                  if (Dt(s, Se)) return;
                  s = "zoomPointerUp";
                }
                Re ||
                  ("swipe" === s
                    ? !Pe && K > f.currItem.fitRatio && Pt(Se)
                    : Ot());
              }
          }
          var W,
            j,
            V,
            X,
            Q,
            Y,
            Z,
            G,
            $,
            K,
            J,
            ee,
            te,
            ie,
            ne,
            oe,
            se,
            ae,
            re,
            le,
            ce,
            de,
            ue,
            he,
            pe,
            me,
            fe,
            ge,
            ve,
            ye,
            be,
            we,
            _e,
            Ee,
            Se,
            ke,
            xe,
            Ce,
            Le,
            Ae,
            Te,
            Ie,
            Me,
            Pe,
            De,
            ze,
            Oe,
            qe,
            Be,
            Re,
            He,
            Ne,
            Fe,
            Ue,
            We,
            je,
            Ve = n(),
            Xe = n(),
            Qe = n(),
            Ye = {},
            Ze = 0,
            Ge = {},
            $e = n(),
            Ke = 0,
            Je = !0,
            et = [],
            tt = {},
            it = !1,
            nt = {},
            ot = function (e) {
              Be &&
                (e &&
                  (K > f.currItem.fitRatio
                    ? it || (Kt(f.currItem, !1, !0), (it = !0))
                    : it && (Kt(f.currItem), (it = !1))),
                r(Be, Qe.x, Qe.y, K));
            },
            st = function (e) {
              e.container &&
                r(
                  e.container.style,
                  e.initialPosition.x,
                  e.initialPosition.y,
                  e.initialZoomLevel,
                  e
                );
            },
            at = function (e, t) {
              t[de] = ee + e + "px, 0px" + te;
            },
            rt = null,
            lt = {},
            ct = 0,
            t = {
              shout: v,
              listen: s,
              viewportSize: Ye,
              options: g,
              isMainScrollAnimating: function () {
                return Re;
              },
              getZoomLevel: function () {
                return K;
              },
              getCurrentIndex: function () {
                return X;
              },
              isDragging: function () {
                return Le;
              },
              isZooming: function () {
                return ze;
              },
              setScrollOffset: function (e, t) {
                (Ge.x = e), (ye = Ge.y = t), v("updateScrollOffset", Ge);
              },
              applyZoomPan: function (e, t, i, n) {
                (Qe.x = t), (Qe.y = i), (K = e), ot(n);
              },
              init: function () {
                if (!W && !j) {
                  var e;
                  (f.framework = m),
                    (f.template = p),
                    (f.bg = m.getChildByClass(p, "pswp__bg")),
                    (fe = p.className),
                    (W = !0),
                    (be = m.detectFeatures()),
                    (pe = be.raf),
                    (me = be.caf),
                    (de = be.transform),
                    (ve = be.oldIE),
                    (f.scrollWrap = m.getChildByClass(p, "pswp__scroll-wrap")),
                    (f.container = m.getChildByClass(
                      f.scrollWrap,
                      "pswp__container"
                    )),
                    (Q = f.container.style),
                    (f.itemHolders = oe =
                      [
                        { el: f.container.children[0], wrap: 0, index: -1 },
                        { el: f.container.children[1], wrap: 0, index: -1 },
                        { el: f.container.children[2], wrap: 0, index: -1 },
                      ]),
                    (oe[0].el.style.display = oe[2].el.style.display = "none"),
                    (function () {
                      if (de) {
                        var e = be.perspective && !he;
                        return (
                          (ee = "translate" + (e ? "3d(" : "(")),
                          (te = be.perspective ? ", 0px)" : ")")
                        );
                      }
                      (de = "left"),
                        m.addClass(p, "pswp--ie"),
                        (at = function (e, t) {
                          t.left = e + "px";
                        }),
                        (st = function (e) {
                          var t = 1 < e.fitRatio ? 1 : e.fitRatio,
                            i = e.container.style,
                            n = t * e.w,
                            t = t * e.h;
                          (i.width = n + "px"),
                            (i.height = t + "px"),
                            (i.left = e.initialPosition.x + "px"),
                            (i.top = e.initialPosition.y + "px");
                        }),
                        (ot = function () {
                          var e, t, i, n;
                          Be &&
                            ((e = Be),
                            (i =
                              (t =
                                1 < (n = f.currItem).fitRatio
                                  ? 1
                                  : n.fitRatio) * n.w),
                            (n = t * n.h),
                            (e.width = i + "px"),
                            (e.height = n + "px"),
                            (e.left = Qe.x + "px"),
                            (e.top = Qe.y + "px"));
                        });
                    })(),
                    ($ = {
                      resize: f.updateSize,
                      orientationchange: function () {
                        clearTimeout(we),
                          (we = setTimeout(function () {
                            Ye.x !== f.scrollWrap.clientWidth && f.updateSize();
                          }, 500));
                      },
                      scroll: C,
                      keydown: k,
                      click: x,
                    });
                  var t =
                    be.isOldIOSPhone || be.isOldAndroid || be.isMobileOpera;
                  for (
                    (be.animationName && be.transform && !t) ||
                      (g.showAnimationDuration = g.hideAnimationDuration = 0),
                      e = 0;
                    e < et.length;
                    e++
                  )
                    f["init" + et[e]]();
                  i && (f.ui = new i(f, m)).init(),
                    v("firstUpdate"),
                    (X = X || g.index || 0),
                    (isNaN(X) || X < 0 || X >= Xt()) && (X = 0),
                    (f.currItem = Vt(X)),
                    (be.isOldIOSPhone || be.isOldAndroid) && (Je = !1),
                    p.setAttribute("aria-hidden", "false"),
                    g.modal &&
                      (Je
                        ? (p.style.position = "fixed")
                        : ((p.style.position = "absolute"),
                          (p.style.top = m.getScrollY() + "px"))),
                    void 0 === ye &&
                      (v("initialLayout"), (ye = ge = m.getScrollY()));
                  t = "pswp--open ";
                  for (
                    g.mainClass && (t += g.mainClass + " "),
                      g.showHideOpacity && (t += "pswp--animate_opacity "),
                      t += he ? "pswp--touch" : "pswp--notouch",
                      t += be.animationName ? " pswp--css_animation" : "",
                      t += be.svg ? " pswp--svg" : "",
                      m.addClass(p, t),
                      f.updateSize(),
                      Y = -1,
                      Ke = null,
                      e = 0;
                    e < 3;
                    e++
                  )
                    at((e + Y) * $e.x, oe[e].el.style);
                  ve || m.bind(f.scrollWrap, G, f),
                    s("initialZoomInEnd", function () {
                      f.setContent(oe[0], X - 1),
                        f.setContent(oe[2], X + 1),
                        (oe[0].el.style.display = oe[2].el.style.display =
                          "block"),
                        g.focus && p.focus(),
                        m.bind(document, "keydown", f),
                        be.transform && m.bind(f.scrollWrap, "click", f),
                        g.mouseUsed || m.bind(document, "mousemove", h),
                        m.bind(window, "resize scroll orientationchange", f),
                        v("bindEvents");
                    }),
                    f.setContent(oe[1], X),
                    f.updateCurrItem(),
                    v("afterInit"),
                    Je ||
                      (ie = setInterval(function () {
                        ct ||
                          Le ||
                          ze ||
                          K !== f.currItem.initialZoomLevel ||
                          f.updateSize();
                      }, 1e3)),
                    m.addClass(p, "pswp--visible");
                }
              },
              close: function () {
                W &&
                  ((j = !(W = !1)),
                  v("close"),
                  m.unbind(window, "resize scroll orientationchange", f),
                  m.unbind(window, "scroll", $.scroll),
                  m.unbind(document, "keydown", f),
                  m.unbind(document, "mousemove", h),
                  be.transform && m.unbind(f.scrollWrap, "click", f),
                  Le && m.unbind(window, Z, f),
                  clearTimeout(we),
                  v("unbindEvents"),
                  Qt(f.currItem, null, !0, f.destroy));
              },
              destroy: function () {
                v("destroy"),
                  Ft && clearTimeout(Ft),
                  p.setAttribute("aria-hidden", "true"),
                  (p.className = fe),
                  ie && clearInterval(ie),
                  m.unbind(f.scrollWrap, G, f),
                  m.unbind(window, "scroll", f),
                  xt(),
                  T(),
                  (nt = null);
              },
              panTo: function (e, t, i) {
                i ||
                  (e > qe.min.x
                    ? (e = qe.min.x)
                    : e < qe.max.x && (e = qe.max.x),
                  t > qe.min.y
                    ? (t = qe.min.y)
                    : t < qe.max.y && (t = qe.max.y)),
                  (Qe.x = e),
                  (Qe.y = t),
                  ot();
              },
              handleEvent: function (e) {
                (e = e || window.event), $[e.type] && $[e.type](e);
              },
              goTo: function (e) {
                var t = (e = a(e)) - X;
                (Ke = t),
                  (X = e),
                  (f.currItem = Vt(X)),
                  (Ze -= t),
                  u($e.x * Ze),
                  T(),
                  (Re = !1),
                  f.updateCurrItem();
              },
              next: function () {
                f.goTo(X + 1);
              },
              prev: function () {
                f.goTo(X - 1);
              },
              updateCurrZoomItem: function (e) {
                var t;
                e && v("beforeChange", 0),
                  (Be = oe[1].el.children.length
                    ? ((t = oe[1].el.children[0]),
                      m.hasClass(t, "pswp__zoom-wrap") ? t.style : null)
                    : null),
                  (qe = f.currItem.bounds),
                  (J = K = f.currItem.initialZoomLevel),
                  (Qe.x = qe.center.x),
                  (Qe.y = qe.center.y),
                  e && v("afterChange");
              },
              invalidateCurrItems: function () {
                ne = !0;
                for (var e = 0; e < 3; e++)
                  oe[e].item && (oe[e].item.needsUpdate = !0);
              },
              updateCurrItem: function (e) {
                if (0 !== Ke) {
                  var t,
                    i = Math.abs(Ke);
                  if (!(e && i < 2)) {
                    (f.currItem = Vt(X)),
                      (it = !1),
                      v("beforeChange", Ke),
                      3 <= i && ((Y += Ke + (0 < Ke ? -3 : 3)), (i = 3));
                    for (var n = 0; n < i; n++)
                      0 < Ke
                        ? ((t = oe.shift()),
                          (oe[2] = t),
                          at((++Y + 2) * $e.x, t.el.style),
                          f.setContent(t, X - i + n + 1 + 1))
                        : ((t = oe.pop()),
                          oe.unshift(t),
                          at(--Y * $e.x, t.el.style),
                          f.setContent(t, X + i - n - 1 - 1));
                    !Be ||
                      1 !== Math.abs(Ke) ||
                      ((e = Vt(se)).initialZoomLevel !== K &&
                        ($t(e, Ye), Kt(e), st(e))),
                      (Ke = 0),
                      f.updateCurrZoomItem(),
                      (se = X),
                      v("afterChange");
                  }
                }
              },
              updateSize: function (e) {
                if (!Je && g.modal) {
                  var t = m.getScrollY();
                  if (
                    (ye !== t && ((p.style.top = t + "px"), (ye = t)),
                    !e &&
                      tt.x === window.innerWidth &&
                      tt.y === window.innerHeight)
                  )
                    return;
                  (tt.x = window.innerWidth),
                    (tt.y = window.innerHeight),
                    (p.style.height = tt.y + "px");
                }
                if (
                  ((Ye.x = f.scrollWrap.clientWidth),
                  (Ye.y = f.scrollWrap.clientHeight),
                  C(),
                  ($e.x = Ye.x + Math.round(Ye.x * g.spacing)),
                  ($e.y = Ye.y),
                  u($e.x * Ze),
                  v("beforeResize"),
                  void 0 !== Y)
                ) {
                  for (var i, n, o, s = 0; s < 3; s++)
                    (i = oe[s]),
                      at((s + Y) * $e.x, i.el.style),
                      (o = X + s - 1),
                      g.loop && 2 < Xt() && (o = a(o)),
                      (n = Vt(o)) && (ne || n.needsUpdate || !n.bounds)
                        ? (f.cleanSlide(n),
                          f.setContent(i, o),
                          1 === s &&
                            ((f.currItem = n), f.updateCurrZoomItem(!0)),
                          (n.needsUpdate = !1))
                        : -1 === i.index && 0 <= o && f.setContent(i, o),
                      n && n.container && ($t(n, Ye), Kt(n), st(n));
                  ne = !1;
                }
                (J = K = f.currItem.initialZoomLevel),
                  (qe = f.currItem.bounds) &&
                    ((Qe.x = qe.center.x), (Qe.y = qe.center.y), ot(!0)),
                  v("resize");
              },
              zoomTo: function (t, e, i, n, o) {
                e &&
                  ((J = K),
                  (St.x = Math.abs(e.x) - Qe.x),
                  (St.y = Math.abs(e.y) - Qe.y),
                  b(Xe, Qe));
                var e = w(t, !1),
                  s = {};
                S("x", e, s, t), S("y", e, s, t);
                var a = K,
                  r = Qe.x,
                  l = Qe.y;
                c(s);
                e = function (e) {
                  1 === e
                    ? ((K = t), (Qe.x = s.x), (Qe.y = s.y))
                    : ((K = (t - a) * e + a),
                      (Qe.x = (s.x - r) * e + r),
                      (Qe.y = (s.y - l) * e + l)),
                    o && o(e),
                    ot(1 === e);
                };
                i
                  ? I("customZoomTo", 0, 1, i, n || m.easing.sine.inOut, e)
                  : e(1);
              },
            },
            dt = {},
            ut = {},
            ht = {},
            pt = {},
            mt = {},
            ft = [],
            gt = {},
            vt = [],
            yt = {},
            bt = 0,
            wt = n(),
            _t = 0,
            Et = n(),
            St = n(),
            kt = n(),
            xt = function () {
              Me && (me(Me), (Me = null));
            },
            Ct = {},
            Lt = {},
            At = {},
            Tt = [],
            It = function () {
              if (De) {
                var e,
                  t,
                  i,
                  n,
                  o,
                  s = De.length;
                if (0 !== s)
                  if (
                    (b(dt, De[0]),
                    (ht.x = dt.x - pt.x),
                    (ht.y = dt.y - pt.y),
                    ze && 1 < s)
                  )
                    (pt.x = dt.x),
                      (pt.y = dt.y),
                      (ht.x ||
                        ht.y ||
                        ((n = De[1]), (o = ut), n.x !== o.x || n.y !== o.y)) &&
                        (b(ut, De[1]),
                        Te || ((Te = !0), v("zoomGestureStarted")),
                        (t = M(dt, ut)),
                        (i = zt(t)) >
                          f.currItem.initialZoomLevel +
                            f.currItem.initialZoomLevel / 15 && (We = !0),
                        (e = 1),
                        (s = _()),
                        (n = E()),
                        i < s
                          ? g.pinchToClose &&
                            !We &&
                            J <= f.currItem.initialZoomLevel
                            ? (y((o = 1 - (s - i) / (s / 1.2))),
                              v("onPinchClose", o),
                              (Fe = !0))
                            : (1 < (e = (s - i) / s) && (e = 1),
                              (i = s - e * (s / 3)))
                          : n < i &&
                            (1 < (e = (i - n) / (6 * s)) && (e = 1),
                            (i = n + e * s)),
                        e < 0 && (e = 0),
                        q(dt, ut, wt),
                        (Ve.x += wt.x - kt.x),
                        (Ve.y += wt.y - kt.y),
                        b(kt, wt),
                        (Qe.x = l("x", i)),
                        (Qe.y = l("y", i)),
                        (ke = K < i),
                        (K = i),
                        ot());
                  else if (
                    He &&
                    (Ne &&
                      ((Ne = !1),
                      10 <= Math.abs(ht.x) && (ht.x -= De[0].x - mt.x),
                      10 <= Math.abs(ht.y) && (ht.y -= De[0].y - mt.y)),
                    (pt.x = dt.x),
                    (pt.y = dt.y),
                    0 !== ht.x || 0 !== ht.y)
                  ) {
                    if (
                      "v" === He &&
                      g.closeOnVerticalDrag &&
                      "fit" === g.scaleMode &&
                      K === f.currItem.initialZoomLevel
                    ) {
                      (Ve.y += ht.y), (Qe.y += ht.y);
                      var a = B();
                      return (xe = !0), v("onVerticalDrag", a), y(a), void ot();
                    }
                    (e = d()),
                      (t = dt.x),
                      (i = dt.y),
                      50 < e - Ee &&
                        (((a = 2 < vt.length ? vt.shift() : {}).x = t),
                        (a.y = i),
                        vt.push(a),
                        (Ee = e)),
                      (Ie = !0),
                      (qe = f.currItem.bounds),
                      H("x", ht) || (H("y", ht), c(Qe), ot());
                  }
              }
            },
            Mt = function () {
              var t,
                i,
                n = {
                  lastFlickOffset: {},
                  lastFlickDist: {},
                  lastFlickSpeed: {},
                  slowDownRatio: {},
                  slowDownRatioReverse: {},
                  speedDecelerationRatio: {},
                  speedDecelerationRatioAbs: {},
                  distanceOffset: {},
                  backAnimDestination: {},
                  backAnimStarted: {},
                  calculateSwipeSpeed: function (e) {
                    (i =
                      1 < vt.length
                        ? ((t = d() - Ee + 50), vt[vt.length - 2][e])
                        : ((t = d() - _e), mt[e])),
                      (n.lastFlickOffset[e] = pt[e] - i),
                      (n.lastFlickDist[e] = Math.abs(n.lastFlickOffset[e])),
                      20 < n.lastFlickDist[e]
                        ? (n.lastFlickSpeed[e] = n.lastFlickOffset[e] / t)
                        : (n.lastFlickSpeed[e] = 0),
                      Math.abs(n.lastFlickSpeed[e]) < 0.1 &&
                        (n.lastFlickSpeed[e] = 0),
                      (n.slowDownRatio[e] = 0.95),
                      (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                      (n.speedDecelerationRatio[e] = 1);
                  },
                  calculateOverBoundsAnimOffset: function (t, e) {
                    n.backAnimStarted[t] ||
                      (Qe[t] > qe.min[t]
                        ? (n.backAnimDestination[t] = qe.min[t])
                        : Qe[t] < qe.max[t] &&
                          (n.backAnimDestination[t] = qe.max[t]),
                      void 0 !== n.backAnimDestination[t] &&
                        ((n.slowDownRatio[t] = 0.7),
                        (n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t]),
                        n.speedDecelerationRatioAbs[t] < 0.05 &&
                          ((n.lastFlickSpeed[t] = 0),
                          (n.backAnimStarted[t] = !0),
                          I(
                            "bounceZoomPan" + t,
                            Qe[t],
                            n.backAnimDestination[t],
                            e || 300,
                            m.easing.sine.out,
                            function (e) {
                              (Qe[t] = e), ot();
                            }
                          ))));
                  },
                  calculateAnimOffset: function (e) {
                    n.backAnimStarted[e] ||
                      ((n.speedDecelerationRatio[e] =
                        n.speedDecelerationRatio[e] *
                        (n.slowDownRatio[e] +
                          n.slowDownRatioReverse[e] -
                          (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                      (n.speedDecelerationRatioAbs[e] = Math.abs(
                        n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]
                      )),
                      (n.distanceOffset[e] =
                        n.lastFlickSpeed[e] *
                        n.speedDecelerationRatio[e] *
                        n.timeDiff),
                      (Qe[e] += n.distanceOffset[e]));
                  },
                  panAnimLoop: function () {
                    lt.zoomPan &&
                      ((lt.zoomPan.raf = pe(n.panAnimLoop)),
                      (n.now = d()),
                      (n.timeDiff = n.now - n.lastNow),
                      (n.lastNow = n.now),
                      n.calculateAnimOffset("x"),
                      n.calculateAnimOffset("y"),
                      ot(),
                      n.calculateOverBoundsAnimOffset("x"),
                      n.calculateOverBoundsAnimOffset("y"),
                      n.speedDecelerationRatioAbs.x < 0.05 &&
                        n.speedDecelerationRatioAbs.y < 0.05 &&
                        ((Qe.x = Math.round(Qe.x)),
                        (Qe.y = Math.round(Qe.y)),
                        ot(),
                        L("zoomPan")));
                  },
                };
              return n;
            },
            Pt = function (e) {
              if (
                (e.calculateSwipeSpeed("y"),
                (qe = f.currItem.bounds),
                (e.backAnimDestination = {}),
                (e.backAnimStarted = {}),
                Math.abs(e.lastFlickSpeed.x) <= 0.05 &&
                  Math.abs(e.lastFlickSpeed.y) <= 0.05)
              )
                return (
                  (e.speedDecelerationRatioAbs.x =
                    e.speedDecelerationRatioAbs.y =
                      0),
                  e.calculateOverBoundsAnimOffset("x"),
                  e.calculateOverBoundsAnimOffset("y"),
                  !0
                );
              A("zoomPan"), (e.lastNow = d()), e.panAnimLoop();
            },
            Dt = function (e, t) {
              var i, n;
              Re || (bt = X),
                "swipe" === e &&
                  ((n = pt.x - mt.x),
                  (e = t.lastFlickDist.x < 10),
                  30 < n && (e || 20 < t.lastFlickOffset.x)
                    ? (s = -1)
                    : n < -30 && (e || t.lastFlickOffset.x < -20) && (s = 1)),
                s &&
                  ((X += s) < 0
                    ? ((X = g.loop ? Xt() - 1 : 0), (o = !0))
                    : X >= Xt() && ((X = g.loop ? 0 : Xt() - 1), (o = !0)),
                  (o && !g.loop) || ((Ke += s), (Ze -= s), (i = !0)));
              var o = $e.x * Ze,
                s = Math.abs(o - Et.x),
                a =
                  i || o > Et.x == 0 < t.lastFlickSpeed.x
                    ? ((a =
                        0 < Math.abs(t.lastFlickSpeed.x)
                          ? s / Math.abs(t.lastFlickSpeed.x)
                          : 333),
                      (a = Math.min(a, 400)),
                      Math.max(a, 250))
                    : 333;
              return (
                bt === X && (i = !1),
                (Re = !0),
                v("mainScrollAnimStart"),
                I("mainScroll", Et.x, o, a, m.easing.cubic.out, u, function () {
                  T(),
                    (Re = !1),
                    (bt = -1),
                    (!i && bt === X) || f.updateCurrItem(),
                    v("mainScrollAnimComplete");
                }),
                i && f.updateCurrItem(!0),
                i
              );
            },
            zt = function (e) {
              return (1 / Oe) * e * J;
            },
            Ot = function () {
              var e = K,
                t = _(),
                i = E();
              K < t ? (e = t) : i < K && (e = i);
              var n,
                o = Ue;
              return (
                Fe && !ke && !We && K < t
                  ? f.close()
                  : (Fe &&
                      (n = function (e) {
                        y((1 - o) * e + o);
                      }),
                    f.zoomTo(e, 0, 200, m.easing.cubic.out, n)),
                !0
              );
            };
          o("Gestures", {
            publicMethods: {
              initGestures: function () {
                function e(e, t, i, n, o) {
                  (ae = e + t),
                    (re = e + i),
                    (le = e + n),
                    (ce = o ? e + o : "");
                }
                (ue = be.pointerEvent) && be.touch && (be.touch = !1),
                  ue
                    ? navigator.msPointerEnabled
                      ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                      : e("pointer", "down", "move", "up", "cancel")
                    : be.touch
                    ? (e("touch", "start", "move", "end", "cancel"), (he = !0))
                    : e("mouse", "down", "move", "up"),
                  (Z = re + " " + le + " " + ce),
                  (G = ae),
                  ue &&
                    !he &&
                    (he =
                      1 < navigator.maxTouchPoints ||
                      1 < navigator.msMaxTouchPoints),
                  (f.likelyTouchDevice = he),
                  ($[ae] = N),
                  ($[re] = F),
                  ($[le] = U),
                  ce && ($[ce] = $[le]),
                  be.touch &&
                    ((G += " mousedown"),
                    (Z += " mousemove mouseup"),
                    ($.mousedown = $[ae]),
                    ($.mousemove = $[re]),
                    ($.mouseup = $[le])),
                  he || (g.allowPanToNext = !1);
              },
            },
          });
          function qt() {
            return {
              center: { x: 0, y: 0 },
              max: { x: 0, y: 0 },
              min: { x: 0, y: 0 },
            };
          }
          function Bt(e, t, i, n, o, s) {
            t.loadError ||
              (n &&
                ((t.imageAppended = !0),
                Kt(t, n, t === f.currItem && it),
                i.appendChild(n),
                s &&
                  setTimeout(function () {
                    t &&
                      t.loaded &&
                      t.placeholder &&
                      ((t.placeholder.style.display = "none"),
                      (t.placeholder = null));
                  }, 500)));
          }
          function Rt(e) {
            function t() {
              (e.loading = !1),
                (e.loaded = !0),
                e.loadComplete ? e.loadComplete(e) : (e.img = null),
                (i.onload = i.onerror = null),
                (i = null);
            }
            (e.loading = !0), (e.loaded = !1);
            var i = (e.img = m.createEl("pswp__img", "img"));
            return (
              (i.onload = t),
              (i.onerror = function () {
                (e.loadError = !0), t();
              }),
              (i.src = e.src),
              i
            );
          }
          function Ht(e, t) {
            return (
              e.src &&
              e.loadError &&
              e.container &&
              (t && (e.container.innerHTML = ""),
              (e.container.innerHTML = g.errorMsg.replace("%url%", e.src)),
              1)
            );
          }
          function Nt() {
            if (Zt.length) {
              for (var e, t = 0; t < Zt.length; t++)
                (e = Zt[t]).holder.index === e.index &&
                  Bt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
              Zt = [];
            }
          }
          var Ft,
            Ut,
            Wt,
            jt,
            Vt,
            Xt,
            Qt = function (a, e, r, t) {
              var l;
              Ft && clearTimeout(Ft),
                (Wt = jt = !0),
                a.initialLayout
                  ? ((l = a.initialLayout), (a.initialLayout = null))
                  : (l = g.getThumbBoundsFn && g.getThumbBoundsFn(X));
              function c() {
                L("initialZoom"),
                  r
                    ? (f.template.removeAttribute("style"),
                      f.bg.removeAttribute("style"))
                    : (y(1),
                      e && (e.style.display = "block"),
                      m.addClass(p, "pswp--animated-in"),
                      v("initialZoom" + (r ? "OutEnd" : "InEnd"))),
                  t && t(),
                  (jt = !1);
              }
              var d = r ? g.hideAnimationDuration : g.showAnimationDuration;
              if (!d || !l || void 0 === l.x)
                return (
                  v("initialZoom" + (r ? "Out" : "In")),
                  (K = a.initialZoomLevel),
                  b(Qe, a.initialPosition),
                  ot(),
                  (p.style.opacity = r ? 0 : 1),
                  y(1),
                  void (d
                    ? setTimeout(function () {
                        c();
                      }, d)
                    : c())
                );
              var u, h;
              (u = V),
                (h =
                  !f.currItem.src || f.currItem.loadError || g.showHideOpacity),
                a.miniImg &&
                  (a.miniImg.style.webkitBackfaceVisibility = "hidden"),
                r ||
                  ((K = l.w / a.w),
                  (Qe.x = l.x),
                  (Qe.y = l.y - ge),
                  (f[h ? "template" : "bg"].style.opacity = 0.001),
                  ot()),
                A("initialZoom"),
                r && !u && m.removeClass(p, "pswp--animated-in"),
                h &&
                  (r
                    ? m[(u ? "remove" : "add") + "Class"](
                        p,
                        "pswp--animate_opacity"
                      )
                    : setTimeout(function () {
                        m.addClass(p, "pswp--animate_opacity");
                      }, 30)),
                (Ft = setTimeout(
                  function () {
                    var t, i, n, o, s, e;
                    v("initialZoom" + (r ? "Out" : "In")),
                      r
                        ? ((t = l.w / a.w),
                          (i = Qe.x),
                          (n = Qe.y),
                          (o = K),
                          (s = Ue),
                          (e = function (e) {
                            1 === e
                              ? ((K = t), (Qe.x = l.x), (Qe.y = l.y - ye))
                              : ((K = (t - o) * e + o),
                                (Qe.x = (l.x - i) * e + i),
                                (Qe.y = (l.y - ye - n) * e + n)),
                              ot(),
                              h ? (p.style.opacity = 1 - e) : y(s - e * s);
                          }),
                          u
                            ? I(
                                "initialZoom",
                                0,
                                1,
                                d,
                                m.easing.cubic.out,
                                e,
                                c
                              )
                            : (e(1), (Ft = setTimeout(c, d + 20))))
                        : ((K = a.initialZoomLevel),
                          b(Qe, a.initialPosition),
                          ot(),
                          y(1),
                          h ? (p.style.opacity = 1) : y(1),
                          (Ft = setTimeout(c, d + 20)));
                  },
                  r ? 25 : 90
                ));
            },
            Yt = {},
            Zt = [],
            Gt = {
              index: 0,
              errorMsg:
                '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
              forceProgressiveLoading: !1,
              preload: [1, 1],
              getNumItemsFn: function () {
                return Ut.length;
              },
            },
            $t = function (e, t, i) {
              if (!e.src || e.loadError)
                return (
                  (e.w = e.h = 0),
                  (e.initialZoomLevel = e.fitRatio = 1),
                  (e.bounds = qt()),
                  (e.initialPosition = e.bounds.center),
                  e.bounds
                );
              var n,
                o,
                s,
                a = !i;
              return (
                a &&
                  (e.vGap || (e.vGap = { top: 0, bottom: 0 }),
                  v("parseVerticalMargin", e)),
                (Yt.x = t.x),
                (Yt.y = t.y - e.vGap.top - e.vGap.bottom),
                a &&
                  ((n = Yt.x / e.w),
                  (o = Yt.y / e.h),
                  (e.fitRatio = n < o ? n : o),
                  "orig" === (s = g.scaleMode)
                    ? (i = 1)
                    : "fit" === s && (i = e.fitRatio),
                  1 < i && (i = 1),
                  (e.initialZoomLevel = i),
                  e.bounds || (e.bounds = qt())),
                i
                  ? ((n = (t = e).w * i),
                    (o = e.h * i),
                    ((s = t.bounds).center.x = Math.round((Yt.x - n) / 2)),
                    (s.center.y = Math.round((Yt.y - o) / 2) + t.vGap.top),
                    (s.max.x = n > Yt.x ? Math.round(Yt.x - n) : s.center.x),
                    (s.max.y =
                      o > Yt.y
                        ? Math.round(Yt.y - o) + t.vGap.top
                        : s.center.y),
                    (s.min.x = n > Yt.x ? 0 : s.center.x),
                    (s.min.y = o > Yt.y ? t.vGap.top : s.center.y),
                    a &&
                      i === e.initialZoomLevel &&
                      (e.initialPosition = e.bounds.center),
                    e.bounds)
                  : void 0
              );
            },
            Kt = function (e, t, i) {
              var n;
              e.src &&
                ((t = t || e.container.lastChild),
                (n = i ? e.w : Math.round(e.w * e.fitRatio)),
                (i = i ? e.h : Math.round(e.h * e.fitRatio)),
                e.placeholder &&
                  !e.loaded &&
                  ((e.placeholder.style.width = n + "px"),
                  (e.placeholder.style.height = i + "px")),
                (t.style.width = n + "px"),
                (t.style.height = i + "px"));
            };
          o("Controller", {
            publicMethods: {
              lazyLoadItem: function (e) {
                e = a(e);
                var t = Vt(e);
                t &&
                  ((!t.loaded && !t.loading) || ne) &&
                  (v("gettingData", e, t), t.src && Rt(t));
              },
              initController: function () {
                m.extend(g, Gt, !0),
                  (f.items = Ut = e),
                  (Vt = f.getItemAt),
                  (Xt = g.getNumItemsFn)() < 3 && (g.loop = !1),
                  s("beforeChange", function (e) {
                    for (
                      var t = g.preload,
                        i = null === e || 0 <= e,
                        n = Math.min(t[0], Xt()),
                        o = Math.min(t[1], Xt()),
                        s = 1;
                      s <= (i ? o : n);
                      s++
                    )
                      f.lazyLoadItem(X + s);
                    for (s = 1; s <= (i ? n : o); s++) f.lazyLoadItem(X - s);
                  }),
                  s("initialLayout", function () {
                    f.currItem.initialLayout =
                      g.getThumbBoundsFn && g.getThumbBoundsFn(X);
                  }),
                  s("mainScrollAnimComplete", Nt),
                  s("initialZoomInEnd", Nt),
                  s("destroy", function () {
                    for (var e, t = 0; t < Ut.length; t++)
                      (e = Ut[t]).container && (e.container = null),
                        e.placeholder && (e.placeholder = null),
                        e.img && (e.img = null),
                        e.preloader && (e.preloader = null),
                        e.loadError && (e.loaded = e.loadError = !1);
                    Zt = null;
                  });
              },
              getItemAt: function (e) {
                return 0 <= e && void 0 !== Ut[e] && Ut[e];
              },
              allowProgressiveImg: function () {
                return (
                  g.forceProgressiveLoading ||
                  !he ||
                  g.mouseUsed ||
                  1200 < screen.width
                );
              },
              setContent: function (t, i) {
                g.loop && (i = a(i));
                var e = f.getItemAt(t.index);
                e && (e.container = null);
                var n,
                  o,
                  s = f.getItemAt(i);
                s
                  ? (v("gettingData", i, s),
                    (t.index = i),
                    (o = (t.item = s).container =
                      m.createEl("pswp__zoom-wrap")),
                    !s.src &&
                      s.html &&
                      (s.html.tagName
                        ? o.appendChild(s.html)
                        : (o.innerHTML = s.html)),
                    Ht(s),
                    $t(s, Ye),
                    !s.src || s.loadError || s.loaded
                      ? s.src &&
                        !s.loadError &&
                        (((n = m.createEl(
                          "pswp__img",
                          "img"
                        )).style.opacity = 1),
                        (n.src = s.src),
                        Kt(s, n),
                        Bt(0, s, o, n))
                      : ((s.loadComplete = function (e) {
                          if (W) {
                            if (t && t.index === i) {
                              if (Ht(e, !0))
                                return (
                                  (e.loadComplete = e.img = null),
                                  $t(e, Ye),
                                  st(e),
                                  void (t.index === X && f.updateCurrZoomItem())
                                );
                              e.imageAppended
                                ? !jt &&
                                  e.placeholder &&
                                  ((e.placeholder.style.display = "none"),
                                  (e.placeholder = null))
                                : be.transform && (Re || jt)
                                ? Zt.push({
                                    item: e,
                                    baseDiv: o,
                                    img: e.img,
                                    index: i,
                                    holder: t,
                                    clearPlaceholder: !0,
                                  })
                                : Bt(0, e, o, e.img, 0, !0);
                            }
                            (e.loadComplete = null),
                              (e.img = null),
                              v("imageLoadComplete", i, e);
                          }
                        }),
                        m.features.transform &&
                          ((e = "pswp__img pswp__img--placeholder"),
                          (e += s.msrc ? "" : " pswp__img--placeholder--blank"),
                          (e = m.createEl(e, s.msrc ? "img" : "")),
                          s.msrc && (e.src = s.msrc),
                          Kt(s, e),
                          o.appendChild(e),
                          (s.placeholder = e)),
                        s.loading || Rt(s),
                        f.allowProgressiveImg() &&
                          (!Wt && be.transform
                            ? Zt.push({
                                item: s,
                                baseDiv: o,
                                img: s.img,
                                index: i,
                                holder: t,
                              })
                            : Bt(0, s, o, s.img, 0, !0))),
                    Wt || i !== X ? st(s) : ((Be = o.style), Qt(s, n || s.img)),
                    (t.el.innerHTML = ""),
                    t.el.appendChild(o))
                  : (t.el.innerHTML = "");
              },
              cleanSlide: function (e) {
                e.img && (e.img.onload = e.img.onerror = null),
                  (e.loaded = e.loading = e.img = e.imageAppended = !1);
              },
            },
          });
          function Jt(e, t, i) {
            var n = document.createEvent("CustomEvent"),
              i = {
                origEvent: e,
                target: e.target,
                releasePoint: t,
                pointerType: i || "touch",
              };
            n.initCustomEvent("pswpTap", !0, !0, i), e.target.dispatchEvent(n);
          }
          var ei,
            ti,
            ii = {};
          o("Tap", {
            publicMethods: {
              initTap: function () {
                s("firstTouchStart", f.onTapStart),
                  s("touchRelease", f.onTapRelease),
                  s("destroy", function () {
                    (ii = {}), (ei = null);
                  });
              },
              onTapStart: function (e) {
                1 < e.length && (clearTimeout(ei), (ei = null));
              },
              onTapRelease: function (e, t) {
                var i, n, o;
                t &&
                  (Ie ||
                    Ae ||
                    ct ||
                    ((i = t),
                    ei &&
                    (clearTimeout(ei),
                    (ei = null),
                    (n = i),
                    (o = ii),
                    Math.abs(n.x - o.x) < 25 && Math.abs(n.y - o.y) < 25)
                      ? v("doubleTap", i)
                      : "mouse" !== t.type
                      ? "BUTTON" === e.target.tagName.toUpperCase() ||
                        m.hasClass(e.target, "pswp__single-tap")
                        ? Jt(e, t)
                        : (b(ii, i),
                          (ei = setTimeout(function () {
                            Jt(e, t), (ei = null);
                          }, 300)))
                      : Jt(e, t, "mouse")));
              },
            },
          }),
            o("DesktopZoom", {
              publicMethods: {
                initDesktopZoom: function () {
                  ve ||
                    (he
                      ? s("mouseUsed", function () {
                          f.setupDesktopZoom();
                        })
                      : f.setupDesktopZoom(!0));
                },
                setupDesktopZoom: function (e) {
                  ti = {};
                  var t = "wheel mousewheel DOMMouseScroll";
                  s("bindEvents", function () {
                    m.bind(p, t, f.handleMouseWheel);
                  }),
                    s("unbindEvents", function () {
                      ti && m.unbind(p, t, f.handleMouseWheel);
                    }),
                    (f.mouseZoomedIn = !1);
                  function i() {
                    f.mouseZoomedIn &&
                      (m.removeClass(p, "pswp--zoomed-in"),
                      (f.mouseZoomedIn = !1)),
                      K < 1
                        ? m.addClass(p, "pswp--zoom-allowed")
                        : m.removeClass(p, "pswp--zoom-allowed"),
                      o();
                  }
                  var n,
                    o = function () {
                      n && (m.removeClass(p, "pswp--dragging"), (n = !1));
                    };
                  s("resize", i),
                    s("afterChange", i),
                    s("pointerDown", function () {
                      f.mouseZoomedIn &&
                        ((n = !0), m.addClass(p, "pswp--dragging"));
                    }),
                    s("pointerUp", o),
                    e || i();
                },
                handleMouseWheel: function (e) {
                  if (K <= f.currItem.fitRatio)
                    return (
                      g.modal &&
                        (!g.closeOnScroll || ct || Le
                          ? e.preventDefault()
                          : de &&
                            2 < Math.abs(e.deltaY) &&
                            ((V = !0), f.close())),
                      !0
                    );
                  if ((e.stopPropagation(), (ti.x = 0), "deltaX" in e))
                    1 === e.deltaMode
                      ? ((ti.x = 18 * e.deltaX), (ti.y = 18 * e.deltaY))
                      : ((ti.x = e.deltaX), (ti.y = e.deltaY));
                  else if ("wheelDelta" in e)
                    e.wheelDeltaX && (ti.x = -0.16 * e.wheelDeltaX),
                      e.wheelDeltaY
                        ? (ti.y = -0.16 * e.wheelDeltaY)
                        : (ti.y = -0.16 * e.wheelDelta);
                  else {
                    if (!("detail" in e)) return;
                    ti.y = e.detail;
                  }
                  w(K, !0);
                  var t = Qe.x - ti.x,
                    i = Qe.y - ti.y;
                  (g.modal ||
                    (t <= qe.min.x &&
                      t >= qe.max.x &&
                      i <= qe.min.y &&
                      i >= qe.max.y)) &&
                    e.preventDefault(),
                    f.panTo(t, i);
                },
                toggleDesktopZoom: function (e) {
                  e = e || { x: Ye.x / 2 + Ge.x, y: Ye.y / 2 + Ge.y };
                  var t = g.getDoubleTapZoom(!0, f.currItem),
                    i = K === t;
                  (f.mouseZoomedIn = !i),
                    f.zoomTo(i ? f.currItem.initialZoomLevel : t, e, 333),
                    m[(i ? "remove" : "add") + "Class"](p, "pswp--zoomed-in");
                },
              },
            });
          function ni() {
            return vi.hash.substring(1);
          }
          function oi() {
            ri && clearTimeout(ri), ci && clearTimeout(ci);
          }
          function si() {
            var e = ni(),
              t = {};
            if (e.length < 5) return t;
            var i,
              n = e.split("&");
            for (s = 0; s < n.length; s++)
              n[s] && ((i = n[s].split("=")).length < 2 || (t[i[0]] = i[1]));
            if (g.galleryPIDs) {
              for (var o = t.pid, s = (t.pid = 0); s < Ut.length; s++)
                if (Ut[s].pid === o) {
                  t.pid = s;
                  break;
                }
            } else t.pid = parseInt(t.pid, 10) - 1;
            return t.pid < 0 && (t.pid = 0), t;
          }
          function ai() {
            var e, t;
            ci && clearTimeout(ci),
              ct || Le
                ? (ci = setTimeout(ai, 500))
                : (di ? clearTimeout(li) : (di = !0),
                  (t = X + 1),
                  (e = Vt(X)).hasOwnProperty("pid") && (t = e.pid),
                  (e = pi + "&gid=" + g.galleryUID + "&pid=" + t),
                  mi || (-1 === vi.hash.indexOf(e) && (gi = !0)),
                  (t = vi.href.split("#")[0] + "#" + e),
                  yi
                    ? "#" + e !== window.location.hash &&
                      history[mi ? "replaceState" : "pushState"](
                        "",
                        document.title,
                        t
                      )
                    : mi
                    ? vi.replace(t)
                    : (vi.hash = e),
                  (mi = !0),
                  (li = setTimeout(function () {
                    di = !1;
                  }, 60)));
          }
          var ri,
            li,
            ci,
            di,
            ui,
            hi,
            pi,
            mi,
            fi,
            gi,
            vi,
            yi,
            bi = { history: !0, galleryUID: 1 };
          o("History", {
            publicMethods: {
              initHistory: function () {
                var e, t;
                m.extend(g, bi, !0),
                  g.history &&
                    ((vi = window.location),
                    (mi = fi = gi = !1),
                    (pi = ni()),
                    (yi = "pushState" in history),
                    -1 < pi.indexOf("gid=") &&
                      (pi = (pi = pi.split("&gid=")[0]).split("?gid=")[0]),
                    s("afterChange", f.updateURL),
                    s("unbindEvents", function () {
                      m.unbind(window, "hashchange", f.onHashChange);
                    }),
                    (e = function () {
                      (hi = !0),
                        fi ||
                          (gi
                            ? history.back()
                            : pi
                            ? (vi.hash = pi)
                            : yi
                            ? history.pushState(
                                "",
                                document.title,
                                vi.pathname + vi.search
                              )
                            : (vi.hash = "")),
                        oi();
                    }),
                    s("unbindEvents", function () {
                      V && e();
                    }),
                    s("destroy", function () {
                      hi || e();
                    }),
                    s("firstUpdate", function () {
                      X = si().pid;
                    }),
                    -1 < (t = pi.indexOf("pid=")) &&
                      "&" === (pi = pi.substring(0, t)).slice(-1) &&
                      (pi = pi.slice(0, -1)),
                    setTimeout(function () {
                      W && m.bind(window, "hashchange", f.onHashChange);
                    }, 40));
              },
              onHashChange: function () {
                if (ni() === pi) return (fi = !0), void f.close();
                di || ((ui = !0), f.goTo(si().pid), (ui = !1));
              },
              updateURL: function () {
                oi(), ui || (mi ? (ri = setTimeout(ai, 800)) : ai());
              },
            },
          }),
            m.extend(f, t);
        };
      });
    function te(e) {
      return (te =
        "function" == typeof Symbol && "symbol" === wi(Symbol.iterator)
          ? function (e) {
              return wi(e);
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : wi(e);
            })(e);
    }
    var ie =
      "object" ===
      ("undefined" == typeof HTMLElement ? "undefined" : te(HTMLElement));
    function ne(e) {
      return ie
        ? e instanceof HTMLElement
        : e &&
            "object" === te(e) &&
            null !== e &&
            1 === e.nodeType &&
            "string" == typeof e.nodeName;
    }
    function oe(t, e) {
      e.forEach(function (e) {
        t.classList.add(e);
      });
    }
    function se(t, e) {
      e.forEach(function (e) {
        t.classList.remove(e);
      });
    }
    var ae =
      ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
    function re() {
      throw new Error("Missing parameter");
    }
    function le(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var ce = (function () {
      function n(e) {
        !(function (e) {
          if (!(e instanceof n))
            throw new TypeError("Cannot call a class as a function");
        })(this),
          (this.isShowing = !1);
        var t = e.namespace,
          i = void 0 === t ? null : t,
          t = e.zoomFactor,
          t = void 0 === t ? re() : t,
          e = e.containerEl,
          e = void 0 === e ? re() : e;
        (this.settings = { namespace: i, zoomFactor: t, containerEl: e }),
          (this.openClasses = this._buildClasses("open")),
          this._buildElement();
      }
      var e, t, i;
      return (
        (e = n),
        (t = [
          {
            key: "_buildClasses",
            value: function (e) {
              var t = ["drift-".concat(e)],
                i = this.settings.namespace;
              return i && t.push("".concat(i, "-").concat(e)), t;
            },
          },
          {
            key: "_buildElement",
            value: function () {
              (this.el = document.createElement("div")),
                oe(this.el, this._buildClasses("bounding-box"));
            },
          },
          {
            key: "show",
            value: function (e, t) {
              (this.isShowing = !0),
                this.settings.containerEl.appendChild(this.el);
              var i = this.el.style;
              (i.width = "".concat(
                Math.round(e / this.settings.zoomFactor),
                "px"
              )),
                (i.height = "".concat(
                  Math.round(t / this.settings.zoomFactor),
                  "px"
                )),
                oe(this.el, this.openClasses);
            },
          },
          {
            key: "hide",
            value: function () {
              this.isShowing && this.settings.containerEl.removeChild(this.el),
                (this.isShowing = !1),
                se(this.el, this.openClasses);
            },
          },
          {
            key: "setPosition",
            value: function (e, t, i) {
              var n = window.pageXOffset,
                o = window.pageYOffset,
                e = i.left + e * i.width - this.el.clientWidth / 2 + n,
                t = i.top + t * i.height - this.el.clientHeight / 2 + o;
              e < i.left + n
                ? (e = i.left + n)
                : e + this.el.clientWidth > i.left + i.width + n &&
                  (e = i.left + i.width - this.el.clientWidth + n),
                t < i.top + o
                  ? (t = i.top + o)
                  : t + this.el.clientHeight > i.top + i.height + o &&
                    (t = i.top + i.height - this.el.clientHeight + o),
                (this.el.style.left = "".concat(e, "px")),
                (this.el.style.top = "".concat(t, "px"));
            },
          },
        ]) && le(e.prototype, t),
        i && le(e, i),
        n
      );
    })();
    function de(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var ue = (function () {
      function p() {
        var e =
          0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        !(function (e) {
          if (!(e instanceof p))
            throw new TypeError("Cannot call a class as a function");
        })(this),
          (this._show = this._show.bind(this)),
          (this._hide = this._hide.bind(this)),
          (this._handleEntry = this._handleEntry.bind(this)),
          (this._handleMovement = this._handleMovement.bind(this));
        var t = e.el,
          i = void 0 === t ? re() : t,
          n = e.zoomPane,
          o = void 0 === n ? re() : n,
          s = e.sourceAttribute,
          a = void 0 === s ? re() : s,
          r = e.handleTouch,
          l = void 0 === r ? re() : r,
          c = e.onShow,
          d = void 0 === c ? null : c,
          u = e.onHide,
          h = void 0 === u ? null : u,
          t = e.hoverDelay,
          n = void 0 === t ? 0 : t,
          s = e.touchDelay,
          r = void 0 === s ? 0 : s,
          c = e.hoverBoundingBox,
          u = void 0 === c ? re() : c,
          t = e.touchBoundingBox,
          s = void 0 === t ? re() : t,
          c = e.namespace,
          t = void 0 === c ? null : c,
          c = e.zoomFactor,
          c = void 0 === c ? re() : c,
          e = e.boundingBoxContainer,
          e = void 0 === e ? re() : e;
        (this.settings = {
          el: i,
          zoomPane: o,
          sourceAttribute: a,
          handleTouch: l,
          onShow: d,
          onHide: h,
          hoverDelay: n,
          touchDelay: r,
          hoverBoundingBox: u,
          touchBoundingBox: s,
          namespace: t,
          zoomFactor: c,
          boundingBoxContainer: e,
        }),
          (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) &&
            (this.boundingBox = new ce({
              namespace: this.settings.namespace,
              zoomFactor: this.settings.zoomFactor,
              containerEl: this.settings.boundingBoxContainer,
            })),
          (this.enabled = !0),
          this._bindEvents();
      }
      var e, t, i;
      return (
        (e = p),
        (t = [
          {
            key: "_preventDefault",
            value: function (e) {
              e.preventDefault();
            },
          },
          {
            key: "_preventDefaultAllowTouchScroll",
            value: function (e) {
              (this.settings.touchDelay &&
                this._isTouchEvent(e) &&
                !this.isShowing) ||
                e.preventDefault();
            },
          },
          {
            key: "_isTouchEvent",
            value: function (e) {
              return !!e.touches;
            },
          },
          {
            key: "_bindEvents",
            value: function () {
              this.settings.el.addEventListener(
                "mouseenter",
                this._handleEntry,
                !1
              ),
                this.settings.el.addEventListener("mouseleave", this._hide, !1),
                this.settings.el.addEventListener(
                  "mousemove",
                  this._handleMovement,
                  !1
                ),
                this.settings.handleTouch
                  ? (this.settings.el.addEventListener(
                      "touchstart",
                      this._handleEntry,
                      !1
                    ),
                    this.settings.el.addEventListener(
                      "touchend",
                      this._hide,
                      !1
                    ),
                    this.settings.el.addEventListener(
                      "touchmove",
                      this._handleMovement,
                      !1
                    ))
                  : (this.settings.el.addEventListener(
                      "touchstart",
                      this._preventDefault,
                      !1
                    ),
                    this.settings.el.addEventListener(
                      "touchend",
                      this._preventDefault,
                      !1
                    ),
                    this.settings.el.addEventListener(
                      "touchmove",
                      this._preventDefault,
                      !1
                    ));
            },
          },
          {
            key: "_unbindEvents",
            value: function () {
              this.settings.el.removeEventListener(
                "mouseenter",
                this._handleEntry,
                !1
              ),
                this.settings.el.removeEventListener(
                  "mouseleave",
                  this._hide,
                  !1
                ),
                this.settings.el.removeEventListener(
                  "mousemove",
                  this._handleMovement,
                  !1
                ),
                this.settings.handleTouch
                  ? (this.settings.el.removeEventListener(
                      "touchstart",
                      this._handleEntry,
                      !1
                    ),
                    this.settings.el.removeEventListener(
                      "touchend",
                      this._hide,
                      !1
                    ),
                    this.settings.el.removeEventListener(
                      "touchmove",
                      this._handleMovement,
                      !1
                    ))
                  : (this.settings.el.removeEventListener(
                      "touchstart",
                      this._preventDefault,
                      !1
                    ),
                    this.settings.el.removeEventListener(
                      "touchend",
                      this._preventDefault,
                      !1
                    ),
                    this.settings.el.removeEventListener(
                      "touchmove",
                      this._preventDefault,
                      !1
                    ));
            },
          },
          {
            key: "_handleEntry",
            value: function (e) {
              this._preventDefaultAllowTouchScroll(e),
                "mouseenter" == (this._lastMovement = e).type &&
                this.settings.hoverDelay
                  ? (this.entryTimeout = setTimeout(
                      this._show,
                      this.settings.hoverDelay
                    ))
                  : this.settings.touchDelay
                  ? (this.entryTimeout = setTimeout(
                      this._show,
                      this.settings.touchDelay
                    ))
                  : this._show();
            },
          },
          {
            key: "_show",
            value: function () {
              var e;
              this.enabled &&
                ((e = this.settings.onShow) && "function" == typeof e && e(),
                this.settings.zoomPane.show(
                  this.settings.el.getAttribute(this.settings.sourceAttribute),
                  this.settings.el.clientWidth,
                  this.settings.el.clientHeight
                ),
                !this._lastMovement ||
                  ((((e = this._lastMovement.touches) &&
                    this.settings.touchBoundingBox) ||
                    (!e && this.settings.hoverBoundingBox)) &&
                    this.boundingBox.show(
                      this.settings.zoomPane.el.clientWidth,
                      this.settings.zoomPane.el.clientHeight
                    )),
                this._handleMovement());
            },
          },
          {
            key: "_hide",
            value: function (e) {
              e && this._preventDefaultAllowTouchScroll(e),
                (this._lastMovement = null),
                this.entryTimeout && clearTimeout(this.entryTimeout),
                this.boundingBox && this.boundingBox.hide();
              e = this.settings.onHide;
              e && "function" == typeof e && e(), this.settings.zoomPane.hide();
            },
          },
          {
            key: "_handleMovement",
            value: function (e) {
              if (e)
                this._preventDefaultAllowTouchScroll(e),
                  (this._lastMovement = e);
              else {
                if (!this._lastMovement) return;
                e = this._lastMovement;
              }
              i = e.touches
                ? ((t = (i = e.touches[0]).clientX), i.clientY)
                : ((t = e.clientX), e.clientY);
              var e = this.settings.el.getBoundingClientRect(),
                t = t - e.left,
                i = i - e.top,
                t = t / this.settings.el.clientWidth,
                i = i / this.settings.el.clientHeight;
              this.boundingBox && this.boundingBox.setPosition(t, i, e),
                this.settings.zoomPane.setPosition(t, i, e);
            },
          },
          {
            key: "isShowing",
            get: function () {
              return this.settings.zoomPane.isShowing;
            },
          },
        ]) && de(e.prototype, t),
        i && de(e, i),
        p
      );
    })();
    function he(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var pe = document.createElement("div").style,
      me =
        "undefined" != typeof document &&
        ("animation" in pe || "webkitAnimation" in pe),
      fe = (function () {
        function c() {
          var e =
            0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (e) {
            if (!(e instanceof c))
              throw new TypeError("Cannot call a class as a function");
          })(this),
            (this._completeShow = this._completeShow.bind(this)),
            (this._completeHide = this._completeHide.bind(this)),
            (this._handleLoad = this._handleLoad.bind(this)),
            (this.isShowing = !1);
          var t = e.container,
            i = void 0 === t ? null : t,
            n = e.zoomFactor,
            o = void 0 === n ? re() : n,
            s = e.inline,
            a = void 0 === s ? re() : s,
            r = e.namespace,
            l = void 0 === r ? null : r,
            t = e.showWhitespaceAtEdges,
            n = void 0 === t ? re() : t,
            s = e.containInline,
            r = void 0 === s ? re() : s,
            t = e.inlineOffsetX,
            s = void 0 === t ? 0 : t,
            t = e.inlineOffsetY,
            t = void 0 === t ? 0 : t,
            e = e.inlineContainer,
            e = void 0 === e ? document.body : e;
          (this.settings = {
            container: i,
            zoomFactor: o,
            inline: a,
            namespace: l,
            showWhitespaceAtEdges: n,
            containInline: r,
            inlineOffsetX: s,
            inlineOffsetY: t,
            inlineContainer: e,
          }),
            (this.openClasses = this._buildClasses("open")),
            (this.openingClasses = this._buildClasses("opening")),
            (this.closingClasses = this._buildClasses("closing")),
            (this.inlineClasses = this._buildClasses("inline")),
            (this.loadingClasses = this._buildClasses("loading")),
            this._buildElement();
        }
        var e, t, i;
        return (
          (e = c),
          (t = [
            {
              key: "_buildClasses",
              value: function (e) {
                var t = ["drift-".concat(e)],
                  i = this.settings.namespace;
                return i && t.push("".concat(i, "-").concat(e)), t;
              },
            },
            {
              key: "_buildElement",
              value: function () {
                (this.el = document.createElement("div")),
                  oe(this.el, this._buildClasses("zoom-pane"));
                var e = document.createElement("div");
                oe(e, this._buildClasses("zoom-pane-loader")),
                  this.el.appendChild(e),
                  (this.imgEl = document.createElement("img")),
                  this.el.appendChild(this.imgEl);
              },
            },
            {
              key: "_setImageURL",
              value: function (e) {
                this.imgEl.setAttribute("src", e);
              },
            },
            {
              key: "_setImageSize",
              value: function (e, t) {
                (this.imgEl.style.width = "".concat(
                  e * this.settings.zoomFactor,
                  "px"
                )),
                  (this.imgEl.style.height = "".concat(
                    t * this.settings.zoomFactor,
                    "px"
                  ));
              },
            },
            {
              key: "setPosition",
              value: function (e, t, i) {
                var n = this.imgEl.offsetWidth,
                  o = this.imgEl.offsetHeight,
                  s = this.el.offsetWidth,
                  a = this.el.offsetHeight,
                  r = s / 2 - n * e,
                  l = a / 2 - o * t,
                  c = s - n,
                  d = a - o,
                  u = 0 < c,
                  h = 0 < d,
                  n = u ? c / 2 : 0,
                  o = h ? d / 2 : 0,
                  u = u ? c / 2 : c,
                  c = h ? d / 2 : d;
                this.el.parentElement === this.settings.inlineContainer &&
                  ((h = window.pageXOffset),
                  (d = window.pageYOffset),
                  (e =
                    i.left +
                    e * i.width -
                    s / 2 +
                    this.settings.inlineOffsetX +
                    h),
                  (t =
                    i.top +
                    t * i.height -
                    a / 2 +
                    this.settings.inlineOffsetY +
                    d),
                  this.settings.containInline &&
                    (e < i.left + h
                      ? (e = i.left + h)
                      : e + s > i.left + i.width + h &&
                        (e = i.left + i.width - s + h),
                    t < i.top + d
                      ? (t = i.top + d)
                      : t + a > i.top + i.height + d &&
                        (t = i.top + i.height - a + d)),
                  (this.el.style.left = "".concat(e, "px")),
                  (this.el.style.top = "".concat(t, "px"))),
                  this.settings.showWhitespaceAtEdges ||
                    (n < r ? (r = n) : r < u && (r = u),
                    o < l ? (l = o) : l < c && (l = c)),
                  (this.imgEl.style.transform = "translate("
                    .concat(r, "px, ")
                    .concat(l, "px)")),
                  (this.imgEl.style.webkitTransform = "translate("
                    .concat(r, "px, ")
                    .concat(l, "px)"));
              },
            },
            {
              key: "_removeListenersAndResetClasses",
              value: function () {
                this.el.removeEventListener(
                  "animationend",
                  this._completeShow,
                  !1
                ),
                  this.el.removeEventListener(
                    "animationend",
                    this._completeHide,
                    !1
                  ),
                  this.el.removeEventListener(
                    "webkitAnimationEnd",
                    this._completeShow,
                    !1
                  ),
                  this.el.removeEventListener(
                    "webkitAnimationEnd",
                    this._completeHide,
                    !1
                  ),
                  se(this.el, this.openClasses),
                  se(this.el, this.closingClasses);
              },
            },
            {
              key: "show",
              value: function (e, t, i) {
                this._removeListenersAndResetClasses(),
                  (this.isShowing = !0),
                  oe(this.el, this.openClasses),
                  this.imgEl.getAttribute("src") != e &&
                    (oe(this.el, this.loadingClasses),
                    this.imgEl.addEventListener("load", this._handleLoad, !1),
                    this._setImageURL(e)),
                  this._setImageSize(t, i),
                  this._isInline ? this._showInline() : this._showInContainer(),
                  me &&
                    (this.el.addEventListener(
                      "animationend",
                      this._completeShow,
                      !1
                    ),
                    this.el.addEventListener(
                      "webkitAnimationEnd",
                      this._completeShow,
                      !1
                    ),
                    oe(this.el, this.openingClasses));
              },
            },
            {
              key: "_showInline",
              value: function () {
                this.settings.inlineContainer.appendChild(this.el),
                  oe(this.el, this.inlineClasses);
              },
            },
            {
              key: "_showInContainer",
              value: function () {
                this.settings.container.appendChild(this.el);
              },
            },
            {
              key: "hide",
              value: function () {
                this._removeListenersAndResetClasses(),
                  (this.isShowing = !1),
                  me
                    ? (this.el.addEventListener(
                        "animationend",
                        this._completeHide,
                        !1
                      ),
                      this.el.addEventListener(
                        "webkitAnimationEnd",
                        this._completeHide,
                        !1
                      ),
                      oe(this.el, this.closingClasses))
                    : (se(this.el, this.openClasses),
                      se(this.el, this.inlineClasses));
              },
            },
            {
              key: "_completeShow",
              value: function () {
                this.el.removeEventListener(
                  "animationend",
                  this._completeShow,
                  !1
                ),
                  this.el.removeEventListener(
                    "webkitAnimationEnd",
                    this._completeShow,
                    !1
                  ),
                  se(this.el, this.openingClasses);
              },
            },
            {
              key: "_completeHide",
              value: function () {
                this.el.removeEventListener(
                  "animationend",
                  this._completeHide,
                  !1
                ),
                  this.el.removeEventListener(
                    "webkitAnimationEnd",
                    this._completeHide,
                    !1
                  ),
                  se(this.el, this.openClasses),
                  se(this.el, this.closingClasses),
                  se(this.el, this.inlineClasses),
                  this.el.setAttribute("style", ""),
                  this.el.parentElement === this.settings.container
                    ? this.settings.container.removeChild(this.el)
                    : this.el.parentElement === this.settings.inlineContainer &&
                      this.settings.inlineContainer.removeChild(this.el);
              },
            },
            {
              key: "_handleLoad",
              value: function () {
                this.imgEl.removeEventListener("load", this._handleLoad, !1),
                  se(this.el, this.loadingClasses);
              },
            },
            {
              key: "_isInline",
              get: function () {
                var e = this.settings.inline;
                return (
                  !0 === e || ("number" == typeof e && window.innerWidth <= e)
                );
              },
            },
          ]) && he(e.prototype, t),
          i && he(e, i),
          c
        );
      })();
    function ge(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var ve = (function () {
      function b(e) {
        var t =
          1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        if (
          (!(function (e) {
            if (!(e instanceof b))
              throw new TypeError("Cannot call a class as a function");
          })(this),
          (this.VERSION = "1.4.0"),
          (this.triggerEl = e),
          (this.destroy = this.destroy.bind(this)),
          !ne(this.triggerEl))
        )
          throw new TypeError(
            "`new Drift` requires a DOM element as its first argument."
          );
        var i = t.namespace || null,
          n = t.showWhitespaceAtEdges || !1,
          o = t.containInline || !1,
          s = t.inlineOffsetX || 0,
          a = t.inlineOffsetY || 0,
          r = t.inlineContainer || document.body,
          l = t.sourceAttribute || "data-zoom",
          c = t.zoomFactor || 3,
          d = void 0 === t.paneContainer ? document.body : t.paneContainer,
          u = t.inlinePane || 375,
          h = !("handleTouch" in t) || !!t.handleTouch,
          p = t.onShow || null,
          m = t.onHide || null,
          f = !("injectBaseStyles" in t) || !!t.injectBaseStyles,
          g = t.hoverDelay || 0,
          v = t.touchDelay || 0,
          y = t.hoverBoundingBox || !1,
          e = t.touchBoundingBox || !1,
          t = t.boundingBoxContainer || document.body;
        if (!0 !== u && !ne(d))
          throw new TypeError(
            "`paneContainer` must be a DOM element when `inlinePane !== true`"
          );
        if (!ne(r))
          throw new TypeError("`inlineContainer` must be a DOM element");
        (this.settings = {
          namespace: i,
          showWhitespaceAtEdges: n,
          containInline: o,
          inlineOffsetX: s,
          inlineOffsetY: a,
          inlineContainer: r,
          sourceAttribute: l,
          zoomFactor: c,
          paneContainer: d,
          inlinePane: u,
          handleTouch: h,
          onShow: p,
          onHide: m,
          injectBaseStyles: f,
          hoverDelay: g,
          touchDelay: v,
          hoverBoundingBox: y,
          touchBoundingBox: e,
          boundingBoxContainer: t,
        }),
          this.settings.injectBaseStyles &&
            (document.querySelector(".drift-base-styles") ||
              (((e = document.createElement("style")).type = "text/css"),
              e.classList.add("drift-base-styles"),
              e.appendChild(document.createTextNode(ae)),
              (t = document.head).insertBefore(e, t.firstChild))),
          this._buildZoomPane(),
          this._buildTrigger();
      }
      var e, t, i;
      return (
        (e = b),
        (t = [
          {
            key: "_buildZoomPane",
            value: function () {
              this.zoomPane = new fe({
                container: this.settings.paneContainer,
                zoomFactor: this.settings.zoomFactor,
                showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                containInline: this.settings.containInline,
                inline: this.settings.inlinePane,
                namespace: this.settings.namespace,
                inlineOffsetX: this.settings.inlineOffsetX,
                inlineOffsetY: this.settings.inlineOffsetY,
                inlineContainer: this.settings.inlineContainer,
              });
            },
          },
          {
            key: "_buildTrigger",
            value: function () {
              this.trigger = new ue({
                el: this.triggerEl,
                zoomPane: this.zoomPane,
                handleTouch: this.settings.handleTouch,
                onShow: this.settings.onShow,
                onHide: this.settings.onHide,
                sourceAttribute: this.settings.sourceAttribute,
                hoverDelay: this.settings.hoverDelay,
                touchDelay: this.settings.touchDelay,
                hoverBoundingBox: this.settings.hoverBoundingBox,
                touchBoundingBox: this.settings.touchBoundingBox,
                namespace: this.settings.namespace,
                zoomFactor: this.settings.zoomFactor,
                boundingBoxContainer: this.settings.boundingBoxContainer,
              });
            },
          },
          {
            key: "setZoomImageURL",
            value: function (e) {
              this.zoomPane._setImageURL(e);
            },
          },
          {
            key: "disable",
            value: function () {
              this.trigger.enabled = !1;
            },
          },
          {
            key: "enable",
            value: function () {
              this.trigger.enabled = !0;
            },
          },
          {
            key: "destroy",
            value: function () {
              this.trigger._hide(), this.trigger._unbindEvents();
            },
          },
          {
            key: "isShowing",
            get: function () {
              return this.zoomPane.isShowing;
            },
          },
          {
            key: "zoomFactor",
            get: function () {
              return this.settings.zoomFactor;
            },
            set: function (e) {
              (this.settings.zoomFactor = e),
                (this.zoomPane.settings.zoomFactor = e),
                (this.trigger.settings.zoomFactor = e),
                (this.boundingBox.settings.zoomFactor = e);
            },
          },
        ]) && ge(e.prototype, t),
        i && ge(e, i),
        b
      );
    })();
    Object.defineProperty(ve.prototype, "isShowing", {
      get: function () {
        return this.isShowing;
      },
    }),
      Object.defineProperty(ve.prototype, "zoomFactor", {
        get: function () {
          return this.zoomFactor;
        },
        set: function (e) {
          this.zoomFactor = e;
        },
      }),
      (ve.prototype.setZoomImageURL = ve.prototype.setZoomImageURL),
      (ve.prototype.disable = ve.prototype.disable),
      (ve.prototype.enable = ve.prototype.enable),
      (ve.prototype.destroy = ve.prototype.destroy);
    function ye(e) {
      a(this, ye),
        (this.element = e),
        !Shopify.designMode ||
          ((e = this.element.querySelector(".page__header")) &&
            (document
              .querySelector(".blog-container")
              .previousElementSibling.remove(),
            document
              .querySelector(".blog-container")
              .insertAdjacentElement("beforebegin", e)));
    }
    function be(e) {
      a(this, be),
        (this.element = e),
        Shopify.designMode &&
          this.element.classList.remove("hidden-lap-and-up");
    }
    var we,
      _e,
      Ee = (function () {
        function i(e, t) {
          a(this, i),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.viewInSpaceElement =
              this.element.querySelector("[data-shopify-xr]")),
            (this.options = t),
            (this.media = {}),
            (this.previouslySelectedMedia = null),
            this._createCarousel(),
            this._createZoom(),
            this._attachListeners();
        }
        return (
          r(i, [
            {
              key: "destroy",
              value: function () {
                for (var e in (this.flickityInstance &&
                  this.flickityInstance.destroy(),
                this.media))
                  this.media.hasOwnProperty(e) && this.media[e].destroy();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                var e = this;
                this.delegateElement.on(
                  "model:played",
                  this._disableDrag.bind(this)
                ),
                  this.delegateElement.on(
                    "video:played",
                    this._disableDrag.bind(this)
                  ),
                  this.delegateElement.on(
                    "model:paused",
                    this._enableDrag.bind(this)
                  ),
                  this.delegateElement.on(
                    "video:paused",
                    this._enableDrag.bind(this)
                  ),
                  this.options.enableImageZoom &&
                    (window.addEventListener(
                      "resize",
                      this._handleZoomForMediaQuery.bind(this)
                    ),
                    this.delegateElement.on(
                      "click",
                      ".product-gallery__image",
                      this._openMobileZoom.bind(this)
                    ),
                    this.delegateElement.on(
                      "click",
                      ".pswp__button",
                      this._doPswpAction.bind(this)
                    ));
                var t = window.innerWidth;
                window.addEventListener("resize", function () {
                  window.innerWidth !== t &&
                    e.flickityInstance &&
                    (e.flickityInstance.resize(), (t = window.innerWidth));
                });
              },
            },
            {
              key: "variantHasChanged",
              value: function (s) {
                var a = this,
                  e = !1;
                D.mutate(function () {
                  a.productGalleryCellsElements.forEach(function (i, n) {
                    var o;
                    i.hasAttribute("data-group-name") &&
                      ((o = i.getAttribute("data-group-name")),
                      a.options.productOptions.forEach(function (e, t) {
                        e.toLowerCase() === o &&
                          (s["option".concat(t + 1)].toLowerCase() ===
                            i.getAttribute("data-group-value") ||
                          (s.featured_media &&
                            s.featured_media.id ===
                              parseInt(i.getAttribute("data-media-id")))
                            ? (i.classList.remove("is-filtered"),
                              a.productThumbnailsCellsElements[
                                n
                              ].classList.remove("is-filtered"))
                            : (i.classList.add("is-filtered"),
                              a.productThumbnailsCellsElements[n].classList.add(
                                "is-filtered"
                              )));
                      }),
                      (e = !0));
                  }),
                    e &&
                      (a.flickityInstance.deactivate(),
                      a.flickityInstance.activate()),
                    k.matchesBreakpoint("lap-and-up") &&
                      a.element
                        .querySelectorAll(".product-gallery__carousel-item")
                        .forEach(function (e) {
                          e.classList.remove(
                            "product-gallery__carousel-item--hidden"
                          );
                        }),
                    a.flickityInstance &&
                      s &&
                      s.featured_media &&
                      a.flickityInstance.selectCell(
                        '[data-media-id="'.concat(s.featured_media.id, '"]')
                      );
                });
              },
            },
            {
              key: "_createCarousel",
              value: function () {
                var i,
                  e,
                  n = this;
                (this.productGalleryElement = this.element.querySelector(
                  ".product-gallery__carousel"
                )),
                  (this.productGalleryCellsElements = this.productGalleryElement
                    ? this.productGalleryElement.querySelectorAll(
                        ".product-gallery__carousel-item"
                      )
                    : []),
                  this.productGalleryElement &&
                    1 <
                      parseInt(
                        this.productGalleryElement.getAttribute(
                          "data-media-count"
                        )
                      ) &&
                    ((e = [].slice
                      .call(this.productGalleryCellsElements)
                      .filter(function (e) {
                        return !e.classList.contains("is-filtered");
                      })),
                    (i = 0),
                    e.forEach(function (e, t) {
                      e.getAttribute("data-media-id") ===
                        n.productGalleryElement.getAttribute(
                          "data-initial-media-id"
                        ) && (i = t);
                    }),
                    (e = e[i]).classList.add("is-selected"),
                    (this.productGalleryElement.style.height = "".concat(
                      e.clientHeight,
                      "px"
                    )),
                    (this.flickityInstance = new J(this.productGalleryElement, {
                      accessibility: !1,
                      prevNextButtons: !1,
                      pageDots: !1,
                      resize: !1,
                      adaptiveHeight: !0,
                      draggable: !k.matchesBreakpoint("supports-hover"),
                      fade: "fade" === this.options.galleryTransitionEffect,
                      cellSelector:
                        ".product-gallery__carousel-item:not(.is-filtered)",
                      initialIndex: i,
                      on: {
                        ready: function () {
                          setTimeout(function () {
                            n.productGalleryElement.style.height = null;
                          }, 1e3);
                        },
                      },
                    }))),
                  (this.productThumbnailsListElement =
                    this.element.querySelector(
                      ".product-gallery__thumbnail-list"
                    )),
                  this.delegateElement.on(
                    "click",
                    ".product-gallery__thumbnail",
                    this._onThumbnailClicked.bind(this)
                  ),
                  this.productThumbnailsListElement &&
                    this.flickityInstance &&
                    ((this.productThumbnailsCellsElements =
                      this.productThumbnailsListElement.querySelectorAll(
                        ".product-gallery__thumbnail"
                      )),
                    this.flickityInstance.on(
                      "select",
                      this._onGallerySlideChanged.bind(this)
                    ),
                    "fade" === this.options.galleryTransitionEffect
                      ? this.flickityInstance.on(
                          "select",
                          this._onGallerySlideSettled.bind(this)
                        )
                      : this.flickityInstance.on(
                          "settle",
                          this._onGallerySlideSettled.bind(this)
                        ),
                    this._onGallerySlideChanged(!1),
                    this._onGallerySlideSettled());
              },
            },
            {
              key: "_createZoom",
              value: function () {
                var t,
                  i = this;
                this.options.enableImageZoom &&
                  k.matchesBreakpoint("lap-and-up") &&
                  ((this.driftObjects = []),
                  (t = this.element.querySelector(".product__zoom-wrapper")),
                  this.element
                    .querySelectorAll(".product-gallery__image")
                    .forEach(function (e) {
                      i.driftObjects.push(
                        new ve(e, {
                          containInline: "outside" === i.options.zoomEffect,
                          inlinePane:
                            window.innerWidth < 1024 ||
                            "outside" !== i.options.zoomEffect,
                          hoverBoundingBox: "outside" === i.options.zoomEffect,
                          handleTouch: !1,
                          inlineOffsetY: window.innerWidth < 1024 ? -85 : 0,
                          paneContainer: t,
                        })
                      );
                    }));
              },
            },
            {
              key: "_openMobileZoom",
              value: function () {
                var e,
                  n,
                  o,
                  t,
                  i,
                  s = this,
                  a = this.element.querySelector(".pswp");
                a &&
                  k.matchesBreakpoint("pocket") &&
                  ((e = this.element.querySelectorAll(
                    '.product-gallery__carousel-item:not(.is-filtered)[data-media-type="image"]'
                  )),
                  (n = 0),
                  (o = []),
                  e.forEach(function (e, t) {
                    var i = e.querySelector(".product-gallery__image");
                    o.push({
                      src: i.getAttribute("data-zoom"),
                      w: parseInt(i.getAttribute("data-zoom-width")),
                      h:
                        parseInt(i.getAttribute("data-zoom-width")) *
                        (i.height / i.width),
                      msrc: i.currentSrc,
                    }),
                      e.classList.contains("is-selected") && (n = t);
                  }),
                  (a.querySelector(".pswp__prev-next").style.display =
                    1 < o.length ? "flex" : "none"),
                  (this.photoSwipeInstance = new ee(a, !1, o, {
                    index: n,
                    closeOnVerticalDrag: !1,
                    closeOnScroll: !1,
                    history: !1,
                    showHideOpacity: !0,
                    pinchToClose: !1,
                    maxSpreadZoom: 1,
                    showAnimationDuration: !1,
                    allowPanToNext: !1,
                  })),
                  (t = this.photoSwipeInstance.updateSize),
                  (i = null),
                  (this.photoSwipeInstance.updateSize = function () {
                    (null !== i && i === window.innerWidth) ||
                      t(this, arguments),
                      (i = window.innerWidth);
                  }),
                  this.photoSwipeInstance.listen("destroy", function () {
                    s.photoSwipeInstance = null;
                  }),
                  this.photoSwipeInstance.listen("beforeChange", function () {
                    var e = s.element.querySelector(
                        ".pswp__pagination-current"
                      ),
                      t = s.element.querySelector(".pswp__pagination-count");
                    (e.textContent =
                      s.photoSwipeInstance.getCurrentIndex() + 1),
                      (t.textContent =
                        s.photoSwipeInstance.options.getNumItemsFn());
                  }),
                  this.photoSwipeInstance.init());
              },
            },
            {
              key: "_doPswpAction",
              value: function (e, t) {
                this.photoSwipeInstance &&
                  (t.classList.contains("pswp__button--close")
                    ? this.photoSwipeInstance.close()
                    : t.classList.contains("pswp__button--arrow--left")
                    ? this.photoSwipeInstance.prev()
                    : t.classList.contains("pswp__button--arrow--right") &&
                      this.photoSwipeInstance.next());
              },
            },
            {
              key: "_handleZoomForMediaQuery",
              value: function () {
                k.matchesBreakpoint("lap-and-up") &&
                  this.photoSwipeInstance &&
                  (this.photoSwipeInstance.close(),
                  (this.photoSwipeInstance = null));
              },
            },
            {
              key: "_onGallerySlideChanged",
              value: function () {
                var e,
                  t = this,
                  i =
                    !(0 < arguments.length && void 0 !== arguments[0]) ||
                    arguments[0],
                  n = null,
                  o = null;
                this.productThumbnailsCellsElements.forEach(function (e) {
                  e.classList.contains("is-nav-selected") && (n = e),
                    e.getAttribute("data-media-id") ===
                      t.flickityInstance.selectedElement.getAttribute(
                        "data-media-id"
                      ) && (o = e);
                }),
                  n.classList.remove("is-nav-selected"),
                  o.classList.add("is-nav-selected"),
                  k.matchesBreakpoint("pocket")
                    ? ((e =
                        o.offsetLeft -
                        (this.productThumbnailsListElement.parentNode
                          .clientWidth -
                          o.clientWidth) /
                          2),
                      this.productThumbnailsListElement.parentNode.scrollTo({
                        left: e,
                        behavior: i ? "smooth" : "auto",
                      }))
                    : ((e =
                        o.offsetTop -
                        (this.productThumbnailsListElement.clientHeight -
                          o.clientHeight) /
                          2),
                      this.productThumbnailsListElement.scrollTo({
                        top: e,
                        behavior: i ? "smooth" : "auto",
                      }));
              },
            },
            {
              key: "_onGallerySlideSettled",
              value: function () {
                this._handleMedia(this.flickityInstance.selectedElement),
                  k.matchesBreakpoint("lap-and-up") &&
                    this.element
                      .querySelectorAll(
                        ".product-gallery__carousel-item:not(.is-selected)"
                      )
                      .forEach(function (e) {
                        e.classList.add(
                          "product-gallery__carousel-item--hidden"
                        );
                      });
              },
            },
            {
              key: "_onThumbnailClicked",
              value: function (e, t) {
                e.preventDefault(),
                  this.flickityInstance &&
                    (this.flickityInstance.selectCell(
                      '[data-media-id="'.concat(
                        t.getAttribute("data-media-id"),
                        '"]'
                      )
                    ),
                    k.matchesBreakpoint("lap-and-up") &&
                      this.element
                        .querySelectorAll(".product-gallery__carousel-item")
                        .forEach(function (e) {
                          e.classList.remove(
                            "product-gallery__carousel-item--hidden"
                          );
                        }));
              },
            },
            {
              key: "_disableDrag",
              value: function () {
                (this.flickityInstance.options.draggable = !1),
                  this.flickityInstance.updateDraggable();
              },
            },
            {
              key: "_enableDrag",
              value: function () {
                (this.flickityInstance.options.draggable =
                  !k.matchesBreakpoint("supports-hover")),
                  this.flickityInstance.updateDraggable();
              },
            },
            {
              key: "_handleMedia",
              value: function (e) {
                var t = null === this.previouslySelectedMedia;
                if (
                  this.previouslySelectedMedia &&
                  this.previouslySelectedMedia !== e
                ) {
                  switch (
                    this.previouslySelectedMedia.getAttribute("data-media-type")
                  ) {
                    case "video":
                    case "external_video":
                    case "model":
                      this.media[
                        this.previouslySelectedMedia.getAttribute(
                          "data-media-id"
                        )
                      ].hasBeenDeselected();
                  }
                  "model" ===
                    this.previouslySelectedMedia.getAttribute(
                      "data-media-type"
                    ) &&
                    this.viewInSpaceElement &&
                    this.viewInSpaceElement.setAttribute(
                      "data-shopify-model3d-id",
                      this.viewInSpaceElement.getAttribute(
                        "data-shopify-model3d-default-id"
                      )
                    );
                }
                switch (e.getAttribute("data-media-type")) {
                  case "video":
                  case "external_video":
                  case "model":
                    this.media[e.getAttribute("data-media-id")].hasBeenSelected(
                      t
                    ),
                      this.element
                        .querySelector(".product-gallery__carousel")
                        .classList.remove(
                          "product-gallery__carousel--zoomable"
                        );
                    break;
                  case "image":
                    this.element
                      .querySelector(".product-gallery__carousel")
                      .classList.add("product-gallery__carousel--zoomable");
                }
                "model" === e.getAttribute("data-media-type") &&
                  this.viewInSpaceElement &&
                  this.viewInSpaceElement.setAttribute(
                    "data-shopify-model3d-id",
                    e.getAttribute("data-media-id")
                  ),
                  (this.previouslySelectedMedia = e);
              },
            },
          ]),
          i
        );
      })(),
      Se = (function () {
        function t(e) {
          a(this, t),
            e &&
              ((this.element = e),
              (this.inputElement =
                this.element.querySelector('[name="quantity"]')),
              (this.delegateElement = new _(this.element)),
              this._attachListeners());
        }
        return (
          r(t, [
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "click",
                  '[data-action="decrease-picker-quantity"]',
                  this._onDecrease.bind(this)
                ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="increase-picker-quantity"]',
                    this._onIncrease.bind(this)
                  ),
                  this.delegateElement.on(
                    "keyup",
                    this._onInputValueChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "focusout",
                    this._onInputFocusOut.bind(this)
                  );
              },
            },
            {
              key: "_onDecrease",
              value: function () {
                this.inputElement.value = Math.max(
                  1,
                  parseInt(this.inputElement.value) - 1
                );
              },
            },
            {
              key: "_onIncrease",
              value: function () {
                this.inputElement.value = parseInt(this.inputElement.value) + 1;
              },
            },
            {
              key: "_onInputValueChanged",
              value: function (e) {
                var t = e.target.value;
                "" !== t &&
                  isNaN(t) &&
                  (e.target.value = Math.max(1, parseInt(t) || 1));
              },
            },
            {
              key: "_onInputFocusOut",
              value: function (e) {
                e.target.value = Math.max(1, parseInt(e.target.value) || 1);
              },
            },
          ]),
          t
        );
      })(),
      xe = (function () {
        function i(e) {
          var t =
            1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
          a(this, i),
            (this.id = e),
            (this.delegateRoot = new _(document.documentElement)),
            (this.isOpen = !1),
            (this.togglerElement = document.querySelector(
              '[data-action="open-value-picker"][aria-controls="'.concat(
                this.id,
                '"]'
              )
            )),
            (this.onSelect = t.onValueSelect || function () {}),
            this._attachListeners();
        }
        return (
          r(i, [
            {
              key: "destroy",
              value: function () {
                this.delegateRoot.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateRoot.on(
                  "click",
                  '[data-action="open-value-picker"][aria-controls="'.concat(
                    this.id,
                    '"]'
                  ),
                  this._toggle.bind(this)
                ),
                  this.delegateRoot.on(
                    "click",
                    '[data-action="close-value-picker"][aria-controls="'.concat(
                      this.id,
                      '"]'
                    ),
                    this._toggle.bind(this)
                  ),
                  this.delegateRoot.on(
                    "click",
                    "#".concat(this.id, ' [data-action="select-value"]'),
                    this._selectValue.bind(this)
                  ),
                  this.delegateRoot.on(
                    "click",
                    this._detectOutsideClick.bind(this),
                    !0
                  ),
                  this.delegateRoot.on(
                    "focusout",
                    "#".concat(this.id),
                    this._onFocusOut.bind(this)
                  );
              },
            },
            {
              key: "_toggle",
              value: function (e) {
                this.isOpen ? this._close(e) : this._open(e);
              },
            },
            {
              key: "_open",
              value: function () {
                document
                  .querySelector(
                    '[data-action="open-value-picker"][aria-controls="'.concat(
                      this.id,
                      '"]'
                    )
                  )
                  .setAttribute("aria-expanded", "true"),
                  document
                    .getElementById(this.id)
                    .setAttribute("aria-hidden", "false"),
                  k.matchesBreakpoint("phone") &&
                    (document.querySelector(
                      ".shopify-section__header"
                    ).style.zIndex = "3"),
                  (this.isOpen = !0),
                  document.body.classList.add("no-mobile-scroll");
              },
            },
            {
              key: "_close",
              value: function () {
                document
                  .querySelector(
                    '[data-action="open-value-picker"][aria-controls="'.concat(
                      this.id,
                      '"]'
                    )
                  )
                  .setAttribute("aria-expanded", "false"),
                  document
                    .getElementById(this.id)
                    .setAttribute("aria-hidden", "true"),
                  (document.querySelector(
                    ".shopify-section__header"
                  ).style.zIndex = ""),
                  (this.isOpen = !1),
                  document.body.classList.remove("no-mobile-scroll");
              },
            },
            {
              key: "_selectValue",
              value: function (e, t) {
                this.onSelect(t.getAttribute("data-value")), this._close();
              },
            },
            {
              key: "_onFocusOut",
              value: function (e) {
                document.getElementById(this.id).contains(e.relatedTarget) ||
                  this._close();
              },
            },
            {
              key: "_detectOutsideClick",
              value: function (e) {
                this.isOpen &&
                  this.togglerElement !== e.target &&
                  !this.togglerElement.contains(e.target) &&
                  !e.target.closest(".value-picker__inner") &&
                  this.isOpen &&
                  this._close(e);
              },
            },
          ]),
          i
        );
      })(),
      Ce = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.domDelegate = new _(this.element)),
            this.element
              .querySelectorAll('[action*="/account/addresses"]')
              .forEach(function (e) {
                new S(
                  e.querySelector('[name="address[country]"]'),
                  e.querySelector('[name="address[province]"]')
                );
              }),
            (this.pageSelector = new xe("account-selector"));
        }
        return (
          r(t, [
            {
              key: "_onUnload",
              value: function () {
                this.pageSelector.destroy();
              },
            },
          ]),
          t
        );
      })(),
      Le = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.domDelegate = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            (this.isOpen = !1),
            this.options.showNewsletter
              ? document.documentElement.style.setProperty(
                  "--announcement-bar-button-width",
                  this.element.querySelector(".announcement-bar__button")
                    .clientWidth + "px"
                )
              : document.documentElement.style.removeProperty(
                  "--announcement-bar-button-width"
                ),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "onSelect",
              value: function () {
                this.options.showNewsletter &&
                  !this.isOpen &&
                  this._toggleNewsletter();
              },
            },
            {
              key: "onDeselect",
              value: function () {
                this.options.showNewsletter &&
                  this.isOpen &&
                  this._toggleNewsletter();
              },
            },
            {
              key: "onUnload",
              value: function () {
                this.domDelegate.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.domDelegate.on(
                  "click",
                  '[data-action="toggle-newsletter"]',
                  this._toggleNewsletter.bind(this)
                ),
                  this.domDelegate.on("keyup", this._handleKey.bind(this));
              },
            },
            {
              key: "_toggleNewsletter",
              value: function () {
                var e = this.element.querySelector(".announcement-bar__button"),
                  t = this.element.querySelector(
                    ".announcement-bar__newsletter"
                  );
                "false" === e.getAttribute("aria-expanded")
                  ? (e.setAttribute("aria-expanded", "true"),
                    t.setAttribute("aria-hidden", "false"),
                    y.slideDown(t, function () {
                      A.trapFocus(t, "announcement-bar");
                    }))
                  : (e.setAttribute("aria-expanded", "false"),
                    t.setAttribute("aria-hidden", "true"),
                    y.slideUp(t),
                    A.removeTrapFocus(t, "announcement-bar")),
                  (this.isOpen = !this.isOpen);
              },
            },
            {
              key: "_handleKey",
              value: function (e) {
                "Escape" === e.key && this.isOpen && this._toggleNewsletter();
              },
            },
          ]),
          t
        );
      })(),
      Ae = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.blogTagSelector = new xe("blog-tag-selector")),
            !Shopify.designMode ||
              ((e = this.element.querySelector(".page__header")) &&
                (document
                  .querySelector(".blog-container")
                  .previousElementSibling.remove(),
                document
                  .querySelector(".blog-container")
                  .insertAdjacentElement("beforebegin", e)));
        }
        return (
          r(t, [
            {
              key: "onUnload",
              value: function () {
                this.blogTagSelector.destroy();
              },
            },
          ]),
          t
        );
      })(),
      Te = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            "blog" === window.theme.pageType && this._fixItemsPerRow();
        }
        return (
          r(t, [
            {
              key: "_fixItemsPerRow",
              value: function () {
                0 ===
                this.element.querySelectorAll(".blog-sidebar__item").length
                  ? (document
                      .querySelector(".blog-container")
                      .classList.add("blog-container--without-sidebar"),
                    document
                      .querySelectorAll(
                        ".shopify-section__blog-posts .block-list__item"
                      )
                      .forEach(function (e) {
                        e.classList.contains("1/2--lap-and-up") &&
                          (e.classList.remove("1/2--lap-and-up"),
                          e.classList.add("1/3--lap-and-up"));
                      }))
                  : (document
                      .querySelector(".blog-container")
                      .classList.remove("blog-container--without-sidebar"),
                    document
                      .querySelectorAll(
                        ".shopify-section__blog-posts .block-list__item"
                      )
                      .forEach(function (e) {
                        e.classList.contains("1/3--lap-and-up") &&
                          (e.classList.remove("1/3--lap-and-up"),
                          e.classList.add("1/2--lap-and-up"));
                      }));
              },
            },
          ]),
          t
        );
      })(),
      Ie = (function () {
        function n(e) {
          var t = this;
          a(this, n),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            (this.productGallery = new Ee(this.element, this.options)),
            this._initShopifyReviews(),
            this.options.isQuickView &&
              this.options.showPaymentButton &&
              window.Shopify.PaymentButton &&
              Shopify.PaymentButton.init(),
            (this.productVariants = new N(this.element, this.options)),
            !this.options.showQuantitySelector ||
              ((i = this.element.querySelector(
                ".quantity-selector--product"
              )) &&
                (this.quantityPicker = new Se(i)));
          var i = this.element.querySelector(
            ".product-block-list__item--info .card"
          );
          i &&
            ((this.element.querySelector(
              ".product-block-list__wrapper"
            ).style.minHeight = "".concat(i.clientHeight, "px")),
            window.ResizeObserver &&
              ((this.productInfoResizeObserver = new ResizeObserver(function (
                e
              ) {
                e[0].contentBoxSize
                  ? (t.element.querySelector(
                      ".product-block-list__wrapper"
                    ).style.minHeight = "".concat(
                      e[0].contentBoxSize[0].blockSize,
                      "px"
                    ))
                  : (t.element.querySelector(
                      ".product-block-list__wrapper"
                    ).style.minHeight = "".concat(
                      e[0].contentRect.height,
                      "px"
                    ));
              })),
              this.productInfoResizeObserver.observe(i)),
            this.options.infoOverflowScroll &&
              (this.infoOverflowScroller = new z(i, {
                offsetTop:
                  document.documentElement.style.getPropertyValue(
                    "--header-is-sticky"
                  ) *
                  parseInt(
                    document.documentElement.style.getPropertyValue(
                      "--header-height"
                    ) + 30
                  ),
                offsetBottom: 30,
              }))),
            this._attachListeners();
        }
        return (
          r(n, [
            {
              key: "onUnload",
              value: function () {
                this.productVariants.destroy(),
                  this.productGallery.destroy(),
                  this.options.infoOverflowScroll &&
                    this.infoOverflowScroller.destroy(),
                  window.ResizeObserver &&
                    this.productInfoResizeObserver &&
                    this.productInfoResizeObserver.disconnect(),
                  this.delegateElement.off(),
                  this.element.removeEventListener(
                    "variant:changed",
                    this._onVariantChangedListener
                  );
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._onVariantChangedListener =
                  this._onVariantChanged.bind(this)),
                  this.element.addEventListener(
                    "variant:changed",
                    this._onVariantChangedListener
                  );
              },
            },
            {
              key: "_initShopifyReviews",
              value: function () {
                var e = this;
                Shopify.designMode &&
                  window.SPR &&
                  (window.SPR.initDomEls(), window.SPR.loadProducts()),
                  (window.SPRCallbacks = {}),
                  (window.SPRCallbacks.onFormSuccess = function () {
                    e.element
                      .querySelector("#shopify-product-reviews .spr-form")
                      .classList.add("spr-form-submitted");
                  }),
                  this.options.isQuickView &&
                    this.options.showPaymentButton &&
                    window.Shopify.PaymentButton &&
                    Shopify.PaymentButton.init();
              },
            },
            {
              key: "_onVariantChanged",
              value: function (e) {
                this.productGallery.variantHasChanged(e.detail.variant);
              },
            },
          ]),
          n
        );
      })(),
      Me = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.domDelegate = new _(this.element)),
            (this.delegateRoot = new _(document.documentElement)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            this._attachListeners(),
            this._enforceMinimumHeight();
        }
        return (
          r(t, [
            {
              key: "_attachListeners",
              value: function () {
                this.domDelegate.on(
                  "click",
                  '[data-action="add-to-cart"]',
                  this._addToCart.bind(this)
                ),
                  this.domDelegate.on(
                    "click",
                    '[data-action="save-note"]',
                    this._saveNote.bind(this)
                  ),
                  this.domDelegate.on(
                    "click",
                    '[data-secondary-action="open-quick-view"]',
                    this._openQuickView.bind(this)
                  ),
                  this.delegateRoot.on(
                    "cart:rerendered",
                    this._onCartRerendered.bind(this)
                  );
              },
            },
            {
              key: "_saveNote",
              value: function () {
                var e = this.element.querySelector('[name="note"]').value;
                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                  body: JSON.stringify({ note: e }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }),
                  this.element
                    .querySelector(".cart-recap__note-edit")
                    .classList.toggle("is-visible", "" !== e),
                  document.dispatchEvent(
                    new CustomEvent("collapsible:toggle", {
                      detail: { id: "order-note" },
                    })
                  );
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i,
                  n = this;
                "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  t.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  (i = t.closest('form[action*="/cart/add"]')),
                  fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(R.serialize(i)),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function (e) {
                    e.ok
                      ? (t.removeAttribute("disabled"),
                        n.element.dispatchEvent(
                          new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                              variant: null,
                              quantity: parseInt(
                                i.querySelector('[name="quantity"]').value
                              ),
                            },
                          })
                        ))
                      : t.removeAttribute("disabled");
                  }),
                  e.preventDefault());
              },
            },
            {
              key: "_openQuickView",
              value: function (e, t) {
                var i = document.getElementById(
                  t.getAttribute("aria-controls")
                );
                i.classList.add("is-loading"),
                  fetch(
                    "".concat(
                      t.getAttribute("data-product-url"),
                      "?view=quick-view"
                    ),
                    { credentials: "same-origin", method: "GET" }
                  ).then(function (e) {
                    e.text().then(function (e) {
                      (i.querySelector(".modal__inner").innerHTML = e),
                        i.classList.remove("is-loading");
                      var t = new Ie(
                          i.querySelector('[data-section-type="product"]')
                        ),
                        e = function e() {
                          t.onUnload(),
                            i.removeEventListener("modal:closed", e);
                        };
                      i.addEventListener("modal:closed", e);
                    });
                  });
              },
            },
            {
              key: "_enforceMinimumHeight",
              value: function () {
                var n = this.element.querySelector(".cart-wrapper"),
                  e = this.element.querySelector(".cart-recap__scroller");
                n &&
                  e &&
                  ((n.style.minHeight = "".concat(e.clientHeight, "px")),
                  window.ResizeObserver &&
                    new ResizeObserver(function (e) {
                      var t = (function (e, t) {
                        var i;
                        if (
                          "undefined" == typeof Symbol ||
                          null == e[Symbol.iterator]
                        ) {
                          if (
                            Array.isArray(e) ||
                            (i = f(e)) ||
                            (t && e && "number" == typeof e.length)
                          ) {
                            i && (e = i);
                            var n = 0,
                              t = function () {};
                            return {
                              s: t,
                              n: function () {
                                return n >= e.length
                                  ? { done: !0 }
                                  : { done: !1, value: e[n++] };
                              },
                              e: function (e) {
                                throw e;
                              },
                              f: t,
                            };
                          }
                          throw new TypeError(
                            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                          );
                        }
                        var o,
                          s = !0,
                          a = !1;
                        return {
                          s: function () {
                            i = e[Symbol.iterator]();
                          },
                          n: function () {
                            var e = i.next();
                            return (s = e.done), e;
                          },
                          e: function (e) {
                            (a = !0), (o = e);
                          },
                          f: function () {
                            try {
                              s || null == i.return || i.return();
                            } finally {
                              if (a) throw o;
                            }
                          },
                        };
                      })(e);
                      try {
                        for (t.s(); !(i = t.n()).done; ) {
                          var i = i.value;
                          n.style.minHeight = "".concat(
                            parseInt(i.contentRect.height),
                            "px"
                          );
                        }
                      } catch (e) {
                        t.e(e);
                      } finally {
                        t.f();
                      }
                    }).observe(e));
              },
            },
          ]),
          t
        );
      })(),
      Pe = (function () {
        function n(e) {
          var t = this;
          a(this, n), (this.element = e);
          e = this.element.querySelector(".collection-list");
          this.flickityInstance = new K(e, {
            watchCSS: !0,
            prevNextButtons: !0,
            draggable: !window.matchMedia(
              "(-moz-touch-enabled: 0), (hover: hover)"
            ).matches,
            pageDots: !1,
            resize: !1,
            cellAlign: e.childElementCount < 6 ? "center" : "left",
            contain: !0,
            groupCells: !0,
          });
          var i = window.innerWidth;
          window.addEventListener("resize", function () {
            window.innerWidth !== i &&
              (t.flickityInstance.resize(), (i = window.innerWidth));
          });
        }
        return (
          r(n, [
            {
              key: "onUnload",
              value: function () {
                this.flickityInstance.destroy();
              },
            },
            {
              key: "onBlockSelect",
              value: function (e) {
                this.flickityInstance.isActive &&
                  this.flickityInstance.selectCell(
                    parseInt(e.target.getAttribute("data-collection-index")),
                    null,
                    e.detail.load
                  );
              },
            },
          ]),
          n
        );
      })(),
      De = (function () {
        function i(e) {
          var t = this;
          a(this, i),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            (this.currentUrl = new URL(window.location.href)),
            (this.mobileFilterDrawer = new x(this.options)),
            (this.displayByValuePicker = new xe("display-by-selector", {
              onValueSelect: this._showingCountChanged.bind(this),
            })),
            (this.sortByValuePicker = new xe("sort-by-selector", {
              onValueSelect: this._sortByChanged.bind(this),
            })),
            (this.productItemColorSwatch = new q(this.element)),
            "search" === window.theme.pageType && this._loadContentResults(),
            window.addEventListener("popstate", function () {
              (t.currentUrl = new URL(window.location.href)), t._reload(!1);
            }),
            this._attachListeners();
        }
        return (
          r(i, [
            {
              key: "onUnload",
              value: function () {
                this.delegateElement.off(),
                  this.mobileFilterDrawer.destroy(),
                  this.displayByValuePicker.destroy(),
                  this.sortByValuePicker.destroy(),
                  this.productItemColorSwatch.destroy();
              },
            },
            {
              key: "onSelect",
              value: function (e) {
                Shopify.designMode &&
                  e.detail.load &&
                  (this.element
                    .querySelector(
                      '.collection__layout-button[data-layout-mode="'.concat(
                        this.options.defaultLayout,
                        '"]'
                      )
                    )
                    .click(),
                  this._showingCountChanged(
                    this.options.defaultProductsPerPage
                  ));
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "click",
                  '[data-action="change-layout"]',
                  this._changeLayout.bind(this)
                ),
                  this.delegateElement.on(
                    "change",
                    "#mobile-sort-by, #desktop-sort-by",
                    this._sortByChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "change",
                    "#showing-count",
                    this._showingCountChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    ".pagination [data-page]",
                    this._paginationPageChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-secondary-action="open-quick-view"]',
                    this._openQuickView.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="add-to-cart"]',
                    this._addToCart.bind(this)
                  ),
                  this.delegateElement.on(
                    "change",
                    '[name^="filter."]',
                    this._onFilterChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="clear-filters"]',
                    this._onFiltersCleared.bind(this)
                  );
              },
            },
            {
              key: "_openQuickView",
              value: function (e, t) {
                var i = new URL(
                  ""
                    .concat(window.location.origin)
                    .concat(t.getAttribute("data-product-url"))
                );
                if (
                  k.matchesBreakpoint("phone") ||
                  k.matchesBreakpoint("tablet")
                )
                  return (window.location.href = i.href), !1;
                var n = document.getElementById(
                  t.getAttribute("aria-controls")
                );
                n.classList.add("is-loading"),
                  i.searchParams.set("view", "quick-view"),
                  fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET",
                  }).then(function (e) {
                    e.text().then(function (e) {
                      (n.querySelector(".modal__inner").innerHTML = e),
                        n.classList.remove("is-loading");
                      var t = new Ie(
                          n.querySelector('[data-section-type="product"]')
                        ),
                        e = function e() {
                          t.onUnload(),
                            n.removeEventListener("modal:closed", e);
                        };
                      n.addEventListener("modal:closed", e);
                    });
                  });
              },
            },
            {
              key: "_changeLayout",
              value: function (e, t) {
                var i,
                  n = this;
                t.classList.contains("is-selected") ||
                  ((i = t.getAttribute("data-layout-mode")),
                  fetch("".concat(window.routes.cartUrl, "/update.js"), {
                    body: JSON.stringify({
                      attributes: { collection_layout: i },
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }),
                  D.mutate(function () {
                    b.getSiblings(t, ".is-selected").forEach(function (e) {
                      return e.classList.remove("is-selected");
                    }),
                      t.classList.add("is-selected"),
                      n.element
                        .querySelectorAll(".product-item")
                        .forEach(function (e) {
                          e.className =
                            "grid" === i
                              ? "product-item product-item--vertical ".concat(
                                  n.options.gridClasses
                                )
                              : "product-item product-item--list";
                        }),
                      n.productItemColorSwatch.recalculateSwatches();
                  }));
              },
            },
            {
              key: "_sortByChanged",
              value: function (e) {
                this.currentUrl.searchParams.set("sort_by", e),
                  this.currentUrl.searchParams.delete("page"),
                  this._reload(!0);
              },
            },
            {
              key: "_showingCountChanged",
              value: function (e) {
                var t = this;
                this.currentUrl.searchParams.delete("page"),
                  fetch("".concat(window.routes.cartUrl, "/update.js"), {
                    body: JSON.stringify({
                      attributes: { collection_products_per_page: e },
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function () {
                    t._reload(!0);
                  });
              },
            },
            {
              key: "_paginationPageChanged",
              value: function (e, t) {
                e.preventDefault(),
                  this.currentUrl.searchParams.set(
                    "page",
                    parseInt(t.getAttribute("data-page"))
                  ),
                  this._reload(!0);
              },
            },
            {
              key: "_onFilterChanged",
              value: function (e, t) {
                (t = new FormData(t.closest("form"))),
                  (t = new URLSearchParams(t).toString());
                (this.currentUrl = new URL(
                  "".concat(window.location.pathname, "?").concat(t),
                  window.location.origin
                )),
                  this._reload(!0);
              },
            },
            {
              key: "_onFiltersCleared",
              value: function (e, t) {
                (this.currentUrl = new URL(
                  t.getAttribute("data-url"),
                  window.location.origin
                )),
                  this._reload(!0);
              },
            },
            {
              key: "_reload",
              value: function (e) {
                var o = this;
                this.abortController && this.abortController.abort(),
                  e &&
                    window.history.pushState(
                      { path: this.currentUrl.toString() },
                      "",
                      this.currentUrl.toString()
                    ),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  );
                var s = window.getComputedStyle(document.documentElement),
                  t = "",
                  t = (
                    this.currentUrl.search
                      ? ""
                          .concat(this.currentUrl.pathname, "/")
                          .concat(this.currentUrl.search, "&section_id=")
                      : "".concat(this.currentUrl.pathname, "?section_id=")
                  ).concat(this.element.getAttribute("data-section-id"));
                try {
                  return (
                    (this.abortController = new AbortController()),
                    fetch(t, {
                      credentials: "same-origin",
                      method: "GET",
                      signal: this.abortController.signal,
                    }).then(function (e) {
                      e.text().then(function (e) {
                        var i = document.createElement("div");
                        (i.innerHTML = e),
                          (o.element.querySelector(
                            ".collection__dynamic-part"
                          ).innerHTML = i.querySelector(
                            ".collection__dynamic-part"
                          ).innerHTML);
                        var t = o.element.querySelector(
                            "#desktop-filters-form"
                          ),
                          n = o.element.querySelector(
                            "#mobile-collection-filters"
                          ),
                          e = 0;
                        n &&
                          (e = n.querySelector(
                            ".collection-drawer__inner"
                          ).scrollTop),
                          t &&
                            (Array.from(
                              o.element.querySelectorAll(
                                ".collection__filter-group-name[aria-controls]"
                              )
                            ).forEach(function (e) {
                              var t = i.querySelector(
                                '[aria-controls="'.concat(
                                  e.getAttribute("aria-controls"),
                                  '"]'
                                )
                              );
                              "true" === e.getAttribute("aria-expanded")
                                ? (t.setAttribute("aria-expanded", "true"),
                                  t.nextElementSibling.setAttribute(
                                    "aria-hidden",
                                    "false"
                                  ),
                                  (t.nextElementSibling.style.height = "auto"),
                                  (t.nextElementSibling.style.overflow =
                                    "visible"))
                                : (t.setAttribute("aria-expanded", "false"),
                                  t.nextElementSibling.setAttribute(
                                    "aria-hidden",
                                    "true"
                                  ),
                                  (t.nextElementSibling.style = ""));
                            }),
                            (t.innerHTML = i.querySelector(
                              "#desktop-filters-form"
                            ).innerHTML),
                            (n.innerHTML = i.querySelector(
                              "#mobile-collection-filters"
                            ).innerHTML),
                            (n.querySelector(
                              ".collection-drawer__inner"
                            ).scrollTop = e),
                            o.mobileFilterDrawer._computeDrawerHeight()),
                          o.productItemColorSwatch.recalculateSwatches();
                        n =
                          o.element
                            .querySelector(".collection")
                            .getBoundingClientRect().top -
                          25 -
                          parseInt(s.getPropertyValue("--header-is-sticky")) *
                            parseInt(s.getPropertyValue("--header-height"));
                        n < 0 &&
                          window.scrollBy({ top: n, behavior: "smooth" });
                        (e = JSON.parse(
                          i.querySelector("[data-collection-products-count]")
                            .innerHTML
                        )),
                          (n = o.element.querySelector(
                            ".collection__products-count-showing"
                          ));
                        n && (n.innerHTML = e.showingCount),
                          (o.element.querySelector(
                            ".collection__products-count-total"
                          ).innerHTML = e.productsCount),
                          document.dispatchEvent(
                            new CustomEvent("theme:loading:end")
                          );
                      });
                    })
                  );
                } catch (e) {}
              },
            },
            {
              key: "_loadContentResults",
              value: function () {
                var n = this,
                  e = new URL(window.location.href);
                fetch(
                  ""
                    .concat(
                      window.routes.searchUrl,
                      "?section_id=search-content&q="
                    )
                    .concat(e.searchParams.get("q"), "&type=article,page"),
                  { credentials: "same-origin" }
                ).then(function (e) {
                  e.text().then(function (e) {
                    var t = n.element.querySelector(".link-search-results"),
                      i = document.createElement("div");
                    (i.innerHTML = e),
                      t &&
                        "" !== e.trim() &&
                        ((t.innerHTML = i.firstElementChild.innerHTML),
                        (t.style.display = "block"));
                  });
                });
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i,
                  n = this;
                "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  t.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  (i = t.closest('form[action*="/cart/add"]')),
                  fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(R.serialize(i)),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function (e) {
                    t.removeAttribute("disabled"),
                      e.ok
                        ? n.element.dispatchEvent(
                            new CustomEvent("product:added", {
                              bubbles: !0,
                              detail: {
                                button: t,
                                variant: null,
                                quantity: parseInt(
                                  i.querySelector('[name="quantity"]').value
                                ),
                              },
                            })
                          )
                        : document.dispatchEvent(
                            new CustomEvent("theme:loading:end")
                          );
                  }),
                  e.preventDefault());
              },
            },
          ]),
          i
        );
      })(),
      ze = (function () {
        function n(e) {
          var t,
            i = this;
          a(this, n),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            ));
        
          if (!this.options.stackable) {
            
            var isRTL = Shopify.locale === "ar";
        
            this.flickityInstance = new K(
              this.element.querySelector(".product-list"),
              {
                watchCSS: !0,
                pageDots: !1,
                prevNextButtons: !0,
                contain: !0,
                resize: !1,
                groupCells: !0,
                cellAlign: "left",
                draggable: !window.matchMedia(
                  "(-moz-touch-enabled: 0), (hover: hover)"
                ).matches,
                rightToLeft: isRTL, 
              }
            );
        
            t = window.innerWidth;
            window.addEventListener("resize", function () {
              if (window.innerWidth !== t) {
                i.flickityInstance.resize();
                t = window.innerWidth;
              }
            });
          }
        
          this.productItemColorSwatch = new q(this.element);
          this._fixSafari();
          this._attachListeners();
        }
        return (
          r(n, [
            {
              key: "onUnload",
              value: function () {
                this.options.stackable || this.flickityInstance.destroy(),
                  window.removeEventListener("resize", this._fixSafariListener),
                  this.delegateElement.off("change"),
                  this.productItemColorSwatch.destroy(),
                  this.resizeObserver && this.resizeObserver.disconnect();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                var t = this;
                (this._fixSafariListener = this._fixSafari.bind(this)),
                  window.addEventListener("resize", this._fixSafariListener),
                  this.delegateElement.on(
                    "click",
                    '[data-action="add-to-cart"]',
                    this._addToCart.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-secondary-action="open-quick-view"]',
                    this._openQuickView.bind(this)
                  ),
                  window.ResizeObserver &&
                    this.flickityInstance &&
                    ((this.resizeObserver = new ResizeObserver(function () {
                      t.flickityInstance.resize();
                    })),
                    this.element
                      .querySelectorAll(".product-item")
                      .forEach(function (e) {
                        t.resizeObserver.observe(e);
                      }));
              },
            },
            {
              key: "_fixSafari",
              value: function () {
                var t,
                  e = window.navigator.userAgent.toLowerCase();
                e.includes("safari") &&
                  (e.includes("version/10.1") ||
                    e.includes("version/10.3") ||
                    e.includes("version/11.0")) &&
                  ((t = k.matchesBreakpoint("phone")),
                  this.element
                    .querySelectorAll(
                      ".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg"
                    )
                    .forEach(function (e) {
                      e.parentNode.style.height = t
                        ? null
                        : "".concat(e.clientHeight, "px");
                    }));
              },
            },
            {
              key: "_openQuickView",
              value: function (e, t) {
                var i = new URL(
                  ""
                    .concat(window.location.origin)
                    .concat(t.getAttribute("data-product-url"))
                );
                if (
                  k.matchesBreakpoint("phone") ||
                  k.matchesBreakpoint("tablet")
                )
                  return (window.location.href = i.href), !1;
                var n = document.getElementById(
                  t.getAttribute("aria-controls")
                );
                n.classList.add("is-loading"),
                  i.searchParams.set("view", "quick-view"),
                  fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET",
                  }).then(function (e) {
                    e.text().then(function (e) {
                      (n.querySelector(".modal__inner").innerHTML = e),
                        n.classList.remove("is-loading");
                      var t = new Ie(
                          n.querySelector('[data-section-type="product"]')
                        ),
                        e = function e() {
                          t.onUnload(),
                            n.removeEventListener("modal:closed", e);
                        };
                      n.addEventListener("modal:closed", e);
                    });
                  });
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i,
                  n = this;
                "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  t.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  (i = t.closest('form[action*="/cart/add"]')),
                  fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(R.serialize(i)),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function (e) {
                    t.removeAttribute("disabled"),
                      e.ok
                        ? n.element.dispatchEvent(
                            new CustomEvent("product:added", {
                              bubbles: !0,
                              detail: {
                                button: t,
                                variant: null,
                                quantity: parseInt(
                                  i.querySelector('[name="quantity"]').value
                                ),
                              },
                            })
                          )
                        : document.dispatchEvent(
                            new CustomEvent("theme:loading:end")
                          );
                  }),
                  e.preventDefault());
              },
            },
          ]),
          n
        );
      })(),
      Oe = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.localeValuePicker = new xe("footer-locale-picker")),
            (this.currencyValuePicker = new xe("footer-currency-picker")),
            this._setupCollapsibles(),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "onUnload",
              value: function () {
                window.removeEventListener(
                  "resize",
                  this._setupCollapsiblesListener
                ),
                  this.localeValuePicker.destroy(),
                  this.currencyValuePicker.destroy();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._setupCollapsiblesListener =
                  this._setupCollapsibles.bind(this)),
                  window.addEventListener(
                    "resize",
                    this._setupCollapsiblesListener
                  );
              },
            },
            {
              key: "_setupCollapsibles",
              value: function () {
                var e = this.element.querySelectorAll(
                    '[data-action="toggle-collapsible"]'
                  ),
                  t = k.matchesBreakpoint("phone");
                e.forEach(function (e) {
                  t
                    ? e.removeAttribute("disabled")
                    : (e.setAttribute("disabled", "disabled"),
                      (document.getElementById(
                        e.getAttribute("aria-controls")
                      ).style.height = ""));
                });
              },
            },
          ]),
          t
        );
      })(),
      qe = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.headerElement = this.element.closest(".header")),
            (this.searchBarElement = this.element.querySelector(".search-bar")),
            (this.inputElement = this.element.querySelector('[name="q"]')),
            (this.searchMenuElement = this.element.querySelector(
              ".search-bar__menu-wrapper"
            )),
            (this.searchResultsElement = this.element.querySelector(
              ".search-bar__results"
            )),
            (this.closeButtonElement = this.element.querySelector(
              ".search-bar__close-button"
            )),
            (this.productTypeFilter = ""),
            (this.isSearchOpen = !1),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "destroy",
              value: function () {
                this.delegateElement.off();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "click",
                  '[data-action="clear-input"]',
                  this._clearInput.bind(this)
                ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="unfix-search"]',
                    this._unfixMobileSearch.bind(this)
                  ),
                  this.delegateElement.on(
                    "focusin",
                    '[name="q"]',
                    this._onInputFocus.bind(this)
                  ),
                  document.addEventListener(
                    "click",
                    this._onFocusOut.bind(this)
                  ),
                  this.delegateElement.on(
                    "keydown",
                    '[name="q"]',
                    this._handleTab.bind(this)
                  ),
                  this.delegateElement.on(
                    "input",
                    '[name="q"]',
                    this._debounce(this._doSearch.bind(this), 250)
                  ),
                  this.delegateElement.on(
                    "change",
                    "#search-product-type",
                    this._productTypeChanged.bind(this)
                  ),
                  this.delegateElement.on(
                    "submit",
                    this._onFormSubmit.bind(this)
                  );
              },
            },
            {
              key: "toggleMobileSearch",
              value: function () {
                if (this.isSearchOpen) {
                  this.headerElement.classList.remove("header--search-expanded");
                  this.element.classList.remove("is-visible");
                } else {
                  this.headerElement.classList.add("header--search-expanded");
                  this.element.classList.add("is-visible");
                  const searchInput = this.element.querySelector(".search-bar__input");
                  if (searchInput) {
                    searchInput.focus();
                  }
                }
                this.isSearchOpen = !this.isSearchOpen;
              },
            },
            {
              key: "_unfixMobileSearch",
              value: function () {
                this.element.classList.remove("is-fixed"),
                  (this.closeButtonElement.style.width = ""),
                  this.searchBarElement.classList.remove("is-expanded"),
                  this.searchResultsElement.setAttribute("aria-hidden", "true"),
                  this.inputElement.classList.remove("is-filled"),
                  document.body.classList.remove("no-mobile-scroll"),
                  this.searchMenuElement &&
                    this.searchMenuElement.setAttribute("aria-hidden", "true");
              },
            },
            {
              key: "_clearInput",
              value: function () {
                (this.inputElement.value = ""),
                  this.inputElement.classList.remove("is-filled"),
                  this.searchResultsElement.setAttribute("aria-hidden", "true"),
                  this.searchMenuElement &&
                    this.searchMenuElement.setAttribute("aria-hidden", "false");
              },
            },
            {
              key: "_onInputFocus",
              value: function () {
                this.element.classList.add("is-fixed"),
                  (this.closeButtonElement.style.width = "".concat(
                    this.closeButtonElement.firstElementChild.offsetWidth,
                    "px"
                  )),
                  document.body.classList.add("no-mobile-scroll"),
                  "" === this.inputElement.value
                    ? (this.searchMenuElement &&
                        this.searchMenuElement.setAttribute(
                          "aria-hidden",
                          "false"
                        ),
                      this.searchResultsElement.setAttribute(
                        "aria-hidden",
                        "true"
                      ))
                    : (this.searchMenuElement &&
                        this.searchMenuElement.setAttribute(
                          "aria-hidden",
                          "true"
                        ),
                      this.searchResultsElement.setAttribute(
                        "aria-hidden",
                        "false"
                      ),
                      this.inputElement.classList.add("is-filled"),
                      this.searchBarElement.classList.add("is-expanded")),
                  this.searchMenuElement &&
                    this.searchBarElement.classList.add("is-expanded");
              },
            },
            {
              key: "_onFocusOut",
              value: function (e) {
                var t = this;
                k.matchesBreakpoint("phone") ||
                  k.matchesBreakpoint("phone") ||
                  e.target.classList.contains("search-bar__input") ||
                  e.target.closest(".search-bar__inner") ||
                  setTimeout(function () {
                    t.element.classList.remove("is-fixed"),
                      document.body.classList.remove("no-mobile-scroll"),
                      t.element.contains(e.relatedTarget) ||
                        (t.searchMenuElement &&
                          t.searchMenuElement.setAttribute(
                            "aria-hidden",
                            "true"
                          ),
                        t.searchResultsElement.setAttribute(
                          "aria-hidden",
                          "true"
                        ),
                        t.searchBarElement.classList.remove("is-expanded"));
                  }, 150);
              },
            },
            {
              key: "_handleTab",
              value: function (e) {
                var t;
                "Tab" !== e.key ||
                  ((t = this.searchResultsElement.querySelector("a")) &&
                    (t.focus(), e.preventDefault()));
              },
            },
            {
              key: "_doSearch",
              value: function () {
                var e,
                  t,
                  i = this,
                  n = this.inputElement.value;
                "" === (this.lastInputValue = n)
                  ? (this.searchMenuElement
                      ? this.searchMenuElement.setAttribute(
                          "aria-hidden",
                          "false"
                        )
                      : this.searchBarElement.classList.remove("is-expanded"),
                    this.searchResultsElement.setAttribute(
                      "aria-hidden",
                      "true"
                    ))
                  : (this.searchMenuElement &&
                      this.searchMenuElement.setAttribute(
                        "aria-hidden",
                        "true"
                      ),
                    this.searchResultsElement.setAttribute(
                      "aria-hidden",
                      "false"
                    ),
                    this.searchBarElement.classList.add(
                      "is-expanded",
                      "is-loading"
                    ),
                    (e = ""
                      .concat(window.Shopify.routes.root, "search")
                      .concat(this._supportsPredictiveApi() ? "/suggest" : "")),
                    (t = ""
                      .concat(
                        "" !== this.productTypeFilter
                          ? "product_type:".concat(
                              this.productTypeFilter,
                              " AND "
                            )
                          : ""
                      )
                      .concat(encodeURIComponent(this.lastInputValue))),
                    (t = [
                      fetch(
                        ""
                          .concat(e, "?section_id=predictive-search&q=")
                          .concat(
                            t,
                            "&resources[limit]=3&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor"
                          ),
                        { method: "GET", credentials: "same-origin" }
                      ),
                    ]),
                    Promise.all(t).then(function (e) {
                      i.lastInputValue === n &&
                        Promise.all(
                          e.map(function (e) {
                            return e.text().then(function (e) {
                              var t = document.createElement("div");
                              return (
                                (t.innerHTML = e),
                                t.querySelector(".search-ajax").innerHTML
                              );
                            });
                          })
                        ).then(function (e) {
                          i.searchBarElement.classList.remove("is-loading");
                          var t = document.createElement("div");
                          t.innerHTML = e.join("").trim();
                          e = t.querySelector(".search-bar__view-all");
                          e && t.insertAdjacentElement("beforeend", e),
                            (i.searchBarElement.querySelector(
                              ".search-bar__results-inner"
                            ).innerHTML = t.innerHTML);
                        });
                    }));
              },
            },
            {
              key: "_supportsPredictiveApi",
              value: function () {
                return JSON.parse(
                  document.getElementById("shopify-features").innerHTML
                ).predictiveSearch;
              },
            },
            {
              key: "_productTypeChanged",
              value: function (e, t) {
                (t
                  .closest(".search-bar__filter")
                  .querySelector(".search-bar__filter-active").innerText =
                  t.options[t.selectedIndex].innerText),
                  (this.productTypeFilter = t.value),
                  "" !== this.inputElement.value && this._doSearch();
              },
            },
            {
              key: "_onFormSubmit",
              value: function (e) {
                var t = this.inputElement.cloneNode();
                t.setAttribute("type", "hidden"),
                  (t.value = "") !== this.productTypeFilter &&
                    ((t.value += "product_type:".concat(
                      this.productTypeFilter
                    )),
                    "" !== this.inputElement.value && (t.value += " AND ")),
                  (t.value += this.inputElement.value),
                  this.inputElement.removeAttribute("name"),
                  this.inputElement.insertAdjacentElement("afterend", t);
              },
            },
            {
              key: "_debounce",
              value: function (n, o) {
                var s = this,
                  a = null;
                return function () {
                  for (
                    var e = arguments.length, t = new Array(e), i = 0;
                    i < e;
                    i++
                  )
                    t[i] = arguments[i];
                  clearTimeout(a),
                    (a = setTimeout(function () {
                      n.apply(s, t);
                    }, o));
                };
              },
            },
          ]),
          t
        );
      })(),
      Be = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            (this.searchBar = new qe(
              this.element.querySelector(".header__search-bar-wrapper")
            )),
            (this.cart = new T(
              this.element.querySelector(".header__action-item--cart"),
              { useStickyHeader: this.options.useStickyHeader }
            ));
          e = this.element.querySelector(
            "inline" === this.options.navigationLayout
              ? ".nav-bar"
              : ".header__desktop-nav"
          );
          e &&
            (this.desktopNavigation = new i(
              e,
              this.options.navigationLayout,
              this.options.desktopOpenTrigger
            ));
          e = this.element.querySelector(".header__mobile-nav");
          e && (this.mobileNavigation = new I(e)),
            this._setupCssVariables(),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "onUnload",
              value: function () {
                this.searchBar.destroy(),
                  this.cart.destroy(),
                  this.desktopNavigation && this.desktopNavigation.destroy(),
                  this.mobileNavigation && this.mobileNavigation.destroy(),
                  window.removeEventListener(
                    "resize",
                    this._setupCssVariablesListener
                  );
              },
            },
            {
              key: "onBlockSelect",
              value: function (e) {
                this.desktopNavigation &&
                  this.desktopNavigation.onBlockSelect(e);
              },
            },
            {
              key: "onBlockDeselect",
              value: function (e) {
                this.desktopNavigation &&
                  this.desktopNavigation.onBlockDeselect(e);
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._setupCssVariablesListener =
                  this._setupCssVariables.bind(this)),
                  window.addEventListener(
                    "resize",
                    this._setupCssVariablesListener
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-search"]',
                    this._toggleMobileSearch.bind(this)
                  );
              },
            },
            {
              key: "_setupCssVariables",
              value: function () {
                document.documentElement.style.setProperty(
                  "--header-height",
                  this.element.parentNode.clientHeight + "px"
                );
              },
            },
            {
              key: "_toggleMobileSearch",
              value: function (e) {
                this.searchBar.toggleMobileSearch(), e.preventDefault();
              },
            },
          ]),
          t
        );
      })(),
      Re = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.domDelegate = new _(this.element)),
            (this.customerLoginForm =
              this.element.querySelector("#customer_login")),
            (this.recoverPasswordForm = this.element.querySelector(
              "#recover_customer_password"
            )),
            this.domDelegate.on(
              "click",
              '[data-action="toggle-login-form"]',
              this._showRecoverPassword.bind(this)
            );
        }
        return (
          r(t, [
            {
              key: "_showRecoverPassword",
              value: function () {
                "block" === this.customerLoginForm.style.display
                  ? ((this.customerLoginForm.style.display = "none"),
                    (this.recoverPasswordForm.style.display = "block"))
                  : ((this.customerLoginForm.style.display = "block"),
                    (this.recoverPasswordForm.style.display = "none"));
              },
            },
          ]),
          t
        );
      })(),
      He = (function () {
        function i(e) {
          var t = this;
          a(this, i),
            e.querySelectorAll("[data-popup-type]").forEach(function (e) {
              "exit" === e.getAttribute("data-popup-type")
                ? (t.exitPopup = new C(e))
                : "newsletter" === e.getAttribute("data-popup-type") &&
                  (t.newsletterPopup = new P(e));
            });
        }
        return (
          r(i, [
            {
              key: "onUnload",
              value: function () {
                this.exitPopup && this.exitPopup.destroy(),
                  this.newsletterPopup && this.newsletterPopup.destroy();
              },
            },
            {
              key: "onBlockSelect",
              value: function (e) {
                "exit" === e.target.getAttribute("data-popup-type") &&
                this.exitPopup
                  ? this.exitPopup._openPopup()
                  : "newsletter" === e.target.getAttribute("data-popup-type") &&
                    this.newsletterPopup &&
                    this.newsletterPopup._openPopup();
              },
            },
            {
              key: "onBlockDeselect",
              value: function () {
                this.exitPopup && this.exitPopup._closePopup(),
                  this.newsletterPopup && this.newsletterPopup._closePopup();
              },
            },
          ]),
          i
        );
      })(),
      Ne = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            this.options.useRecommendations
              ? this._loadRecommendations().then(
                  this._createSlideshow.bind(this)
                )
              : this._createSlideshow(),
            (this.productItemColorSwatch = new q(this.element)),
            this._fixSafari(),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "onUnload",
              value: function () {
                this.options.stackable || this.flickityInstance.destroy(),
                  window.removeEventListener("resize", this._fixSafariListener),
                  this.delegateElement.off("change"),
                  this.productItemColorSwatch.destroy(),
                  this.resizeObserver && this.resizeObserver.disconnect();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                (this._fixSafariListener = this._fixSafari.bind(this)),
                  window.addEventListener("resize", this._fixSafariListener),
                  this.delegateElement.on(
                    "click",
                    '[data-action="add-to-cart"]',
                    this._addToCart.bind(this)
                  ),
                  this.delegateElement.on(
                    "click",
                    '[data-secondary-action="open-quick-view"]',
                    this._openQuickView.bind(this)
                  );
              },
            },
            {
              key: "_fixSafari",
              value: function () {
                var t,
                  e = window.navigator.userAgent.toLowerCase();
                e.includes("safari") &&
                  (e.includes("version/10.1") ||
                    e.includes("version/10.3") ||
                    e.includes("version/11.0")) &&
                  ((t = k.matchesBreakpoint("phone")),
                  this.element
                    .querySelectorAll(
                      ".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg"
                    )
                    .forEach(function (e) {
                      e.parentNode.style.height = t
                        ? null
                        : "".concat(e.clientHeight, "px");
                    }));
              },
            },
            {
              key: "_loadRecommendations",
              value: function () {
                var i = this,
                  e = ""
                    .concat(
                      window.routes.productRecommendationsUrl,
                      "?section_id="
                    )
                    .concat(
                      this.element.getAttribute("data-section-id"),
                      "&product_id="
                    )
                    .concat(this.options.productId, "&limit=")
                    .concat(this.options.recommendationsCount);
                return fetch(e).then(function (e) {
                  return e.text().then(function (e) {
                    var t = document.createElement("div");
                    (t.innerHTML = e),
                      (i.element.querySelector(
                        ".product-recommendations"
                      ).innerHTML = t.querySelector(
                        ".product-recommendations"
                      ).innerHTML),
                      i.productItemColorSwatch.recalculateSwatches();
                  });
                });
              },
            },
            {
              key: "_createSlideshow",
              value: function () {
                var e,
                  t = this;
                this.options.stackable ||
                  ((this.flickityInstance = new K(
                    this.element.querySelector(".product-list"),
                    {
                      watchCSS: !0,
                      pageDots: !1,
                      prevNextButtons: !0,
                      contain: !0,
                      resize: !1,
                      groupCells: !0,
                      cellAlign: "left",
                      draggable: !window.matchMedia(
                        "(-moz-touch-enabled: 0), (hover: hover)"
                      ).matches,
                    }
                  )),
                  (e = window.innerWidth),
                  window.addEventListener("resize", function () {
                    window.innerWidth !== e &&
                      (t.flickityInstance.resize(), (e = window.innerWidth));
                  })),
                  window.ResizeObserver &&
                    this.flickityInstance &&
                    ((this.resizeObserver = new ResizeObserver(function () {
                      t.flickityInstance.resize();
                    })),
                    this.element
                      .querySelectorAll(".product-item")
                      .forEach(function (e) {
                        t.resizeObserver.observe(e);
                      }));
              },
            },
            {
              key: "_openQuickView",
              value: function (e, t) {
                var i = new URL(
                  ""
                    .concat(window.location.origin)
                    .concat(t.getAttribute("data-product-url"))
                );
                if (
                  k.matchesBreakpoint("phone") ||
                  k.matchesBreakpoint("tablet")
                )
                  return (window.location.href = i.href), !1;
                var n = document.getElementById(
                  t.getAttribute("aria-controls")
                );
                n.classList.add("is-loading"),
                  i.searchParams.set("view", "quick-view"),
                  fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET",
                  }).then(function (e) {
                    e.text().then(function (e) {
                      (n.querySelector(".modal__inner").innerHTML = e),
                        n.classList.remove("is-loading");
                      var t = new Ie(
                          n.querySelector('[data-section-type="product"]')
                        ),
                        e = function e() {
                          t.onUnload(),
                            n.removeEventListener("modal:closed", e);
                        };
                      n.addEventListener("modal:closed", e);
                    });
                  });
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i,
                  n = this;
                "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  t.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  (i = t.closest('form[action*="/cart/add"]')),
                  fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(R.serialize(i)),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function (e) {
                    t.removeAttribute("disabled"),
                      e.ok
                        ? n.element.dispatchEvent(
                            new CustomEvent("product:added", {
                              bubbles: !0,
                              detail: {
                                button: t,
                                variant: null,
                                quantity: parseInt(
                                  i.querySelector('[name="quantity"]').value
                                ),
                              },
                            })
                          )
                        : document.dispatchEvent(
                            new CustomEvent("theme:loading:end")
                          );
                  }),
                  e.preventDefault());
              },
            },
          ]),
          t
        );
      })(),
      Fe = (function () {
        function t(e) {
          a(this, t),
            (this.element = e),
            (this.delegateElement = new _(this.element)),
            (this.options = JSON.parse(
              this.element.getAttribute("data-section-settings")
            )),
            (this.productItemColorSwatch = new q(this.element)),
            this._fetchProducts(),
            this._attachListeners();
        }
        return (
          r(t, [
            {
              key: "onUnload",
              value: function () {
                this.flickityInstance && this.flickityInstance.destroy(),
                  this.productItemColorSwatch.destroy(),
                  this.resizeObserver && this.resizeObserver.disconnect();
              },
            },
            {
              key: "_attachListeners",
              value: function () {
                this.delegateElement.on(
                  "click",
                  '[data-action="add-to-cart"]',
                  this._addToCart.bind(this)
                ),
                  this.delegateElement.on(
                    "click",
                    '[data-secondary-action="open-quick-view"]',
                    this._openQuickView.bind(this)
                  );
              },
            },
            {
              key: "_fetchProducts",
              value: function () {
                var n = this,
                  e = this._getSearchQueryString();
                "" !== e &&
                  fetch(
                    ""
                      .concat(window.routes.searchUrl, "?section_id=")
                      .concat(
                        this.element.getAttribute("data-section-id"),
                        "&type=product&q="
                      )
                      .concat(e),
                    { credentials: "same-origin", method: "GET" }
                  ).then(function (e) {
                    e.text().then(function (e) {
                      var t = document.createElement("div");
                      (t.innerHTML = e),
                        (n.element.querySelector(
                          ".recently-viewed-products-placeholder"
                        ).innerHTML = t.querySelector(
                          '[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder'
                        ).innerHTML),
                        (n.element.parentNode.style.display = "block"),
                        n.productItemColorSwatch.recalculateSwatches(),
                        (n.flickityInstance = new K(
                          n.element.querySelector(".product-list"),
                          {
                            watchCSS: !0,
                            pageDots: !1,
                            prevNextButtons: !0,
                            contain: !0,
                            resize: !1,
                            groupCells: !0,
                            cellAlign: "left",
                            draggable: !window.matchMedia(
                              "(-moz-touch-enabled: 0), (hover: hover)"
                            ).matches,
                          }
                        ));
                      var i = window.innerWidth;
                      window.addEventListener("resize", function () {
                        window.innerWidth !== i &&
                          (n.flickityInstance.resize(),
                          (i = window.innerWidth));
                      }),
                        window.ResizeObserver &&
                          n.flickityInstance &&
                          ((n.resizeObserver = new ResizeObserver(function () {
                            n.flickityInstance.resize();
                          })),
                          n.element
                            .querySelectorAll(".product-item")
                            .forEach(function (e) {
                              n.resizeObserver.observe(e);
                            }));
                    });
                  });
              },
            },
            {
              key: "_getSearchQueryString",
              value: function () {
                var e = JSON.parse(
                  localStorage.getItem("recentlyViewedProducts") || "[]"
                );
                return (
                  e.includes(this.options.currentProductId) &&
                    e.splice(e.indexOf(this.options.currentProductId), 1),
                  e
                    .map(function (e) {
                      return "id:" + e;
                    })
                    .join(" OR ")
                );
              },
            },
            {
              key: "_openQuickView",
              value: function (e, t) {
                var i = new URL(
                  ""
                    .concat(window.location.origin)
                    .concat(t.getAttribute("data-product-url"))
                );
                if (
                  k.matchesBreakpoint("phone") ||
                  k.matchesBreakpoint("tablet")
                )
                  return (window.location.href = i.href), !1;
                var n = document.getElementById(
                  t.getAttribute("aria-controls")
                );
                n.classList.add("is-loading"),
                  i.searchParams.set("view", "quick-view"),
                  fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET",
                  }).then(function (e) {
                    e.text().then(function (e) {
                      (n.querySelector(".modal__inner").innerHTML = e),
                        n.classList.remove("is-loading");
                      var t = new Ie(
                          n.querySelector('[data-section-type="product"]')
                        ),
                        e = function e() {
                          t.onUnload(),
                            n.removeEventListener("modal:closed", e);
                        };
                      n.addEventListener("modal:closed", e);
                    });
                  });
              },
            },
            {
              key: "_addToCart",
              value: function (e, t) {
                var i,
                  n = this;
                "page" !== window.theme.cartType &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  t.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  (i = t.closest('form[action*="/cart/add"]')),
                  fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(R.serialize(i)),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                    },
                  }).then(function (e) {
                    t.removeAttribute("disabled"),
                      e.ok
                        ? n.element.dispatchEvent(
                            new CustomEvent("product:added", {
                              bubbles: !0,
                              detail: {
                                button: t,
                                variant: null,
                                quantity: parseInt(
                                  i.querySelector('[name="quantity"]').value
                                ),
                              },
                            })
                          )
                        : document.dispatchEvent(
                            new CustomEvent("theme:loading:end")
                          );
                  }),
                  e.preventDefault());
              },
            },
          ]),
          t
        );
      })(),
      Ue = (function () {
        function e() {
          a(this, e),
            (this.constructors = []),
            (this.instances = []),
            this._attachListeners();
        }
        return (
          r(e, [
            {
              key: "_attachListeners",
              value: function () {
                document.addEventListener(
                  "shopify:section:load",
                  this._onSectionLoad.bind(this)
                ),
                  document.addEventListener(
                    "shopify:section:unload",
                    this._onSectionUnload.bind(this)
                  ),
                  document.addEventListener(
                    "shopify:section:select",
                    this._onSelect.bind(this)
                  ),
                  document.addEventListener(
                    "shopify:section:deselect",
                    this._onDeselect.bind(this)
                  ),
                  document.addEventListener(
                    "shopify:section:reorder",
                    this._onReorder.bind(this)
                  ),
                  document.addEventListener(
                    "shopify:block:select",
                    this._onBlockSelect.bind(this)
                  ),
                  document.addEventListener(
                    "shopify:block:deselect",
                    this._onBlockDeselect.bind(this)
                  );
              },
            },
            {
              key: "register",
              value: function (e, t) {
                var i = this;
                (this.constructors[e] = t),
                  document
                    .querySelectorAll("[data-section-type=".concat(e, "]"))
                    .forEach(function (e) {
                      i._createInstance(e, t);
                    });
              },
            },
            {
              key: "_findInstance",
              value: function (e, t, i) {
                for (var n = 0; n < e.length; n++)
                  if (e[n][t] === i) return e[n];
              },
            },
            {
              key: "_removeInstance",
              value: function (e, t, i) {
                for (var n = e.length; n--; )
                  if (e[n][t] === i) {
                    e.splice(n, 1);
                    break;
                  }
                return e;
              },
            },
            {
              key: "_onSectionLoad",
              value: function (e) {
                e = e.target.querySelector("[data-section-id]");
                e && this._createInstance(e);
              },
            },
            {
              key: "_onSectionUnload",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t &&
                  ("function" == typeof t.onUnload && t.onUnload(e),
                  (this.instances = this._removeInstance(
                    this.instances,
                    "id",
                    e.detail.sectionId
                  )));
              },
            },
            {
              key: "_onSelect",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t && "function" == typeof t.onSelect && t.onSelect(e);
              },
            },
            {
              key: "_onDeselect",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t && "function" == typeof t.onDeselect && t.onDeselect(e);
              },
            },
            {
              key: "_onReorder",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t && "function" == typeof t.onReorder && t.onReorder(e);
              },
            },
            {
              key: "_onBlockSelect",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
              },
            },
            {
              key: "_onBlockDeselect",
              value: function (e) {
                var t = this._findInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                );
                t &&
                  "function" == typeof t.onBlockDeselect &&
                  t.onBlockDeselect(e);
              },
            },
            {
              key: "_createInstance",
              value: function (e, t) {
                var i = e.getAttribute("data-section-id"),
                  n = e.getAttribute("data-section-type");
                void 0 !== (t = t || this.constructors[n]) &&
                  ((e = Object.assign(new t(e), {
                    id: i,
                    type: n,
                    container: e,
                  })),
                  this.instances.push(e));
              },
            },
          ]),
          e
        );
      })(),
      We = (function () {
        function n(e) {
          var t = this;
          a(this, n),
            (this.flickityInstance = new K(
              e.querySelector(".text-with-icons1"),
              {
                pageDots: !0,
                prevNextButtons: !1,
                wrapAround: !0,
                autoPlay: 5e3,
                resize: !1,
                watchCSS: !0,
              }
            ));
          var i = window.innerWidth;
          window.addEventListener("resize", function () {
            window.innerWidth !== i &&
              (t.flickityInstance.resize(), (i = window.innerWidth));
          });
        }
        return (
          r(n, [
            {
              key: "onUnload",
              value: function () {
                this.flickityInstance.destroy();
              },
            },
            {
              key: "onBlockSelect",
              value: function (e) {
                this.flickityInstance.isActive &&
                  (this.flickityInstance.selectCell(
                    parseInt(e.target.getAttribute("data-block-index")),
                    !1,
                    e.detail.load
                  ),
                  this.flickityInstance.pausePlayer());
              },
            },
            {
              key: "onBlockDeselect",
              value: function () {
                this.flickityInstance.isActive &&
                  this.flickityInstance.unpausePlayer();
              },
            },
          ]),
          n
        );
      })(),
      je = t(function (e, t) {
        e.exports = {
          polyfill: function () {
            var e,
              n,
              r,
              l,
              c = window,
              d = document;
            function u(e, t) {
              (this.scrollLeft = e), (this.scrollTop = t);
            }
            function i(e) {
              if (
                null === e ||
                "object" !== wi(e) ||
                void 0 === e.behavior ||
                "auto" === e.behavior ||
                "instant" === e.behavior
              )
                return !0;
              if ("object" === wi(e) && "smooth" === e.behavior) return !1;
              throw new TypeError(
                "behavior member of ScrollOptions " +
                  e.behavior +
                  " is not a valid value for enumeration ScrollBehavior."
              );
            }
            function h(e) {
              var t,
                i = (l() - e.startTime) / n;
              (t = i = 1 < i ? 1 : i),
                (i = 0.5 * (1 - Math.cos(Math.PI * t))),
                (t = e.startX + (e.x - e.startX) * i),
                (i = e.startY + (e.y - e.startY) * i),
                e.method.call(e.scrollable, t, i),
                (t === e.x && i === e.y) ||
                  c.requestAnimationFrame(h.bind(c, e));
            }
            function o(e, t, i) {
              var n,
                o,
                s,
                a = l(),
                e =
                  e === d.body
                    ? ((o = (n = c).scrollX || c.pageXOffset),
                      (s = c.scrollY || c.pageYOffset),
                      r.scroll)
                    : ((o = (n = e).scrollLeft), (s = e.scrollTop), u);
              h({
                scrollable: n,
                method: e,
                startTime: a,
                startX: o,
                startY: s,
                x: t,
                y: i,
              });
            }
            ("scrollBehavior" in d.documentElement.style &&
              !0 !== c.__forceSmoothScrollPolyfill__) ||
              ((e = c.HTMLElement || c.Element),
              (n = 468),
              (r = {
                scroll: c.scroll || c.scrollTo,
                scrollBy: c.scrollBy,
                elementScroll: e.prototype.scroll || u,
              }),
              (l =
                c.performance && c.performance.now
                  ? c.performance.now.bind(c.performance)
                  : Date.now),
              (c.scroll = c.scrollTo =
                function () {
                  void 0 !== arguments[0] &&
                    (!0 !== i(arguments[0])
                      ? o.call(
                          c,
                          d.body,
                          void 0 !== arguments[0].left
                            ? ~~arguments[0].left
                            : c.scrollX || c.pageXOffset,
                          void 0 !== arguments[0].top
                            ? ~~arguments[0].top
                            : c.scrollY || c.pageYOffset
                        )
                      : r.scroll.call(
                          c,
                          void 0 !== arguments[0].left
                            ? arguments[0].left
                            : "object" !== wi(arguments[0])
                            ? arguments[0]
                            : c.scrollX || c.pageXOffset,
                          void 0 !== arguments[0].top
                            ? arguments[0].top
                            : void 0 !== arguments[1]
                            ? arguments[1]
                            : c.scrollY || c.pageYOffset
                        ));
                }),
              (c.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (i(arguments[0])
                    ? r.scrollBy.call(
                        c,
                        void 0 !== arguments[0].left
                          ? arguments[0].left
                          : "object" !== wi(arguments[0])
                          ? arguments[0]
                          : 0,
                        void 0 !== arguments[0].top
                          ? arguments[0].top
                          : void 0 !== arguments[1]
                          ? arguments[1]
                          : 0
                      )
                    : o.call(
                        c,
                        d.body,
                        ~~arguments[0].left + (c.scrollX || c.pageXOffset),
                        ~~arguments[0].top + (c.scrollY || c.pageYOffset)
                      ));
              }),
              (e.prototype.scroll = e.prototype.scrollTo =
                function () {
                  if (void 0 !== arguments[0])
                    if (!0 !== i(arguments[0])) {
                      var e = arguments[0].left,
                        t = arguments[0].top;
                      o.call(
                        this,
                        this,
                        void 0 === e ? this.scrollLeft : ~~e,
                        void 0 === t ? this.scrollTop : ~~t
                      );
                    } else {
                      if (
                        "number" == typeof arguments[0] &&
                        void 0 === arguments[1]
                      )
                        throw new SyntaxError("Value could not be converted");
                      r.elementScroll.call(
                        this,
                        void 0 !== arguments[0].left
                          ? ~~arguments[0].left
                          : "object" !== wi(arguments[0])
                          ? ~~arguments[0]
                          : this.scrollLeft,
                        void 0 !== arguments[0].top
                          ? ~~arguments[0].top
                          : void 0 !== arguments[1]
                          ? ~~arguments[1]
                          : this.scrollTop
                      );
                    }
                }),
              (e.prototype.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (!0 !== i(arguments[0])
                    ? this.scroll({
                        left: ~~arguments[0].left + this.scrollLeft,
                        top: ~~arguments[0].top + this.scrollTop,
                        behavior: arguments[0].behavior,
                      })
                    : r.elementScroll.call(
                        this,
                        void 0 !== arguments[0].left
                          ? ~~arguments[0].left + this.scrollLeft
                          : ~~arguments[0] + this.scrollLeft,
                        void 0 !== arguments[0].top
                          ? ~~arguments[0].top + this.scrollTop
                          : ~~arguments[1] + this.scrollTop
                      ));
              }));
          },
        };
      }),
      Ve = new Set(),
      Xe = document.createElement("link"),
      Qe =
        Xe.relList &&
        Xe.relList.supports &&
        Xe.relList.supports("prefetch") &&
        window.IntersectionObserver &&
        "isIntersecting" in IntersectionObserverEntry.prototype,
      Ye = "instantAllowQueryString" in document.body.dataset,
      Ze = "instantAllowExternalLinks" in document.body.dataset,
      Ge = "instantWhitelist" in document.body.dataset,
      $e = "instantMousedownShortcut" in document.body.dataset,
      Ke = 65,
      Je = !1,
      et = !1,
      pe = !1;
    function tt(e) {
      (e.relatedTarget &&
        e.target.closest("a") == e.relatedTarget.closest("a")) ||
        (we && (clearTimeout(we), (we = void 0)));
    }
    function it(e) {
      return (
        e &&
        e.href &&
        (!Ge || "instant" in e.dataset) &&
        (Ze || e.origin == location.origin || "instant" in e.dataset) &&
        ["http:", "https:"].includes(e.protocol) &&
        ("http:" != e.protocol || "https:" != location.protocol) &&
        (Ye || !e.search || "instant" in e.dataset) &&
        (!e.hash ||
          e.pathname + e.search != location.pathname + location.search) &&
        !("noInstant" in e.dataset)
      );
    }
    function nt(e) {
      var t;
      Ve.has(e) ||
        (((t = document.createElement("link")).rel = "prefetch"),
        (t.href = e),
        document.head.appendChild(t),
        Ve.add(e));
    }
    "instantIntensity" in document.body.dataset &&
      ("mousedown" ==
      (Xe = document.body.dataset.instantIntensity).substr(
        0,
        "mousedown".length
      )
        ? ((Je = !0), "mousedown-only" == Xe && (et = !0))
        : "viewport" == Xe.substr(0, "viewport".length)
        ? (navigator.connection &&
            (navigator.connection.saveData ||
              (navigator.connection.effectiveType &&
                navigator.connection.effectiveType.includes("2g")))) ||
          ("viewport" == Xe
            ? document.documentElement.clientWidth *
                document.documentElement.clientHeight <
                45e4 && (pe = !0)
            : "viewport-all" == Xe && (pe = !0))
        : ((Xe = parseInt(Xe)), isNaN(Xe) || (Ke = Xe))),
      Qe &&
        ((Qe = { capture: !0, passive: !0 }),
        et ||
          document.addEventListener(
            "touchstart",
            function (e) {
              _e = performance.now();
              e = e.target.closest("a");
              if (!it(e)) return;
              nt(e.href);
            },
            Qe
          ),
        Je
          ? $e ||
            document.addEventListener(
              "mousedown",
              function (e) {
                e = e.target.closest("a");
                if (!it(e)) return;
                nt(e.href);
              },
              Qe
            )
          : document.addEventListener(
              "mouseover",
              function (e) {
                if (performance.now() - _e < 1111) return;
                var t = e.target.closest("a");
                if (!it(t)) return;
                t.addEventListener("mouseout", tt, { passive: !0 }),
                  (we = setTimeout(function () {
                    nt(t.href), (we = void 0);
                  }, Ke));
              },
              Qe
            ),
        $e &&
          document.addEventListener(
            "mousedown",
            function (e) {
              if (performance.now() - _e < 1111) return;
              var t = e.target.closest("a");
              if (1 < e.which || e.metaKey || e.ctrlKey) return;
              if (!t) return;
              t.addEventListener(
                "click",
                function (e) {
                  1337 != e.detail && e.preventDefault();
                },
                { capture: !0, passive: !1, once: !0 }
              );
              e = new MouseEvent("click", {
                view: window,
                bubbles: !0,
                cancelable: !1,
                detail: 1337,
              });
              t.dispatchEvent(e);
            },
            Qe
          ),
        pe &&
          (window.requestIdleCallback
            ? function (e) {
                requestIdleCallback(e, { timeout: 1500 });
              }
            : function (e) {
                e();
              })(function () {
            var t = new IntersectionObserver(function (e) {
              e.forEach(function (e) {
                e.isIntersecting &&
                  ((e = e.target), t.unobserve(e), nt(e.href));
              });
            });
            document.querySelectorAll("a").forEach(function (e) {
              it(e) && t.observe(e);
            });
          }));
    pe = (function () {
      o(i, u(HTMLElement));
      var t = p(i);
      function i() {
        var e;
        return (
          a(this, i),
          ((e = t.call(this))._isLoaded = !1),
          (e.delegateElement = new _(h(e))),
          e.delegateElement.on(
            "click",
            '[data-action="add-to-cart"]',
            e._addToCart.bind(h(e))
          ),
          e
        );
      }
      return (
        r(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._loadRecommendations();
            },
          },
          {
            key: "_loadRecommendations",
            value: function () {
              var t,
                i,
                e,
                n = this;
              this._isLoaded ||
                ((this._isLoaded = !0),
                (t = this.closest(".shopify-section")),
                (i = this.getAttribute("intent") || "related"),
                (e = ""
                  .concat(
                    Shopify.routes.root,
                    "recommendations/products?product_id="
                  )
                  .concat(this.getAttribute("product"), "&limit=")
                  .concat(this.getAttribute("limit") || 4, "&section_id=")
                  .concat(this.getAttribute("section-id"), "&intent=")
                  .concat(i)),
                fetch(e).then(function (e) {
                  e.text().then(function (e) {
                    e = new DOMParser()
                      .parseFromString(e, "text/html")
                      .querySelector("product-recommendations");
                    0 < e.childElementCount
                      ? (n.replaceChildren.apply(
                          n,
                          m(document.importNode(e, !0).childNodes)
                        ),
                        (n.flickityInstance = new J(
                          n.querySelector(".complementary-product-list"),
                          {
                            pageDots: !1,
                            watchCSS: !0,
                            groupCells: 2,
                            cellAlign: "left",
                            prevNextButtons: !0,
                            wrapAround: !0,
                            dragThreshold: 12,
                            percentPosition: !0,
                            resize: !1,
                            draggable: ">1",
                          }
                        )))
                      : ("related" === i ? t : n).remove();
                  });
                }));
            },
          },
          {
            key: "_addToCart",
            value: function (e, t) {
              var i,
                n = this;
              "page" !== window.theme.cartType &&
                (e.preventDefault(),
                e.stopPropagation(),
                t.setAttribute("disabled", "disabled"),
                document.dispatchEvent(new CustomEvent("theme:loading:start")),
                (i = t.closest('form[action*="/cart/add"]')),
                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                  body: JSON.stringify(R.serialize(i)),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (e) {
                  t.removeAttribute("disabled"),
                    e.ok
                      ? n.dispatchEvent(
                          new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                              button: t,
                              variant: null,
                              quantity: parseInt(
                                i.querySelector('[name="quantity"]').value
                              ),
                            },
                          })
                        )
                      : document.dispatchEvent(
                          new CustomEvent("theme:loading:end")
                        );
                }),
                e.preventDefault());
            },
          },
        ]),
        i
      );
    })();
    function st() {
      window.NodeList &&
        !NodeList.prototype.forEach &&
        (NodeList.prototype.forEach = function (e, t) {
          t = t || window;
          for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this);
        }),
        je.polyfill(),
        new E(),
        new L(),
        new M(),
        new O();
      var i,
        n,
        o,
        e = new Ue();
      e.register("account", Ce),
        e.register("announcement-bar", Le),
        e.register("blog", Ae),
        e.register("blog-sidebar", Te),
        e.register("blog-post", ye),
        e.register("cart", Me),
        e.register("collection-list", Pe),
        e.register("collection", De),
        e.register("featured-collection", ze),
        e.register("footer", Oe),
        e.register("header", Be),
        e.register("login", Re),
        e.register("popups", He),
        e.register("product-recommendations", Ne),
        e.register("product", Ie),
        e.register("quick-links", be),
        e.register("recently-viewed-products", Fe),
        e.register("text-with-icons1", We),
        document.querySelectorAll(".rte table").forEach(function (e) {
          e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
        }),
        document.querySelectorAll(".rte iframe").forEach(function (e) {
          (-1 === e.src.indexOf("youtube") &&
            -1 === e.src.indexOf("youtu.be") &&
            -1 === e.src.indexOf("vimeo")) ||
            ((e.outerHTML =
              '<div class="video-wrapper">' + e.outerHTML + "</div>"),
            (e.src = e.src));
        }),
        (n = !1),
        document.body.addEventListener("touchstart", function (e) {
          var t = e.target.closest(".flickity-slider");
          t && K.data(t.closest(".flickity-enabled")).isDraggable
            ? ((n = !0), (i = { x: e.touches[0].pageX, y: e.touches[0].pageY }))
            : (n = !1);
        }),
        document.body.addEventListener(
          "touchmove",
          function (e) {
            var t;
            n &&
              e.cancelable &&
              ((t = {
                x: e.touches[0].pageX - i.x,
                y: e.touches[0].pageY - i.y,
              }),
              8 < Math.abs(t.x) && e.preventDefault());
          },
          { passive: !1 }
        ),
        (function () {
          if ("phone" === k.getCurrentBreakpoint())
            for (
              var e = document.querySelectorAll("input[autofocus]"), t = 0;
              t < e.length;
              t++
            )
              e[t].blur(), e[t].removeAttribute("autofocus");
        })(),
        new _(document.body).on(
          "click",
          '[href^="#"], [data-href]',
          function (e, t) {
            var i = t.hasAttribute("href")
              ? t.getAttribute("href")
              : t.getAttribute("data-href");
            if ("#" !== i && "#main" !== i) {
              var n = null;
              try {
                n = document.querySelector(i);
              } catch (e) {
                return;
              }
              for (
                var t = parseInt(t.getAttribute("data-offset") || 0), o = 0;
                "BODY" !== n.offsetParent.tagName;

              )
                (o += n.offsetTop), (n = n.offsetParent);
              (o += n.offsetTop),
                window.scrollTo({ behavior: "smooth", top: o - t }),
                e.preventDefault();
            }
          }
        ),
        window.addEventListener("keydown", function e(t) {
          "Tab" === t.key &&
            (document.body.classList.add("is-tabbing"),
            window.removeEventListener("keydown", e));
        }),
        (e = new _(document.body)).on(
          "keyup",
          "input, textarea",
          function (e, t) {
            t.classList.toggle("is-filled", "" !== t.value);
          }
        ),
        e.on("change", "select", function (e, t) {
          t.parentNode.classList.toggle("is-filled", "" !== t.value);
        }),
        (o = document.links),
        D.mutate(function () {
          for (var e = 0, t = o.length; e < t; e++)
            o[e].hostname, window.location.hostname;
        });
    }
    window.customElements.get("product-recommendations") ||
      window.customElements.define("product-recommendations", pe),
      "fetch" in window && "assign" in Object
        ? st()
        : (((pe = document.createElement("script")).src =
            "//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList"),
          (pe.async = !1),
          (pe.onload = function () {
            st();
          }),
          document.head.appendChild(pe));
  });

